// AUTO-GENERATED by tools/gen-weapon-defs.mjs from research/data/weapons_mp.json — DO NOT EDIT.
// Raw MP WEAPONFILE fields (all categories flattened). Times are SECONDS as in the weapon file;
// shared/weapons/defs.ts converts to the engine's integer milliseconds.
// Source: {"what":"Black Ops II MP weapon definitions used by Sticks and Stones, dumped by OAT v0.33.0 from the user's MP fastfiles. Every WEAPONFILE field is kept, typed, and grouped; asset references are reso
/* eslint-disable */
export type WeaponFileValue = number | string;
export type WeaponFileRaw = Readonly<Record<string, WeaponFileValue>>;
export const WEAPON_FILES: Readonly<Record<string, WeaponFileRaw>> = {
 "crossbow_mp": {
  "displayName": "WEAPON_CROSSBOW_EXPLOSIVE",
  "AIOverlayDescription": "",
  "modeName": "",
  "playerAnimType": "crossbow",
  "weaponType": "projectile",
  "weaponClass": "rifle",
  "penetrateType": "none",
  "impactType": "bolt",
  "inventoryType": "primary",
  "fireType": "Single Shot",
  "clipType": "bottom",
  "barrelType": "Single",
  "offhandClass": "None",
  "offhandSlot": "None",
  "fireTypeIcon": "hud_mp_firerate_bolt",
  "hudIcon": "menu_mp_weapons_crossbow",
  "hudIconRatio": "2:1",
  "indicatorIcon": "",
  "indicatorIconRatio": "1:1",
  "ammoCounterIcon": "menu_mp_weapons_crossbow",
  "ammoCounterIconRatio": "1:1",
  "noPing": 1,
  "killIcon": "menu_mp_weapons_crossbow",
  "killIconRatio": "1:1",
  "flipKillIcon": 1,
  "dpadIcon": "",
  "dpadIconRatio": "1:1",
  "noAmmoOnDpadIcon": 1,
  "altWeapon": "",
  "grenadeWeapon": "explosive_bolt_mp",
  "dropAmmoMin": 1,
  "dropAmmoMax": 2,
  "stance": "stand",
  "fireRumble": "pistol_fire",
  "meleeImpactRumble": "",
  "reloadRumble": "",
  "explosionRumble": "",
  "parentWeaponName": "crossbow",
  "camo": "camo_crossbow",
  "gunModel": "t6_wpn_crossbow_view",
  "gunModel2": "",
  "gunModel3": "",
  "gunModel4": "",
  "gunModel5": "",
  "gunModel6": "",
  "gunModel7": "",
  "gunModel8": "",
  "gunModel9": "",
  "gunModel10": "",
  "gunModel11": "",
  "gunModel12": "",
  "gunModel13": "",
  "gunModel14": "",
  "gunModel15": "",
  "gunModel16": "",
  "handModel": "",
  "worldModel": "t6_wpn_crossbow_world",
  "worldModel2": "t6_wpn_crossbow_stow",
  "worldModel3": "",
  "worldModel4": "",
  "worldModel5": "",
  "worldModel6": "",
  "worldModel7": "",
  "worldModel8": "",
  "worldModel9": "",
  "worldModel10": "",
  "worldModel11": "",
  "worldModel12": "",
  "worldModel13": "",
  "worldModel14": "",
  "worldModel15": "",
  "worldModel16": "",
  "attachViewModel1": "",
  "attachViewModel2": "",
  "attachViewModel3": "",
  "attachViewModel4": "",
  "attachViewModel5": "",
  "attachViewModel6": "",
  "attachViewModel7": "",
  "attachViewModel8": "",
  "attachWorldModel1": "",
  "attachWorldModel2": "",
  "attachWorldModel3": "",
  "attachWorldModel4": "",
  "attachWorldModel5": "",
  "attachWorldModel6": "",
  "attachWorldModel7": "",
  "attachWorldModel8": "",
  "attachViewModelTag1": "",
  "attachViewModelTag2": "",
  "attachViewModelTag3": "",
  "attachViewModelTag4": "",
  "attachViewModelTag5": "",
  "attachViewModelTag6": "",
  "attachViewModelTag7": "",
  "attachViewModelTag8": "",
  "attachWorldModelTag1": "",
  "attachWorldModelTag2": "",
  "attachWorldModelTag3": "",
  "attachWorldModelTag4": "",
  "attachWorldModelTag5": "",
  "attachWorldModelTag6": "",
  "attachWorldModelTag7": "",
  "attachWorldModelTag8": "",
  "attachViewModelOffsetX1": 0,
  "attachViewModelOffsetY1": 0,
  "attachViewModelOffsetZ1": 0,
  "attachViewModelOffsetX2": 0,
  "attachViewModelOffsetY2": 0,
  "attachViewModelOffsetZ2": 0,
  "attachViewModelOffsetX3": 0,
  "attachViewModelOffsetY3": 0,
  "attachViewModelOffsetZ3": 0,
  "attachViewModelOffsetX4": 0,
  "attachViewModelOffsetY4": 0,
  "attachViewModelOffsetZ4": 0,
  "attachViewModelOffsetX5": 0,
  "attachViewModelOffsetY5": 0,
  "attachViewModelOffsetZ5": 0,
  "attachViewModelOffsetX6": 0,
  "attachViewModelOffsetY6": 0,
  "attachViewModelOffsetZ6": 0,
  "attachViewModelOffsetX7": 0,
  "attachViewModelOffsetY7": 0,
  "attachViewModelOffsetZ7": 0,
  "attachViewModelOffsetX8": 0,
  "attachViewModelOffsetY8": 0,
  "attachViewModelOffsetZ8": 0,
  "attachWorldModelOffsetX1": 0,
  "attachWorldModelOffsetY1": 0,
  "attachWorldModelOffsetZ1": 0,
  "attachWorldModelOffsetX2": 0,
  "attachWorldModelOffsetY2": 0,
  "attachWorldModelOffsetZ2": 0,
  "attachWorldModelOffsetX3": 0,
  "attachWorldModelOffsetY3": 0,
  "attachWorldModelOffsetZ3": 0,
  "attachWorldModelOffsetX4": 0,
  "attachWorldModelOffsetY4": 0,
  "attachWorldModelOffsetZ4": 0,
  "attachWorldModelOffsetX5": 0,
  "attachWorldModelOffsetY5": 0,
  "attachWorldModelOffsetZ5": 0,
  "attachWorldModelOffsetX6": 0,
  "attachWorldModelOffsetY6": 0,
  "attachWorldModelOffsetZ6": 0,
  "attachWorldModelOffsetX7": 0,
  "attachWorldModelOffsetY7": 0,
  "attachWorldModelOffsetZ7": 0,
  "attachWorldModelOffsetX8": 0,
  "attachWorldModelOffsetY8": 0,
  "attachWorldModelOffsetZ8": 0,
  "attachViewModelOffsetPitch1": 0,
  "attachViewModelOffsetYaw1": 0,
  "attachViewModelOffsetRoll1": 0,
  "attachViewModelOffsetPitch2": 0,
  "attachViewModelOffsetYaw2": 0,
  "attachViewModelOffsetRoll2": 0,
  "attachViewModelOffsetPitch3": 0,
  "attachViewModelOffsetYaw3": 0,
  "attachViewModelOffsetRoll3": 0,
  "attachViewModelOffsetPitch4": 0,
  "attachViewModelOffsetYaw4": 0,
  "attachViewModelOffsetRoll4": 0,
  "attachViewModelOffsetPitch5": 0,
  "attachViewModelOffsetYaw5": 0,
  "attachViewModelOffsetRoll5": 0,
  "attachViewModelOffsetPitch6": 0,
  "attachViewModelOffsetYaw6": 0,
  "attachViewModelOffsetRoll6": 0,
  "attachViewModelOffsetPitch7": 0,
  "attachViewModelOffsetYaw7": 0,
  "attachViewModelOffsetRoll7": 0,
  "attachViewModelOffsetPitch8": 0,
  "attachViewModelOffsetYaw8": 0,
  "attachViewModelOffsetRoll8": 0,
  "attachWorldModelOffsetPitch1": 0,
  "attachWorldModelOffsetYaw1": 0,
  "attachWorldModelOffsetRoll1": 0,
  "attachWorldModelOffsetPitch2": 0,
  "attachWorldModelOffsetYaw2": 0,
  "attachWorldModelOffsetRoll2": 0,
  "attachWorldModelOffsetPitch3": 0,
  "attachWorldModelOffsetYaw3": 0,
  "attachWorldModelOffsetRoll3": 0,
  "attachWorldModelOffsetPitch4": 0,
  "attachWorldModelOffsetYaw4": 0,
  "attachWorldModelOffsetRoll4": 0,
  "attachWorldModelOffsetPitch5": 0,
  "attachWorldModelOffsetYaw5": 0,
  "attachWorldModelOffsetRoll5": 0,
  "attachWorldModelOffsetPitch6": 0,
  "attachWorldModelOffsetYaw6": 0,
  "attachWorldModelOffsetRoll6": 0,
  "attachWorldModelOffsetPitch7": 0,
  "attachWorldModelOffsetYaw7": 0,
  "attachWorldModelOffsetRoll7": 0,
  "attachWorldModelOffsetPitch8": 0,
  "attachWorldModelOffsetYaw8": 0,
  "attachWorldModelOffsetRoll8": 0,
  "stowedModelOffsetsF": 0,
  "stowedModelOffsetsR": 0,
  "stowedModelOffsetsU": 0,
  "stowedModelOffsetsPitch": 0,
  "stowedModelOffsetsYaw": 0,
  "stowedModelOffsetsRoll": 0,
  "worldClipModel": "",
  "rocketModel": "",
  "AdditionalMeleeModel": "",
  "useDroppedModelAsStowed": 1,
  "projectileModel": "t5_weapon_crossbow_bolt_exp",
  "notetrackSoundMap": "",
  "idleAnim": "viewmodel_crossbow_t6_idle",
  "idleAnimLeft": "",
  "emptyIdleAnim": "viewmodel_crossbow_t6_idle_empty",
  "emptyIdleAnimLeft": "",
  "fireIntroAnim": "",
  "fireAnim": "viewmodel_crossbow_t6_fire",
  "fireAnimLeft": "",
  "holdFireAnim": "",
  "lastShotAnim": "viewmodel_crossbow_t6_last_shot",
  "lastShotAnimLeft": "",
  "flourishAnim": "",
  "flourishAnimLeft": "",
  "detonateAnim": "",
  "rechamberAnim": "",
  "meleeAnim": "",
  "meleeAnimEmpty": "",
  "meleeAnim1": "",
  "meleeAnim2": "",
  "meleeAnim3": "",
  "meleeChargeAnim": "",
  "meleeChargeAnimEmpty": "",
  "reloadAnim": "viewmodel_crossbow_t6_reload_empty",
  "reloadAnimRight": "",
  "reloadAnimLeft": "",
  "reloadEmptyAnim": "",
  "reloadEmptyAnimLeft": "",
  "reloadStartAnim": "",
  "reloadEndAnim": "",
  "reloadQuickAnim": "",
  "reloadQuickEmptyAnim": "",
  "raiseAnim": "viewmodel_crossbow_t6_pullout",
  "dropAnim": "viewmodel_crossbow_t6_putaway",
  "firstRaiseAnim": "viewmodel_crossbow_t6_first_raise",
  "altRaiseAnim": "viewmodel_crossbow_t6_pullout",
  "altDropAnim": "viewmodel_crossbow_t6_putaway",
  "quickRaiseAnim": "viewmodel_crossbow_t6_pullout_quick",
  "quickDropAnim": "viewmodel_crossbow_t6_putaway_quick",
  "emptyRaiseAnim": "viewmodel_crossbow_t6_pullout_empty",
  "emptyDropAnim": "viewmodel_crossbow_t6_putaway_empty",
  "sprintInAnim": "viewmodel_crossbow_t6_sprint_in",
  "sprintLoopAnim": "viewmodel_crossbow_t6_sprint_loop",
  "sprintOutAnim": "viewmodel_crossbow_t6_sprint_out",
  "sprintInEmptyAnim": "viewmodel_crossbow_t6_sprint_in_empty",
  "sprintLoopEmptyAnim": "viewmodel_crossbow_t6_sprint_loop_empty",
  "sprintOutEmptyAnim": "viewmodel_crossbow_t6_sprint_out_empty",
  "lowReadyInAnim": "",
  "lowReadyLoopAnim": "",
  "lowReadyOutAnim": "",
  "contFireInAnim": "",
  "contFireLoopAnim": "",
  "contFireOutAnim": "",
  "crawlInAnim": "viewmodel_crossbow_t6_crawl_in",
  "crawlForwardAnim": "viewmodel_crossbow_t6_crawl_forward",
  "crawlBackAnim": "viewmodel_crossbow_t6_crawl_back",
  "crawlRightAnim": "viewmodel_crossbow_t6_crawl_right",
  "crawlLeftAnim": "viewmodel_crossbow_t6_crawl_left",
  "crawlOutAnim": "viewmodel_crossbow_t6_crawl_out",
  "crawlEmptyInAnim": "viewmodel_crossbow_t6_crawl_in_empty",
  "crawlEmptyForwardAnim": "viewmodel_crossbow_t6_crawl_forward_empty",
  "crawlEmptyBackAnim": "viewmodel_crossbow_t6_crawl_back_empty",
  "crawlEmptyRightAnim": "viewmodel_crossbow_t6_crawl_right_empty",
  "crawlEmptyLeftAnim": "viewmodel_crossbow_t6_crawl_left_empty",
  "crawlEmptyOutAnim": "viewmodel_crossbow_t6_crawl_out_empty",
  "deployAnim": "",
  "nightVisionWearAnim": "",
  "nightVisionRemoveAnim": "",
  "adsFireAnim": "viewmodel_crossbow_t6_ads_fire",
  "adsLastShotAnim": "viewmodel_crossbow_t6_ads_last_shot",
  "adsRechamberAnim": "",
  "adsUpAnim": "viewmodel_crossbow_t6_ads_up",
  "adsDownAnim": "viewmodel_crossbow_t6_ads_down",
  "adsUpOtherScopeAnim": "",
  "adsFireIntroAnim": "",
  "breakdownAnim": "",
  "dtp_in": "viewmodel_crossbow_t6_d2p_in",
  "dtp_loop": "viewmodel_crossbow_t6_d2p_loop",
  "dtp_out": "viewmodel_crossbow_t6_d2p_out",
  "dtp_empty_in": "viewmodel_crossbow_t6_d2p_in_empty",
  "dtp_empty_loop": "viewmodel_crossbow_t6_d2p_loop_empty",
  "dtp_empty_out": "viewmodel_crossbow_t6_d2p_out_empty",
  "mantleAnim": "",
  "sprintCameraAnim": "",
  "dtpInCameraAnim": "",
  "dtpLoopCameraAnim": "",
  "dtpOutCameraAnim": "",
  "mantleCameraAnim": "",
  "pickupSound": "wpn_weap_pickup_npc",
  "pickupSoundPlayer": "wpn_weap_pickup_plr",
  "ammoPickupSound": "wpn_ammo_pickup_npc",
  "ammoPickupSoundPlayer": "wpn_ammo_pickup_plr",
  "projectileSound": "wpn_crossbow_whoosh_dist",
  "pullbackSound": "",
  "pullbackSoundPlayer": "",
  "fireSound": "wpn_crossbow_fire_npc",
  "crackSound": "",
  "whizbySound": "",
  "fireSoundPlayer": "wpn_crossbow_fire_plr",
  "loopFireSound": "",
  "loopFireSoundPlayer": "",
  "loopFireEndSound": "",
  "loopFireEndSoundPlayer": "",
  "startFireSound": "",
  "stopFireSound": "",
  "killcamStartFireSound": "",
  "startFireSoundPlayer": "",
  "stopFireSoundPlayer": "",
  "killcamStartFireSoundPlayer": "",
  "lastShotSound": "",
  "lastShotSoundPlayer": "",
  "emptyFireSound": "wpn_crossbow_dryfire_npc",
  "emptyFireSoundPlayer": "wpn_crossbow_dryfire_plr",
  "meleeSwipeSound": "",
  "meleeSwipeSoundPlayer": "",
  "meleeHitSound": "",
  "meleeMissSound": "",
  "rechamberSound": "",
  "rechamberSoundPlayer": "",
  "reloadSound": "",
  "reloadSoundPlayer": "",
  "reloadEmptySound": "",
  "reloadEmptySoundPlayer": "",
  "reloadStartSound": "",
  "reloadStartSoundPlayer": "",
  "reloadEndSound": "",
  "reloadEndSoundPlayer": "",
  "rotateLoopSound": "",
  "rotateLoopSoundPlayer": "",
  "rotateStopSound": "",
  "rotateStopSoundPlayer": "",
  "deploySound": "",
  "deploySoundPlayer": "",
  "finishDeploySound": "",
  "finishDeploySoundPlayer": "",
  "breakdownSound": "",
  "breakdownSoundPlayer": "",
  "finishBreakdownSound": "",
  "finishBreakdownSoundPlayer": "",
  "detonateSound": "",
  "detonateSoundPlayer": "",
  "nightVisionWearSound": "",
  "nightVisionWearSoundPlayer": "",
  "nightVisionRemoveSound": "",
  "nightVisionRemoveSoundPlayer": "",
  "raiseSound": "wpn_crossbow_raise_npc",
  "raiseSoundPlayer": "wpn_crossbow_raise_plr",
  "firstRaiseSound": "wpn_crossbow_1straise_npc",
  "firstRaiseSoundPlayer": "wpn_crossbow_1straise_plr",
  "altSwitchSound": "",
  "altSwitchSoundPlayer": "",
  "adsRaiseSoundPlayer": "fly_generic_ads_plr",
  "adsLowerSoundPlayer": "fly_generic_ads_lower_plr",
  "putawaySound": "",
  "putawaySoundPlayer": "",
  "overheatSound": "",
  "overheatSoundPlayer": "",
  "adsZoomSound": "",
  "bounceSound": "",
  "spinLoopSound": "",
  "spinLoopSoundPlayer": "",
  "startSpinSound": "",
  "startSpinSoundPlayer": "",
  "stopSpinSound": "",
  "stopSpinSoundPlayer": "",
  "stackSound": "",
  "projExplosionSound": "",
  "projDudSound": "",
  "mortarShellSound": "",
  "tankShellSound": "",
  "projIgnitionSound": "",
  "viewFlashEffect": "weapon/muzzleflashes/fx_crossbow_base",
  "worldFlashEffect": "weapon/muzzleflashes/fx_crossbow_base",
  "barrelCooldownEffect": "",
  "viewShellEjectEffect": "",
  "worldShellEjectEffect": "",
  "viewLastShotEjectEffect": "",
  "worldLastShotEjectEffect": "",
  "projExplosionEffect": "",
  "projExplosionEffectForceNormalUp": 0,
  "projExplosionEffect2": "",
  "projExplosionEffect2ForceNormalUp": 0,
  "projExplosionEffect3": "",
  "projExplosionEffect3ForceNormalUp": 0,
  "projExplosionEffect4": "",
  "projExplosionEffect4ForceNormalUp": 0,
  "projExplosionEffect5": "",
  "projExplosionEffect5ForceNormalUp": 0,
  "projDudEffect": "",
  "projTrailEffect": "weapon/crossbow/fx_trail_crossbow",
  "projIgnitionEffect": "",
  "tagFx_preparationEffect": "",
  "tagFlash_preparationEffect": "",
  "meleeSwipeEffect": "",
  "meleeImpactEffect": "",
  "meleeImpactNoBloodEffect": "",
  "ammoCounterClip": "Magazine",
  "startAmmo": 6,
  "ammoDisplayName": "",
  "ammoName": "explosive_bolt crossbow",
  "clipName": "crossbow",
  "maxAmmo": 3,
  "clipSize": 3,
  "shotCount": 0,
  "sharedAmmoCapName": "",
  "sharedAmmoCap": 0,
  "unlimitedAmmo": 0,
  "ammoCountClipRelative": 0,
  "sharedAmmo": 0,
  "overheatWeapon": 0,
  "overheatRate": 60,
  "cooldownRate": 30,
  "overheatEndVal": 0,
  "clipOnly": 0,
  "suppressAmmoReserveDisplay": 0,
  "reloadAmmoAdd": 0,
  "reloadStartAdd": 0,
  "lowAmmoWarningThreshold": 0.25,
  "damage": 40,
  "minDamage": 0,
  "maxDamageRange": 999999,
  "minDamageRange": 999999,
  "playerDamage": 30,
  "minPlayerDamage": 0,
  "destabilizationRateTime": 0,
  "destabilizationCurvatureMax": 10,
  "destabilizeDistance": 30000,
  "explosionRadius": 1,
  "explosionRadiusMin": 0,
  "indicatorRadius": 0,
  "explosionInnerDamage": 1,
  "explosionOuterDamage": 1,
  "damageConeAngle": 180,
  "projExplosionType": "bolt",
  "projImpactExplode": 0,
  "bulletImpactExplode": 0,
  "explosionTag": "",
  "explosionCameraShakeScale": 0.5,
  "explosionCameraShakeDuration": 500,
  "explosionCameraShakeRadius": 512,
  "locNone": 1,
  "locHelmet": 1,
  "locHead": 1,
  "locNeck": 1,
  "locTorsoUpper": 1,
  "locTorsoMid": 1,
  "locTorsoLower": 1,
  "locRightArmUpper": 1,
  "locRightArmLower": 1,
  "locRightHand": 1,
  "locLeftArmUpper": 1,
  "locLeftArmLower": 1,
  "locLeftHand": 1,
  "locRightLegUpper": 1,
  "locRightLegLower": 1,
  "locRightFoot": 1,
  "locLeftLegUpper": 1,
  "locLeftLegLower": 1,
  "locLeftFoot": 1,
  "locGun": 0,
  "maxGibDistance": 0,
  "meleeDamage": 25,
  "meleeDelay": 0.25,
  "meleeChargeDelay": 0,
  "meleeTime": 0.7,
  "meleeChargeTime": 0,
  "meleeChargeRange": 0,
  "useAsMelee": 0,
  "detonateTime": 0,
  "detonateDelay": 0,
  "fuseTime": 0,
  "aifuseTime": 0,
  "cookOffHold": 0,
  "throwBack": 0,
  "retrievable": 0,
  "dieOnRespawn": 0,
  "forceBounce": 0,
  "showIndicator": 0,
  "projectileSpeed": 4500,
  "projectileSpeedRelativeUp": 0,
  "projectileSpeedUp": 90,
  "projectileSpeedForward": 0,
  "projectileTakeParentVel": 0,
  "projectileActivateDist": 0,
  "projectileLifetime": 30,
  "projectileCurvature": 0,
  "stickiness": "Stick to all",
  "rotateType": "Rotate both axis, grenade style",
  "hasDetonator": 0,
  "plantable": 0,
  "timedDetonation": 0,
  "rotate": 0,
  "holdButtonToThrow": 0,
  "offhandHoldIsCancelable": 0,
  "freezeMovementWhenFiring": 0,
  "bDisallowAtMatchStart": 1,
  "isHoldUseGrenade": 0,
  "parallelDefaultBounce": 0.5,
  "parallelAsphaltBounce": 0.5,
  "parallelBarkBounce": 0.5,
  "parallelBrickBounce": 0.5,
  "parallelCarpetBounce": 0.5,
  "parallelCeramicBounce": 0.5,
  "parallelClothBounce": 0.5,
  "parallelConcreteBounce": 0.5,
  "parallelCushionBounce": 0.5,
  "parallelDirtBounce": 0.5,
  "parallelFleshBounce": 0.5,
  "parallelFoliageBounce": 0.5,
  "parallelFruitBounce": 0.5,
  "parallelGlassBounce": 0.5,
  "parallelGrassBounce": 0.5,
  "parallelGravelBounce": 0.5,
  "parallelIceBounce": 0.5,
  "parallelMetalBounce": 0.5,
  "parallelMudBounce": 0.5,
  "parallelPaintedMetalBounce": 0.5,
  "parallelPaperBounce": 0.5,
  "parallelPlasterBounce": 0.5,
  "parallelPlasticBounce": 0.5,
  "parallelRockBounce": 0.5,
  "parallelRubberBounce": 0.5,
  "parallelSandBounce": 0.5,
  "parallelSnowBounce": 0.5,
  "parallelWaterBounce": 0.5,
  "parallelWoodBounce": 0.5,
  "parallelRiotShieldBounce": 0.5,
  "perpendicularDefaultBounce": 0.5,
  "perpendicularAsphaltBounce": 0.5,
  "perpendicularBarkBounce": 0.5,
  "perpendicularBrickBounce": 0.5,
  "perpendicularCarpetBounce": 0.5,
  "perpendicularCeramicBounce": 0.5,
  "perpendicularClothBounce": 0.5,
  "perpendicularConcreteBounce": 0.5,
  "perpendicularCushionBounce": 0.5,
  "perpendicularDirtBounce": 0.5,
  "perpendicularFleshBounce": 0.5,
  "perpendicularFoliageBounce": 0.5,
  "perpendicularFruitBounce": 0.5,
  "perpendicularGlassBounce": 0.5,
  "perpendicularGrassBounce": 0.5,
  "perpendicularGravelBounce": 0.5,
  "perpendicularIceBounce": 0.5,
  "perpendicularMetalBounce": 0.5,
  "perpendicularMudBounce": 0.5,
  "perpendicularPaintedMetalBounce": 0.5,
  "perpendicularPaperBounce": 0.5,
  "perpendicularPlasterBounce": 0.5,
  "perpendicularPlasticBounce": 0.5,
  "perpendicularRockBounce": 0.5,
  "perpendicularRubberBounce": 0.5,
  "perpendicularSandBounce": 0.5,
  "perpendicularSnowBounce": 0.5,
  "perpendicularWaterBounce": 0.5,
  "perpendicularWoodBounce": 0.5,
  "perpendicularRiotShieldBounce": 0.5,
  "projectileRed": 0.75,
  "projectileGreen": 0.3,
  "projectileBlue": 0,
  "guidedMissileType": "Ballistic",
  "maxSteeringAccel": 3000,
  "projIgnitionDelay": 0,
  "tracerType": "",
  "enemyTracerType": "",
  "throwBackType": "",
  "reticleCenter": "",
  "reticleSide": "reticle_side_small",
  "reticleCenterSize": 4,
  "reticleSideSize": 8,
  "reticleMinOfs": 0,
  "activeReticleType": "None",
  "adsMoveSpeedScale": 1,
  "adsSwayMaxAngle": 2,
  "adsSwayLerpSpeed": 4,
  "adsSwayPitchScale": 0.06,
  "adsSwayYawScale": 0.045,
  "adsSwayHorizScale": 0.13,
  "adsSwayVertScale": 0.12,
  "aimDownSight": 1,
  "adsViewErrorMin": 0,
  "adsViewErrorMax": 0,
  "adsFire": 0,
  "antiQuickScope": 0,
  "adsTransInTime": 0.25,
  "adsTransOutTime": 0.25,
  "adsIdleAmount": 5,
  "adsIdleSpeed": 1.5,
  "adsZoomFov1": 55,
  "adsZoomFov2": 55,
  "adsZoomFov3": 55,
  "adsZoomInFrac": 0.5,
  "adsZoomOutFrac": 0.5,
  "adsOverlayShader": "",
  "adsOverlayShaderLowRes": "",
  "adsOverlayReticle": "none",
  "adsOverlayInterface": "None",
  "adsOverlayWidth": 480,
  "adsOverlayHeight": 480,
  "adsOverlayAlphaScale": 1,
  "adsBobFactor": 0.7,
  "adsViewBobMult": 0.2,
  "holdBreathToSteady": 0,
  "adsAimPitch": 0,
  "adsCrosshairInFrac": 1,
  "adsCrosshairOutFrac": 0.2,
  "adsReloadTransTime": 0.6,
  "adsGunKickReducedKickBullets": 0,
  "adsGunKickReducedKickPercent": 0,
  "adsGunKickPitchMin": 0,
  "adsGunKickPitchMax": 0,
  "adsGunKickYawMin": 0,
  "adsGunKickYawMax": 0,
  "adsGunKickAccel": 0,
  "adsGunKickSpeedMax": 2000,
  "adsGunKickSpeedDecay": 25,
  "adsGunKickStaticDecay": 50,
  "adsViewKickPitchMin": 60,
  "adsViewKickPitchMax": 80,
  "adsViewKickMinMagnitude": 0,
  "adsViewKickYawMin": -40,
  "adsViewKickYawMax": -50,
  "adsRecoilReductionRate": 0,
  "adsRecoilReductionLimit": 0,
  "adsRecoilReturnRate": 0,
  "adsViewKickCenterSpeed": 1500,
  "adsViewKickCenterDuckedScale": 1,
  "adsViewKickCenterProneScale": 1,
  "adsSpread": 0,
  "antiQuickScopeTime": 0,
  "antiQuickScopeScale": 0,
  "antiQuickScopeSpreadMultiplier": 0,
  "antiQuickScopeSpreadMax": 0,
  "antiQuickScopeSwayFactor": 0,
  "adsDofStart": 1.8,
  "adsDofEnd": 2.9,
  "mmsWeapon": 0,
  "mmsInScope": 0,
  "mmsFOV": 0,
  "mmsAspect": 0,
  "mmsMaxDist": 0,
  "jamFireTime": 0,
  "tankLifeTime": 0,
  "fireDelay": 0,
  "spinUpTime": 0,
  "spinDownTime": 0,
  "introFireTime": 0,
  "fireTime": 1.152,
  "flourishTime": 1.152,
  "lastFireTime": 0.32,
  "rechamberTime": 0.9,
  "rechamberBoltTime": 0,
  "holdFireTime": 0,
  "burstFireDelay": 0,
  "reloadTime": 2.85,
  "reloadShowRocketTime": 0,
  "reloadEmptyTime": 2.85,
  "reloadAddTime": 1.5,
  "reloadEmptyAddTime": 0,
  "reloadQuickAddTime": 0,
  "reloadQuickEmptyAddTime": 0,
  "reloadStartTime": 0,
  "reloadStartAddTime": 0,
  "reloadEndTime": 0,
  "reloadQuickTime": 0,
  "reloadQuickEmptyTime": 0,
  "dropTime": 0.45,
  "raiseTime": 0.5,
  "altDropTime": 0,
  "altRaiseTime": 0,
  "quickDropTime": 0.25,
  "quickRaiseTime": 0.5,
  "firstRaiseTime": 1.25,
  "emptyRaiseTime": 0.5,
  "emptyDropTime": 0.45,
  "sprintInTime": 0.3,
  "sprintLoopTime": 0.87,
  "sprintOutTime": 0.3,
  "lowReadyInTime": 0.5,
  "lowReadyLoopTime": 0.5,
  "lowReadyOutTime": 0.5,
  "contFireInTime": 0,
  "contFireLoopTime": 0,
  "contFireOutTime": 0,
  "dtpInTime": 0.15,
  "dtpLoopTime": 0.6,
  "dtpOutTime": 0.25,
  "crawlInTime": 0.3,
  "crawlForwardTime": 1.1,
  "crawlBackTime": 1,
  "crawlRightTime": 1.2,
  "crawlLeftTime": 1.1,
  "crawlOutFireTime": 0.048,
  "crawlOutTime": 0.1,
  "slideInTime": 0.5,
  "deployTime": 0,
  "breakdownTime": 0,
  "nightVisionWearTime": 0,
  "nightVisionRemoveTime": 0,
  "pitchConvergenceTime": 0,
  "yawConvergenceTime": 0,
  "suppressionTime": 0,
  "scanPauseTime": 0,
  "altScopeADSTransInTime": 0,
  "altScopeADSTransOutTime": 0,
  "stackFireSpread": 15,
  "hipSpreadStandMin": 3,
  "hipSpreadDuckedMin": 2,
  "hipSpreadProneMin": 1.5,
  "hipSpreadMax": 7,
  "hipSpreadDuckedMax": 6,
  "hipSpreadProneMax": 3,
  "hipSpreadDecayRate": 4,
  "hipSpreadFireAdd": 1,
  "hipSpreadTurnAdd": 0,
  "hipSpreadMoveAdd": 4.5,
  "hipSpreadDuckedDecay": 1,
  "hipSpreadProneDecay": 1,
  "aiSpread": 0,
  "playerSpread": 0,
  "hipGunKickReducedKickBullets": 0,
  "hipGunKickReducedKickPercent": 0,
  "hipGunKickPitchMin": -30,
  "hipGunKickPitchMax": -35,
  "hipGunKickYawMin": -2,
  "hipGunKickYawMax": 18,
  "hipGunKickAccel": 1000,
  "hipGunKickSpeedMax": 1200,
  "hipGunKickSpeedDecay": 100,
  "hipGunKickStaticDecay": 2,
  "hipViewKickPitchMin": 60,
  "hipViewKickPitchMax": 80,
  "hipViewKickMinMagnitude": 0,
  "hipViewKickYawMin": -40,
  "hipViewKickYawMax": -50,
  "hipViewKickCenterSpeed": 1500,
  "duckedSprintBobH": 0,
  "duckedSprintBobV": 0,
  "sprintBobH": 0,
  "sprintBobV": 0,
  "dtpBobH": 0,
  "dtpBobV": 0,
  "idleCrouchFactor": 0.8,
  "idleProneFactor": 0.6,
  "gunMaxPitch": 2,
  "gunMaxYaw": 8,
  "swayMaxAngle": 4,
  "swayLerpSpeed": 4,
  "swayPitchScale": -1,
  "swayYawScale": -1,
  "swayHorizScale": 0.16,
  "swayVertScale": 0.35,
  "swayShellShockScale": 0.1,
  "hipIdleAmount": 15,
  "hipIdleSpeed": 5,
  "duckedSprintOfsF": 0,
  "duckedSprintOfsR": 0,
  "duckedSprintOfsU": 0,
  "duckedSprintRotP": 0,
  "duckedSprintRotY": 0,
  "duckedSprintRotR": 0,
  "duckedSprintScale": 0,
  "moveSpeedScale": 1,
  "sprintDurationScale": 1,
  "standMoveF": 0,
  "standMoveR": 0,
  "standMoveU": 0,
  "standRotP": 2,
  "standRotY": 0,
  "standRotR": -2,
  "duckedOfsF": -1,
  "duckedOfsR": 0.4,
  "duckedOfsU": -1,
  "duckedMoveF": 0,
  "duckedMoveR": 0,
  "duckedMoveU": 0,
  "sprintOfsF": 0,
  "sprintOfsR": 0,
  "sprintOfsU": 0,
  "sprintRotP": 0,
  "sprintRotY": 0,
  "sprintRotR": 0,
  "sprintScale": 0.8,
  "lowReadyOfsF": 0,
  "lowReadyOfsR": 0,
  "lowReadyOfsU": 0,
  "lowReadyRotP": 0,
  "lowReadyRotY": 0,
  "lowReadyRotR": 0,
  "rideOfsF": 0,
  "rideOfsR": 0,
  "rideOfsU": 0,
  "rideRotP": 0,
  "rideRotY": 0,
  "rideRotR": 0,
  "dtpOfsF": 0,
  "dtpOfsR": 0,
  "dtpOfsU": 0,
  "dtpRotP": 0,
  "dtpRotY": 0,
  "dtpRotR": 0,
  "dtpScale": 1,
  "mantleOfsF": 0,
  "mantleOfsR": -3,
  "mantleOfsU": -1,
  "mantleRotP": -10,
  "mantleRotY": 5,
  "mantleRotR": 0,
  "slideOfsF": 0,
  "slideOfsR": 0,
  "slideOfsU": 0,
  "slideRotP": 0,
  "slideRotY": 0,
  "slideRotR": 0,
  "duckedRotP": 2,
  "duckedRotY": 0,
  "duckedRotR": -2,
  "proneOfsF": -0.3,
  "proneOfsR": 0,
  "proneOfsU": -0.7,
  "proneMoveF": 0,
  "proneMoveR": 0,
  "proneMoveU": 0,
  "proneRotP": 0,
  "proneRotY": 3,
  "proneRotR": -3,
  "strafeMoveF": 0,
  "strafeMoveR": 0.5,
  "strafeMoveU": 0,
  "strafeRotP": 0,
  "strafeRotY": 0,
  "strafeRotR": 3,
  "posMoveRate": 6,
  "posProneMoveRate": 25,
  "standMoveMinSpeed": 0,
  "duckedMoveMinSpeed": 0,
  "proneMoveMinSpeed": 0,
  "posRotRate": 6,
  "posProneRotRate": 30,
  "standRotMinSpeed": 0,
  "duckedRotMinSpeed": 0,
  "proneRotMinSpeed": 0,
  "animHorRotateInc": 0,
  "cameraShakeScale": 0,
  "ikLeftHandIdlePosF": 0,
  "ikLeftHandIdlePosR": 0,
  "ikLeftHandIdlePosU": 0,
  "ikLeftHandOffsetF": 0,
  "ikLeftHandOffsetR": 0,
  "ikLeftHandOffsetU": -2.3,
  "ikLeftHandRotationP": 0,
  "ikLeftHandRotationY": 0,
  "ikLeftHandRotationR": 0,
  "ikLeftHandProneOffsetF": 0,
  "ikLeftHandProneOffsetR": 0,
  "ikLeftHandProneOffsetU": 0,
  "ikLeftHandProneRotationP": 0,
  "ikLeftHandProneRotationY": 0,
  "ikLeftHandProneRotationR": 0,
  "ikLeftHandUiViewerOffsetF": 0,
  "ikLeftHandUiViewerOffsetR": 0,
  "ikLeftHandUiViewerOffsetU": 0,
  "ikLeftHandUiViewerRotationP": 0,
  "ikLeftHandUiViewerRotationY": 0,
  "ikLeftHandUiViewerRotationR": 0,
  "lockOnRadius": 60,
  "lockOnSpeed": 2000,
  "requireLockonToFire": 0,
  "autoAimRange": 0,
  "aimAssistRange": 1000,
  "aimAssistRangeAds": 1000,
  "enemyCrosshairRange": 600,
  "crosshairColorChange": 1,
  "useAntiLagRewind": 1,
  "fightDist": 720,
  "maxDist": 250,
  "slide_in": "",
  "script": "",
  "barrelCooldownMinCount": 0,
  "viewFlashOffsetF": 0,
  "viewFlashOffsetR": 0,
  "viewFlashOffsetU": 0,
  "worldFlashOffsetF": 0,
  "worldFlashOffsetR": 0,
  "worldFlashOffsetU": 0,
  "shellCasing": "",
  "shellCasingPlayer": "",
  "standMountedWeapdef": "",
  "crouchMountedWeapdef": "",
  "proneMountedWeapdef": "",
  "viewShellEjectOffsetF": 0,
  "viewShellEjectOffsetR": 0,
  "viewShellEjectOffsetU": 0,
  "worldShellEjectOffsetF": 0,
  "worldShellEjectOffsetR": 0,
  "worldShellEjectOffsetU": 0,
  "viewShellEjectRotationP": 0,
  "viewShellEjectRotationY": 0,
  "viewShellEjectRotationR": 0,
  "worldShellEjectRotationP": 0,
  "worldShellEjectRotationY": 0,
  "worldShellEjectRotationR": 0,
  "ignoreAttachments": 0,
  "mountedModel": "",
  "coolWhileFiring": 0,
  "fuelTankWeapon": 0,
  "damage2": 0,
  "damage3": 0,
  "damage4": 0,
  "damage5": 0,
  "damageRange2": 0,
  "damageRange3": 0,
  "damageRange4": 0,
  "damageRange5": 0,
  "damageDuration": 0,
  "damageInterval": 0,
  "spinRate": 0,
  "applySpinPitch": 0,
  "introFireLength": 0,
  "nightVisionWearTimeFadeOutEnd": 0,
  "nightVisionWearTimePowerUp": 0,
  "nightVisionRemoveTimePowerDown": 0,
  "nightVisionRemoveTimeFadeInStart": 0,
  "noAdsWhenMagEmpty": 0,
  "avoidDropCleanup": 0,
  "stackFire": 0,
  "stackFireAccuracyDecay": 0,
  "mountableWeapon": 0,
  "aimPadding": 0,
  "rifleBullet": 0,
  "armorPiercing": 0,
  "boltAction": 0,
  "shotsBeforeRechamber": 0,
  "useAltTagFlash": 0,
  "isCarriedKillstreakWeapon": 0,
  "rechamberWhileAds": 0,
  "reloadWhileAds": 0,
  "canUseInVehicle": 0,
  "noDropsOrRaises": 0,
  "cancelAutoHolsterWhenEmpty": 0,
  "laserSight": 0,
  "laserSightDuringNightvision": 0,
  "bayonet": 0,
  "dualWield": 0,
  "hideThirdPerson": 0,
  "explodeOnGround": 0,
  "noThirdPersonDropsOrRaises": 0,
  "continuousFire": 0,
  "noQuickDropWhenEmpty": 1,
  "keepCrosshairWhenADS": 0,
  "useOnlyAltWeaoponHideTagsInAltMode": 0,
  "altWeaponAdsOnly": 0,
  "altWeaponDisableSwitching": 0,
  "noPartialReload": 0,
  "segmentedReload": 0,
  "noADSAutoReload": 0,
  "attachmentUnique": "",
  "DualWieldWeapon": "",
  "dropClipAmmoMin": 0,
  "dropClipAmmoMax": 0,
  "blocksProne": 0,
  "silenced": 0,
  "dualMag": 0,
  "infrared": 0,
  "tvguided": 0,
  "airburstWeapon": 0,
  "perks1": 0,
  "perks0": 0,
  "isRollingGrenade": 0,
  "useBallisticPrediction": 0,
  "isValuable": 0,
  "isTacticalInsertion": 0,
  "isReviveWeapon": 0,
  "bUseRigidBodyOnVehicle": 0,
  "timeToAccelerate": 0,
  "sentientImpactExplode": 0,
  "explodeWhenStationary": 0,
  "noCrumpleMissile": 0,
  "keepRolling": 0,
  "isCameraSensor": 0,
  "isAcousticSensor": 0,
  "isLaserSensor": 0,
  "hipReticleSidePos": 0,
  "leftArc": 0,
  "rightArc": 0,
  "topArc": 0,
  "bottomArc": 0,
  "accuracy": 0,
  "maxVertTurnSpeed": 0,
  "maxHorTurnSpeed": 0,
  "minVertTurnSpeed": 0,
  "minHorTurnSpeed": 0,
  "maxRange": 0,
  "playerPositionDist": 0,
  "useHintString": "",
  "dropHintString": "",
  "horizViewJitter": 0,
  "vertViewJitter": 0,
  "cameraShakeDuration": 0,
  "cameraShakeRadius": 0,
  "aiVsAiAccuracyGraph": "",
  "aiVsPlayerAccuracyGraph": "",
  "scanSpeed": 0,
  "scanAccel": 0,
  "flameTableFirstPerson": "",
  "flameTableThirdPerson": "",
  "usingLeftHandProneIK": 0,
  "doGibbing": 0,
  "customFloat0": 0,
  "customFloat1": 0,
  "customFloat2": 0,
  "customBool0": 0,
  "customBool1": 0,
  "customBool2": 0,
  "au_attachmentType": "none",
  "au_locNone": 1,
  "au_locHelmet": 4,
  "au_locHead": 4,
  "au_locNeck": 5,
  "au_locTorsoUpper": 1,
  "au_locTorsoMid": 1,
  "au_locTorsoLower": 0.9,
  "au_locRightArmUpper": 0.8,
  "au_locRightArmLower": 0.6,
  "au_locRightHand": 0.4,
  "au_locLeftArmUpper": 0.8,
  "au_locLeftArmLower": 0.6,
  "au_locLeftHand": 0.4,
  "au_locRightLegUpper": 0.8,
  "au_locRightLegLower": 0.6,
  "au_locRightFoot": 0.4,
  "au_locLeftLegUpper": 0.8,
  "au_locLeftLegLower": 0.6,
  "au_locLeftFoot": 0.4,
  "au_locGun": 0,
  "au_viewModel": "",
  "au_viewModelAdditional": "",
  "au_viewModelADS": "",
  "au_worldModel": "",
  "au_worldModelAdditional": "",
  "au_viewModelTag": "",
  "au_worldModelTag": "",
  "au_viewModelOffsetX": 0,
  "au_viewModelOffsetY": 0,
  "au_viewModelOffsetZ": 0,
  "au_viewModelOffsetPitch": 0,
  "au_viewModelOffsetYaw": 0,
  "au_viewModelOffsetRoll": 0,
  "au_worldModelOffsetX": 0,
  "au_worldModelOffsetY": 0,
  "au_worldModelOffsetZ": 0,
  "au_worldModelOffsetPitch": 0,
  "au_worldModelOffsetYaw": 0,
  "au_worldModelOffsetRoll": 0,
  "au_viewModelAddOffsetX": 0,
  "au_viewModelAddOffsetY": 0,
  "au_viewModelAddOffsetZ": 0,
  "au_viewModelAddOffsetPitch": 0,
  "au_viewModelAddOffsetYaw": 0,
  "au_viewModelAddOffsetRoll": 0,
  "au_worldModelAddOffsetX": 0,
  "au_worldModelAddOffsetY": 0,
  "au_worldModelAddOffsetZ": 0,
  "au_worldModelAddOffsetPitch": 0,
  "au_worldModelAddOffsetYaw": 0,
  "au_worldModelAddOffsetRoll": 0,
  "au_0": "tag_sights_off",
  "au_1": "tag_bullet1",
  "au_camo": "camo_crossbow",
  "au_disableBaseWeaponAttachment": 0,
  "au_disableBaseWeaponClip": 0,
  "au_overrideBaseWeaponAttachmentOffsets": 0,
  "au_viewModelOffsetBaseAttachmentX": 0,
  "au_viewModelOffsetBaseAttachmentY": 0,
  "au_viewModelOffsetBaseAttachmentZ": 0,
  "au_worldModelOffsetBaseAttachmentX": 0,
  "au_worldModelOffsetBaseAttachmentY": 0,
  "au_worldModelOffsetBaseAttachmentZ": 0,
  "au_altWeapon": "",
  "au_DualWieldWeapon": "",
  "au_adsOverlayShader": "",
  "au_adsOverlayShaderLowRes": "",
  "au_adsOverlayReticle": "none",
  "au_firstRaiseTime": 0,
  "au_altRaiseTime": 0,
  "au_altDropTime": 0,
  "au_reloadAmmoAdd": 0,
  "au_reloadStartAdd": 0,
  "au_segmentedReload": 0,
  "au_idleAnim": "",
  "au_idleAnimLeft": "",
  "au_emptyIdleAnim": "",
  "au_emptyIdleAnimLeft": "",
  "au_fireIntroAnim": "",
  "au_fireAnim": "",
  "au_fireAnimLeft": "",
  "au_holdFireAnim": "",
  "au_lastShotAnim": "",
  "au_lastShotAnimLeft": "",
  "au_flourishAnim": "",
  "au_flourishAnimLeft": "",
  "au_detonateAnim": "",
  "au_rechamberAnim": "",
  "au_meleeAnim": "",
  "au_meleeAnimEmpty": "",
  "au_meleeAnim1": "",
  "au_meleeAnim2": "",
  "au_meleeAnim3": "",
  "au_meleeChargeAnim": "",
  "au_meleeChargeAnimEmpty": "",
  "au_reloadAnim": "",
  "au_reloadAnimRight": "",
  "au_reloadAnimLeft": "",
  "au_reloadEmptyAnim": "",
  "au_reloadEmptyAnimLeft": "",
  "au_reloadStartAnim": "",
  "au_reloadEndAnim": "",
  "au_reloadQuickAnim": "",
  "au_reloadQuickEmptyAnim": "",
  "au_raiseAnim": "",
  "au_dropAnim": "",
  "au_firstRaiseAnim": "",
  "au_altRaiseAnim": "",
  "au_altDropAnim": "",
  "au_quickRaiseAnim": "",
  "au_quickDropAnim": "",
  "au_emptyRaiseAnim": "",
  "au_emptyDropAnim": "",
  "au_sprintInAnim": "",
  "au_sprintLoopAnim": "",
  "au_sprintOutAnim": "",
  "au_sprintInEmptyAnim": "",
  "au_sprintLoopEmptyAnim": "",
  "au_sprintOutEmptyAnim": "",
  "au_lowReadyInAnim": "",
  "au_lowReadyLoopAnim": "",
  "au_lowReadyOutAnim": "",
  "au_contFireInAnim": "",
  "au_contFireLoopAnim": "",
  "au_contFireOutAnim": "",
  "au_crawlInAnim": "",
  "au_crawlForwardAnim": "",
  "au_crawlBackAnim": "",
  "au_crawlRightAnim": "",
  "au_crawlLeftAnim": "",
  "au_crawlOutAnim": "",
  "au_crawlEmptyInAnim": "",
  "au_crawlEmptyForwardAnim": "",
  "au_crawlEmptyBackAnim": "",
  "au_crawlEmptyRightAnim": "",
  "au_crawlEmptyLeftAnim": "",
  "au_crawlEmptyOutAnim": "",
  "au_deployAnim": "",
  "au_breakdownAnim": "",
  "au_nightVisionWearAnim": "",
  "au_nightVisionRemoveAnim": "",
  "au_adsFireAnim": "",
  "au_adsLastShotAnim": "",
  "au_adsRechamberAnim": "",
  "au_adsUpAnim": "",
  "au_adsDownAnim": "",
  "au_adsUpOtherScopeAnim": "",
  "au_adsFireIntroAnim": "",
  "au_dtp_in": "",
  "au_dtp_loop": "",
  "au_dtp_out": "",
  "au_dtp_empty_in": "",
  "au_dtp_empty_loop": "",
  "au_dtp_empty_out": "",
  "au_slide_in": "",
  "au_mantleAnim": "",
  "au_sprintCameraAnim": "",
  "au_dtpInCameraAnim": "",
  "au_dtpLoopCameraAnim": "",
  "au_dtpOutCameraAnim": "",
  "au_mantleCameraAnim": "",
  "au_fireSound": "",
  "au_fireSoundPlayer": "",
  "au_loopFireSound": "",
  "au_loopFireSoundPlayer": "",
  "au_loopFireEndSound": "",
  "au_loopFireEndSoundPlayer": "",
  "au_startFireSound": "",
  "au_stopFireSound": "",
  "au_startFireSoundPlayer": "",
  "au_stopFireSoundPlayer": "",
  "au_lastShotSound": "",
  "au_lastShotSoundPlayer": "",
  "au_killcamStartFireSound": "",
  "au_killcamStartFireSoundPlayer": "",
  "au_viewFlashEffect": "",
  "au_worldFlashEffect": "",
  "au_tracerType": "",
  "au_enemyTracerType": "",
  "au_adsDofStart": 0,
  "au_adsDofEnd": 0,
  "au_overrideLeftHandIK": 0,
  "au_overrideLeftHandProneIK": 0,
  "au_ikLeftHandOffsetF": 0,
  "au_ikLeftHandOffsetR": 0,
  "au_ikLeftHandOffsetU": 0,
  "au_ikLeftHandRotationP": 0,
  "au_ikLeftHandRotationY": 0,
  "au_ikLeftHandRotationR": 0,
  "au_ikLeftHandProneOffsetF": 0,
  "au_ikLeftHandProneOffsetR": 0,
  "au_ikLeftHandProneOffsetU": 0,
  "au_ikLeftHandProneRotationP": 0,
  "au_ikLeftHandProneRotationY": 0,
  "au_ikLeftHandProneRotationR": 0,
  "au_customFloat0": 0,
  "au_customFloat1": 0,
  "au_customFloat2": 0,
  "au_customBool0": 0,
  "au_customBool1": 0,
  "au_customBool2": 0,
  "au_name": "au_crossbow_none",
  "displayNameEnglish": "Crossbow",
  "role": "SnS primary (sas.gsc givecustomloadout: giveweapon, setweaponammoclip 3, setweaponammostock 3, setspawnweapon)"
 },
 "explosive_bolt_mp": {
  "displayName": "WEAPON_STICKY_GRENADE",
  "AIOverlayDescription": "",
  "modeName": "",
  "playerAnimType": "default",
  "weaponType": "grenade",
  "weaponClass": "grenade",
  "penetrateType": "none",
  "impactType": "grenade_explode",
  "inventoryType": "offhand",
  "fireType": "Full Auto",
  "clipType": "bottom",
  "barrelType": "Single",
  "offhandClass": "Frag Grenade",
  "offhandSlot": "Lethal grenade",
  "fireTypeIcon": "",
  "hudIcon": "hud_grenadeicon",
  "hudIconRatio": "1:1",
  "indicatorIcon": "hud_indicator_arrow",
  "indicatorIconRatio": "1:1",
  "ammoCounterIcon": "",
  "ammoCounterIconRatio": "4:1",
  "noPing": 0,
  "killIcon": "hud_obit_exploding_arrow",
  "killIconRatio": "1:1",
  "flipKillIcon": 1,
  "dpadIcon": "",
  "dpadIconRatio": "4:1",
  "noAmmoOnDpadIcon": 0,
  "altWeapon": "",
  "grenadeWeapon": "",
  "dropAmmoMin": 1,
  "dropAmmoMax": 1,
  "stance": "stand",
  "fireRumble": "",
  "meleeImpactRumble": "",
  "reloadRumble": "",
  "explosionRumble": "grenade_rumble",
  "parentWeaponName": "crossbow",
  "camo": "",
  "attachments": "",
  "attachmentUniques": "",
  "gunModel": "t6_wpn_grenade_frag_view",
  "gunModel2": "",
  "gunModel3": "",
  "gunModel4": "",
  "gunModel5": "",
  "gunModel6": "",
  "gunModel7": "",
  "gunModel8": "",
  "gunModel9": "",
  "gunModel10": "",
  "gunModel11": "",
  "gunModel12": "",
  "gunModel13": "",
  "gunModel14": "",
  "gunModel15": "",
  "gunModel16": "",
  "handModel": "viewmodel_hands_no_model",
  "hideTags": "",
  "worldModel": "",
  "worldModel2": "",
  "worldModel3": "",
  "worldModel4": "",
  "worldModel5": "",
  "worldModel6": "",
  "worldModel7": "",
  "worldModel8": "",
  "worldModel9": "",
  "worldModel10": "",
  "worldModel11": "",
  "worldModel12": "",
  "worldModel13": "",
  "worldModel14": "",
  "worldModel15": "",
  "worldModel16": "",
  "attachViewModel1": "",
  "attachViewModel2": "",
  "attachViewModel3": "",
  "attachViewModel4": "",
  "attachViewModel5": "",
  "attachViewModel6": "",
  "attachViewModel7": "",
  "attachViewModel8": "",
  "attachWorldModel1": "",
  "attachWorldModel2": "",
  "attachWorldModel3": "",
  "attachWorldModel4": "",
  "attachWorldModel5": "",
  "attachWorldModel6": "",
  "attachWorldModel7": "",
  "attachWorldModel8": "",
  "attachViewModelTag1": "",
  "attachViewModelTag2": "",
  "attachViewModelTag3": "",
  "attachViewModelTag4": "",
  "attachViewModelTag5": "",
  "attachViewModelTag6": "",
  "attachViewModelTag7": "",
  "attachViewModelTag8": "",
  "attachWorldModelTag1": "",
  "attachWorldModelTag2": "",
  "attachWorldModelTag3": "",
  "attachWorldModelTag4": "",
  "attachWorldModelTag5": "",
  "attachWorldModelTag6": "",
  "attachWorldModelTag7": "",
  "attachWorldModelTag8": "",
  "attachViewModelOffsetX1": 0,
  "attachViewModelOffsetY1": 0,
  "attachViewModelOffsetZ1": 0,
  "attachViewModelOffsetX2": 0,
  "attachViewModelOffsetY2": 0,
  "attachViewModelOffsetZ2": 0,
  "attachViewModelOffsetX3": 0,
  "attachViewModelOffsetY3": 0,
  "attachViewModelOffsetZ3": 0,
  "attachViewModelOffsetX4": 0,
  "attachViewModelOffsetY4": 0,
  "attachViewModelOffsetZ4": 0,
  "attachViewModelOffsetX5": 0,
  "attachViewModelOffsetY5": 0,
  "attachViewModelOffsetZ5": 0,
  "attachViewModelOffsetX6": 0,
  "attachViewModelOffsetY6": 0,
  "attachViewModelOffsetZ6": 0,
  "attachViewModelOffsetX7": 0,
  "attachViewModelOffsetY7": 0,
  "attachViewModelOffsetZ7": 0,
  "attachViewModelOffsetX8": 0,
  "attachViewModelOffsetY8": 0,
  "attachViewModelOffsetZ8": 0,
  "attachWorldModelOffsetX1": 0,
  "attachWorldModelOffsetY1": 0,
  "attachWorldModelOffsetZ1": 0,
  "attachWorldModelOffsetX2": 0,
  "attachWorldModelOffsetY2": 0,
  "attachWorldModelOffsetZ2": 0,
  "attachWorldModelOffsetX3": 0,
  "attachWorldModelOffsetY3": 0,
  "attachWorldModelOffsetZ3": 0,
  "attachWorldModelOffsetX4": 0,
  "attachWorldModelOffsetY4": 0,
  "attachWorldModelOffsetZ4": 0,
  "attachWorldModelOffsetX5": 0,
  "attachWorldModelOffsetY5": 0,
  "attachWorldModelOffsetZ5": 0,
  "attachWorldModelOffsetX6": 0,
  "attachWorldModelOffsetY6": 0,
  "attachWorldModelOffsetZ6": 0,
  "attachWorldModelOffsetX7": 0,
  "attachWorldModelOffsetY7": 0,
  "attachWorldModelOffsetZ7": 0,
  "attachWorldModelOffsetX8": 0,
  "attachWorldModelOffsetY8": 0,
  "attachWorldModelOffsetZ8": 0,
  "attachViewModelOffsetPitch1": 0,
  "attachViewModelOffsetYaw1": 0,
  "attachViewModelOffsetRoll1": 0,
  "attachViewModelOffsetPitch2": 0,
  "attachViewModelOffsetYaw2": 0,
  "attachViewModelOffsetRoll2": 0,
  "attachViewModelOffsetPitch3": 0,
  "attachViewModelOffsetYaw3": 0,
  "attachViewModelOffsetRoll3": 0,
  "attachViewModelOffsetPitch4": 0,
  "attachViewModelOffsetYaw4": 0,
  "attachViewModelOffsetRoll4": 0,
  "attachViewModelOffsetPitch5": 0,
  "attachViewModelOffsetYaw5": 0,
  "attachViewModelOffsetRoll5": 0,
  "attachViewModelOffsetPitch6": 0,
  "attachViewModelOffsetYaw6": 0,
  "attachViewModelOffsetRoll6": 0,
  "attachViewModelOffsetPitch7": 0,
  "attachViewModelOffsetYaw7": 0,
  "attachViewModelOffsetRoll7": 0,
  "attachViewModelOffsetPitch8": 0,
  "attachViewModelOffsetYaw8": 0,
  "attachViewModelOffsetRoll8": 0,
  "attachWorldModelOffsetPitch1": 0,
  "attachWorldModelOffsetYaw1": 0,
  "attachWorldModelOffsetRoll1": 0,
  "attachWorldModelOffsetPitch2": 0,
  "attachWorldModelOffsetYaw2": 0,
  "attachWorldModelOffsetRoll2": 0,
  "attachWorldModelOffsetPitch3": 0,
  "attachWorldModelOffsetYaw3": 0,
  "attachWorldModelOffsetRoll3": 0,
  "attachWorldModelOffsetPitch4": 0,
  "attachWorldModelOffsetYaw4": 0,
  "attachWorldModelOffsetRoll4": 0,
  "attachWorldModelOffsetPitch5": 0,
  "attachWorldModelOffsetYaw5": 0,
  "attachWorldModelOffsetRoll5": 0,
  "attachWorldModelOffsetPitch6": 0,
  "attachWorldModelOffsetYaw6": 0,
  "attachWorldModelOffsetRoll6": 0,
  "attachWorldModelOffsetPitch7": 0,
  "attachWorldModelOffsetYaw7": 0,
  "attachWorldModelOffsetRoll7": 0,
  "attachWorldModelOffsetPitch8": 0,
  "attachWorldModelOffsetYaw8": 0,
  "attachWorldModelOffsetRoll8": 0,
  "stowedModelOffsetsF": 0,
  "stowedModelOffsetsR": 0,
  "stowedModelOffsetsU": 0,
  "stowedModelOffsetsPitch": 0,
  "stowedModelOffsetsYaw": 0,
  "stowedModelOffsetsRoll": 0,
  "worldClipModel": "",
  "rocketModel": "",
  "AdditionalMeleeModel": "",
  "useDroppedModelAsStowed": 0,
  "projectileModel": "t5_weapon_crossbow_bolt",
  "notetrackSoundMap": "",
  "idleAnim": "viewmodel_m67_idle",
  "idleAnimLeft": "",
  "emptyIdleAnim": "viewmodel_m67_idle",
  "emptyIdleAnimLeft": "",
  "fireIntroAnim": "",
  "fireAnim": "viewmodel_m67_throw",
  "fireAnimLeft": "",
  "holdFireAnim": "viewmodel_m67_pullpin",
  "lastShotAnim": "viewmodel_m67_throw",
  "lastShotAnimLeft": "",
  "flourishAnim": "",
  "flourishAnimLeft": "",
  "detonateAnim": "",
  "rechamberAnim": "",
  "meleeAnim": "",
  "meleeAnimEmpty": "",
  "meleeAnim1": "",
  "meleeAnim2": "",
  "meleeAnim3": "",
  "meleeChargeAnim": "",
  "meleeChargeAnimEmpty": "",
  "reloadAnim": "",
  "reloadAnimRight": "",
  "reloadAnimLeft": "",
  "reloadEmptyAnim": "",
  "reloadEmptyAnimLeft": "",
  "reloadStartAnim": "",
  "reloadEndAnim": "",
  "reloadQuickAnim": "",
  "reloadQuickEmptyAnim": "",
  "raiseAnim": "viewmodel_m67_idle",
  "dropAnim": "viewmodel_m67_idle",
  "firstRaiseAnim": "",
  "altRaiseAnim": "viewmodel_m67_pickup_livenade",
  "altDropAnim": "viewmodel_m67_idle",
  "quickRaiseAnim": "",
  "quickDropAnim": "",
  "emptyRaiseAnim": "",
  "emptyDropAnim": "",
  "sprintInAnim": "",
  "sprintLoopAnim": "",
  "sprintOutAnim": "",
  "sprintInEmptyAnim": "",
  "sprintLoopEmptyAnim": "",
  "sprintOutEmptyAnim": "",
  "lowReadyInAnim": "",
  "lowReadyLoopAnim": "",
  "lowReadyOutAnim": "",
  "contFireInAnim": "",
  "contFireLoopAnim": "",
  "contFireOutAnim": "",
  "crawlInAnim": "",
  "crawlForwardAnim": "",
  "crawlBackAnim": "",
  "crawlRightAnim": "",
  "crawlLeftAnim": "",
  "crawlOutAnim": "",
  "crawlEmptyInAnim": "",
  "crawlEmptyForwardAnim": "",
  "crawlEmptyBackAnim": "",
  "crawlEmptyRightAnim": "",
  "crawlEmptyLeftAnim": "",
  "crawlEmptyOutAnim": "",
  "deployAnim": "",
  "nightVisionWearAnim": "",
  "nightVisionRemoveAnim": "",
  "adsFireAnim": "",
  "adsLastShotAnim": "",
  "adsRechamberAnim": "",
  "adsUpAnim": "",
  "adsDownAnim": "",
  "adsUpOtherScopeAnim": "",
  "adsFireIntroAnim": "",
  "breakdownAnim": "",
  "dtp_in": "",
  "dtp_loop": "",
  "dtp_out": "",
  "dtp_empty_in": "",
  "dtp_empty_loop": "",
  "dtp_empty_out": "",
  "mantleAnim": "",
  "sprintCameraAnim": "",
  "dtpInCameraAnim": "",
  "dtpLoopCameraAnim": "",
  "dtpOutCameraAnim": "",
  "mantleCameraAnim": "",
  "pickupSound": "",
  "pickupSoundPlayer": "",
  "ammoPickupSound": "",
  "ammoPickupSoundPlayer": "",
  "projectileSound": "",
  "pullbackSound": "",
  "pullbackSoundPlayer": "",
  "fireSound": "",
  "crackSound": "",
  "whizbySound": "",
  "fireSoundPlayer": "",
  "loopFireSound": "",
  "loopFireSoundPlayer": "",
  "loopFireEndSound": "",
  "loopFireEndSoundPlayer": "",
  "startFireSound": "",
  "stopFireSound": "",
  "killcamStartFireSound": "",
  "startFireSoundPlayer": "",
  "stopFireSoundPlayer": "",
  "killcamStartFireSoundPlayer": "",
  "lastShotSound": "",
  "lastShotSoundPlayer": "",
  "emptyFireSound": "",
  "emptyFireSoundPlayer": "",
  "meleeSwipeSound": "",
  "meleeSwipeSoundPlayer": "",
  "meleeHitSound": "",
  "meleeMissSound": "",
  "rechamberSound": "",
  "rechamberSoundPlayer": "",
  "reloadSound": "",
  "reloadSoundPlayer": "",
  "reloadEmptySound": "",
  "reloadEmptySoundPlayer": "",
  "reloadStartSound": "",
  "reloadStartSoundPlayer": "",
  "reloadEndSound": "",
  "reloadEndSoundPlayer": "",
  "rotateLoopSound": "",
  "rotateLoopSoundPlayer": "",
  "rotateStopSound": "",
  "rotateStopSoundPlayer": "",
  "deploySound": "",
  "deploySoundPlayer": "",
  "finishDeploySound": "",
  "finishDeploySoundPlayer": "",
  "breakdownSound": "",
  "breakdownSoundPlayer": "",
  "finishBreakdownSound": "",
  "finishBreakdownSoundPlayer": "",
  "detonateSound": "",
  "detonateSoundPlayer": "",
  "nightVisionWearSound": "",
  "nightVisionWearSoundPlayer": "",
  "nightVisionRemoveSound": "",
  "nightVisionRemoveSoundPlayer": "",
  "raiseSound": "",
  "raiseSoundPlayer": "",
  "firstRaiseSound": "",
  "firstRaiseSoundPlayer": "",
  "altSwitchSound": "",
  "altSwitchSoundPlayer": "",
  "adsRaiseSoundPlayer": "",
  "adsLowerSoundPlayer": "",
  "putawaySound": "",
  "putawaySoundPlayer": "",
  "overheatSound": "",
  "overheatSoundPlayer": "",
  "adsZoomSound": "",
  "bounceSound": "",
  "spinLoopSound": "",
  "spinLoopSoundPlayer": "",
  "startSpinSound": "",
  "startSpinSoundPlayer": "",
  "stopSpinSound": "",
  "stopSpinSoundPlayer": "",
  "stackSound": "",
  "projExplosionSound": "wpn_grenade_explode",
  "projDudSound": "",
  "mortarShellSound": "",
  "tankShellSound": "",
  "projIgnitionSound": "",
  "viewFlashEffect": "",
  "worldFlashEffect": "",
  "barrelCooldownEffect": "",
  "viewShellEjectEffect": "",
  "worldShellEjectEffect": "",
  "viewLastShotEjectEffect": "",
  "worldLastShotEjectEffect": "",
  "projExplosionEffect": "",
  "projExplosionEffectForceNormalUp": 0,
  "projExplosionEffect2": "",
  "projExplosionEffect2ForceNormalUp": 0,
  "projExplosionEffect3": "",
  "projExplosionEffect3ForceNormalUp": 0,
  "projExplosionEffect4": "",
  "projExplosionEffect4ForceNormalUp": 0,
  "projExplosionEffect5": "",
  "projExplosionEffect5ForceNormalUp": 0,
  "projDudEffect": "",
  "projTrailEffect": "",
  "projIgnitionEffect": "",
  "tagFx_preparationEffect": "",
  "tagFlash_preparationEffect": "",
  "meleeSwipeEffect": "",
  "meleeImpactEffect": "",
  "meleeImpactNoBloodEffect": "",
  "ammoCounterClip": "None",
  "startAmmo": 1,
  "ammoDisplayName": "",
  "ammoName": "explosive_bolt",
  "clipName": "explosive_bolt",
  "maxAmmo": 2,
  "clipSize": 2,
  "shotCount": 0,
  "sharedAmmoCapName": "WEAPON_EXPLOSIVE_BOLT",
  "sharedAmmoCap": 2,
  "unlimitedAmmo": 0,
  "ammoCountClipRelative": 0,
  "sharedAmmo": 0,
  "overheatWeapon": 0,
  "overheatRate": 0,
  "cooldownRate": 0,
  "overheatEndVal": 0,
  "clipOnly": 1,
  "suppressAmmoReserveDisplay": 0,
  "reloadAmmoAdd": 0,
  "reloadStartAdd": 0,
  "lowAmmoWarningThreshold": 0.33,
  "damage": 5,
  "minDamage": 0,
  "maxDamageRange": 999999,
  "minDamageRange": 999999,
  "playerDamage": 0,
  "minPlayerDamage": 0,
  "destabilizationRateTime": 0,
  "destabilizationCurvatureMax": 0,
  "destabilizeDistance": 0,
  "explosionRadius": 100,
  "explosionRadiusMin": 0,
  "indicatorRadius": 100,
  "explosionInnerDamage": 150,
  "explosionOuterDamage": 25,
  "damageConeAngle": 180,
  "projExplosionType": "grenade",
  "projImpactExplode": 0,
  "bulletImpactExplode": 0,
  "explosionTag": "tag_explosive",
  "explosionCameraShakeScale": 0.5,
  "explosionCameraShakeDuration": 500,
  "explosionCameraShakeRadius": 800,
  "locNone": 1,
  "locHelmet": 1,
  "locHead": 1,
  "locNeck": 1,
  "locTorsoUpper": 1,
  "locTorsoMid": 1,
  "locTorsoLower": 1,
  "locRightArmUpper": 1,
  "locRightArmLower": 1,
  "locRightHand": 1,
  "locLeftArmUpper": 1,
  "locLeftArmLower": 1,
  "locLeftHand": 1,
  "locRightLegUpper": 1,
  "locRightLegLower": 1,
  "locRightFoot": 1,
  "locLeftLegUpper": 1,
  "locLeftLegLower": 1,
  "locLeftFoot": 1,
  "locGun": 0,
  "maxGibDistance": 0,
  "meleeDamage": 0,
  "meleeDelay": 0,
  "meleeChargeDelay": 0,
  "meleeTime": 0,
  "meleeChargeTime": 0,
  "meleeChargeRange": 0,
  "useAsMelee": 0,
  "detonateTime": 0.1,
  "detonateDelay": 0.1,
  "fuseTime": 1,
  "aifuseTime": 5,
  "cookOffHold": 0,
  "throwBack": 0,
  "retrievable": 0,
  "dieOnRespawn": 0,
  "forceBounce": 0,
  "showIndicator": 1,
  "projectileSpeed": 900,
  "projectileSpeedRelativeUp": 120,
  "projectileSpeedUp": 0,
  "projectileSpeedForward": 0,
  "projectileTakeParentVel": 0,
  "projectileActivateDist": 0,
  "projectileLifetime": 0,
  "projectileCurvature": 0,
  "stickiness": "Stick to all",
  "rotateType": "Rotate both axis, grenade style",
  "hasDetonator": 0,
  "plantable": 0,
  "timedDetonation": 1,
  "rotate": 1,
  "holdButtonToThrow": 0,
  "offhandHoldIsCancelable": 0,
  "freezeMovementWhenFiring": 0,
  "bDisallowAtMatchStart": 1,
  "isHoldUseGrenade": 0,
  "parallelDefaultBounce": 0.5,
  "parallelAsphaltBounce": 0.6,
  "parallelBarkBounce": 0.6,
  "parallelBrickBounce": 0.6,
  "parallelCarpetBounce": 0.6,
  "parallelCeramicBounce": 0.5,
  "parallelClothBounce": 0.2,
  "parallelConcreteBounce": 0.6,
  "parallelCushionBounce": 0.5,
  "parallelDirtBounce": 0.45,
  "parallelFleshBounce": 0.2,
  "parallelFoliageBounce": 0.05,
  "parallelFruitBounce": 0.5,
  "parallelGlassBounce": 0.4,
  "parallelGrassBounce": 0.35,
  "parallelGravelBounce": 0.5,
  "parallelIceBounce": 0.6,
  "parallelMetalBounce": 0.6,
  "parallelMudBounce": 0.2,
  "parallelPaintedMetalBounce": 0.5,
  "parallelPaperBounce": 0.2,
  "parallelPlasterBounce": 0.5,
  "parallelPlasticBounce": 0.5,
  "parallelRockBounce": 0.6,
  "parallelRubberBounce": 0.5,
  "parallelSandBounce": 0.3,
  "parallelSnowBounce": 0.2,
  "parallelWaterBounce": 0.2,
  "parallelWoodBounce": 0.6,
  "parallelRiotShieldBounce": 0.5,
  "perpendicularDefaultBounce": 0.25,
  "perpendicularAsphaltBounce": 0.25,
  "perpendicularBarkBounce": 0.25,
  "perpendicularBrickBounce": 0.25,
  "perpendicularCarpetBounce": 0.25,
  "perpendicularCeramicBounce": 0.5,
  "perpendicularClothBounce": 0.2,
  "perpendicularConcreteBounce": 0.25,
  "perpendicularCushionBounce": 0.5,
  "perpendicularDirtBounce": 0.225,
  "perpendicularFleshBounce": 0.2,
  "perpendicularFoliageBounce": 0.05,
  "perpendicularFruitBounce": 0.5,
  "perpendicularGlassBounce": 0.2,
  "perpendicularGrassBounce": 0.15,
  "perpendicularGravelBounce": 0.25,
  "perpendicularIceBounce": 0.3,
  "perpendicularMetalBounce": 0.25,
  "perpendicularMudBounce": 0.1,
  "perpendicularPaintedMetalBounce": 0.5,
  "perpendicularPaperBounce": 0.2,
  "perpendicularPlasterBounce": 0.25,
  "perpendicularPlasticBounce": 0.5,
  "perpendicularRockBounce": 0.25,
  "perpendicularRubberBounce": 0.5,
  "perpendicularSandBounce": 0.1,
  "perpendicularSnowBounce": 0.1,
  "perpendicularWaterBounce": 0.2,
  "perpendicularWoodBounce": 0.25,
  "perpendicularRiotShieldBounce": 0.5,
  "projectileRed": 0,
  "projectileGreen": 0,
  "projectileBlue": 0,
  "guidedMissileType": "None",
  "maxSteeringAccel": 0,
  "projIgnitionDelay": 0,
  "tracerType": "",
  "enemyTracerType": "",
  "throwBackType": "",
  "reticleCenter": "reticle_center_cross",
  "reticleSide": "",
  "reticleCenterSize": 32,
  "reticleSideSize": 16,
  "reticleMinOfs": 4,
  "activeReticleType": "None",
  "adsMoveSpeedScale": 0,
  "adsSwayMaxAngle": 0,
  "adsSwayLerpSpeed": 0,
  "adsSwayPitchScale": 0,
  "adsSwayYawScale": 0,
  "adsSwayHorizScale": 0,
  "adsSwayVertScale": 0,
  "aimDownSight": 0,
  "adsViewErrorMin": 0,
  "adsViewErrorMax": 0,
  "adsFire": 0,
  "antiQuickScope": 0,
  "adsTransInTime": 0,
  "adsTransOutTime": 0,
  "adsIdleAmount": 0,
  "adsIdleSpeed": 0,
  "adsZoomFov1": 0,
  "adsZoomFov2": 0,
  "adsZoomFov3": 0,
  "adsZoomInFrac": 0,
  "adsZoomOutFrac": 0,
  "adsOverlayShader": "",
  "adsOverlayShaderLowRes": "",
  "adsOverlayReticle": "none",
  "adsOverlayInterface": "None",
  "adsOverlayWidth": 0,
  "adsOverlayHeight": 0,
  "adsOverlayAlphaScale": 0,
  "adsBobFactor": 0,
  "adsViewBobMult": 0,
  "holdBreathToSteady": 0,
  "adsAimPitch": 0,
  "adsCrosshairInFrac": 0,
  "adsCrosshairOutFrac": 0,
  "adsReloadTransTime": 0,
  "adsGunKickReducedKickBullets": 0,
  "adsGunKickReducedKickPercent": 0,
  "adsGunKickPitchMin": 0,
  "adsGunKickPitchMax": 0,
  "adsGunKickYawMin": 0,
  "adsGunKickYawMax": 0,
  "adsGunKickAccel": 0,
  "adsGunKickSpeedMax": 0,
  "adsGunKickSpeedDecay": 0,
  "adsGunKickStaticDecay": 0,
  "adsViewKickPitchMin": 0,
  "adsViewKickPitchMax": 0,
  "adsViewKickMinMagnitude": 0,
  "adsViewKickYawMin": 0,
  "adsViewKickYawMax": 0,
  "adsRecoilReductionRate": 0,
  "adsRecoilReductionLimit": 0,
  "adsRecoilReturnRate": 0,
  "adsViewKickCenterSpeed": 0,
  "adsViewKickCenterDuckedScale": 0,
  "adsViewKickCenterProneScale": 0,
  "adsSpread": 0,
  "antiQuickScopeTime": 0,
  "antiQuickScopeScale": 0,
  "antiQuickScopeSpreadMultiplier": 0,
  "antiQuickScopeSpreadMax": 0,
  "antiQuickScopeSwayFactor": 0,
  "adsDofStart": 0,
  "adsDofEnd": 0,
  "mmsWeapon": 0,
  "mmsInScope": 0,
  "mmsFOV": 0,
  "mmsAspect": 0,
  "mmsMaxDist": 0,
  "jamFireTime": 0,
  "tankLifeTime": 0,
  "fireDelay": 0.01,
  "spinUpTime": 0,
  "spinDownTime": 0,
  "introFireTime": 0,
  "fireTime": 0.144,
  "flourishTime": 0.144,
  "lastFireTime": 0,
  "rechamberTime": 0,
  "rechamberBoltTime": 0,
  "holdFireTime": 0.25,
  "burstFireDelay": 0,
  "reloadTime": 2,
  "reloadShowRocketTime": 0,
  "reloadEmptyTime": 0,
  "reloadAddTime": 0,
  "reloadEmptyAddTime": 0,
  "reloadQuickAddTime": 0,
  "reloadQuickEmptyAddTime": 0,
  "reloadStartTime": 0,
  "reloadStartAddTime": 0,
  "reloadEndTime": 0,
  "reloadQuickTime": 0,
  "reloadQuickEmptyTime": 0,
  "dropTime": 0,
  "raiseTime": 0,
  "altDropTime": 0,
  "altRaiseTime": 0.6,
  "quickDropTime": 0.5,
  "quickRaiseTime": 0.5,
  "firstRaiseTime": 0.5,
  "emptyRaiseTime": 0.5,
  "emptyDropTime": 0.5,
  "sprintInTime": 0.5,
  "sprintLoopTime": 0.5,
  "sprintOutTime": 0.5,
  "lowReadyInTime": 0.5,
  "lowReadyLoopTime": 0.5,
  "lowReadyOutTime": 0.5,
  "contFireInTime": 0,
  "contFireLoopTime": 0,
  "contFireOutTime": 0,
  "dtpInTime": 0.5,
  "dtpLoopTime": 0.5,
  "dtpOutTime": 0.5,
  "crawlInTime": 0,
  "crawlForwardTime": 0,
  "crawlBackTime": 0,
  "crawlRightTime": 0,
  "crawlLeftTime": 0,
  "crawlOutFireTime": 0,
  "crawlOutTime": 0,
  "slideInTime": 0.5,
  "deployTime": 0,
  "breakdownTime": 0,
  "nightVisionWearTime": 0.5,
  "nightVisionRemoveTime": 0,
  "pitchConvergenceTime": 0,
  "yawConvergenceTime": 0,
  "suppressionTime": 0,
  "scanPauseTime": 0,
  "altScopeADSTransInTime": 0,
  "altScopeADSTransOutTime": 0,
  "stackFireSpread": 0,
  "hipSpreadStandMin": 0,
  "hipSpreadDuckedMin": 0,
  "hipSpreadProneMin": 0,
  "hipSpreadMax": 0,
  "hipSpreadDuckedMax": 0,
  "hipSpreadProneMax": 0,
  "hipSpreadDecayRate": 0,
  "hipSpreadFireAdd": 0,
  "hipSpreadTurnAdd": 0,
  "hipSpreadMoveAdd": 0,
  "hipSpreadDuckedDecay": 0,
  "hipSpreadProneDecay": 0,
  "aiSpread": 0,
  "playerSpread": 0,
  "hipGunKickReducedKickBullets": 0,
  "hipGunKickReducedKickPercent": 0,
  "hipGunKickPitchMin": 0,
  "hipGunKickPitchMax": 0,
  "hipGunKickYawMin": 0,
  "hipGunKickYawMax": 0,
  "hipGunKickAccel": 0,
  "hipGunKickSpeedMax": 0,
  "hipGunKickSpeedDecay": 0,
  "hipGunKickStaticDecay": 0,
  "hipViewKickPitchMin": 0,
  "hipViewKickPitchMax": 0,
  "hipViewKickMinMagnitude": 0,
  "hipViewKickYawMin": 0,
  "hipViewKickYawMax": 0,
  "hipViewKickCenterSpeed": 0,
  "duckedSprintBobH": 0,
  "duckedSprintBobV": 0,
  "sprintBobH": 6,
  "sprintBobV": 8,
  "dtpBobH": 1,
  "dtpBobV": 1,
  "idleCrouchFactor": 0.5,
  "idleProneFactor": 0.15,
  "gunMaxPitch": 0,
  "gunMaxYaw": 0,
  "swayMaxAngle": 30,
  "swayLerpSpeed": 6,
  "swayPitchScale": 0.1,
  "swayYawScale": 0.1,
  "swayHorizScale": 0.1,
  "swayVertScale": 0.1,
  "swayShellShockScale": 5,
  "hipIdleAmount": 80,
  "hipIdleSpeed": 0,
  "duckedSprintOfsF": 0,
  "duckedSprintOfsR": 0,
  "duckedSprintOfsU": 0,
  "duckedSprintRotP": 0,
  "duckedSprintRotY": 0,
  "duckedSprintRotR": 0,
  "duckedSprintScale": 0,
  "moveSpeedScale": 1,
  "sprintDurationScale": 1,
  "standMoveF": 0,
  "standMoveR": 1,
  "standMoveU": -1.5,
  "standRotP": 0,
  "standRotY": 0,
  "standRotR": 0,
  "duckedOfsF": -2,
  "duckedOfsR": 2,
  "duckedOfsU": -0.2,
  "duckedMoveF": 0,
  "duckedMoveR": 1,
  "duckedMoveU": -1.5,
  "sprintOfsF": 0,
  "sprintOfsR": 0,
  "sprintOfsU": 0,
  "sprintRotP": 0,
  "sprintRotY": 0,
  "sprintRotR": 0,
  "sprintScale": 0.9,
  "lowReadyOfsF": 0,
  "lowReadyOfsR": 0,
  "lowReadyOfsU": 0,
  "lowReadyRotP": 0,
  "lowReadyRotY": 0,
  "lowReadyRotR": 0,
  "rideOfsF": 0,
  "rideOfsR": 0,
  "rideOfsU": 0,
  "rideRotP": 0,
  "rideRotY": 0,
  "rideRotR": 0,
  "dtpOfsF": 0,
  "dtpOfsR": 0,
  "dtpOfsU": 0,
  "dtpRotP": 0,
  "dtpRotY": 0,
  "dtpRotR": 0,
  "dtpScale": 1,
  "mantleOfsF": 0,
  "mantleOfsR": 0,
  "mantleOfsU": 0,
  "mantleRotP": 0,
  "mantleRotY": 0,
  "mantleRotR": 0,
  "slideOfsF": 0,
  "slideOfsR": 0,
  "slideOfsU": 0,
  "slideRotP": 0,
  "slideRotY": 0,
  "slideRotR": 0,
  "duckedRotP": 0,
  "duckedRotY": 0,
  "duckedRotR": 0,
  "proneOfsF": -6,
  "proneOfsR": 3.5,
  "proneOfsU": 0.8,
  "proneMoveF": 0,
  "proneMoveR": 1,
  "proneMoveU": -1.5,
  "proneRotP": 0,
  "proneRotY": 0,
  "proneRotR": 0,
  "strafeMoveF": 0,
  "strafeMoveR": 0,
  "strafeMoveU": 0,
  "strafeRotP": 0,
  "strafeRotY": 0,
  "strafeRotR": 0,
  "posMoveRate": 4,
  "posProneMoveRate": 10,
  "standMoveMinSpeed": 110,
  "duckedMoveMinSpeed": 60,
  "proneMoveMinSpeed": 0,
  "posRotRate": 5,
  "posProneRotRate": 10,
  "standRotMinSpeed": 110,
  "duckedRotMinSpeed": 60,
  "proneRotMinSpeed": 0,
  "animHorRotateInc": 0,
  "cameraShakeScale": 0,
  "ikLeftHandIdlePosF": 0,
  "ikLeftHandIdlePosR": 0,
  "ikLeftHandIdlePosU": 0,
  "ikLeftHandOffsetF": 0,
  "ikLeftHandOffsetR": 0,
  "ikLeftHandOffsetU": 0,
  "ikLeftHandRotationP": 0,
  "ikLeftHandRotationY": 0,
  "ikLeftHandRotationR": 0,
  "ikLeftHandProneOffsetF": 0,
  "ikLeftHandProneOffsetR": 0,
  "ikLeftHandProneOffsetU": 0,
  "ikLeftHandProneRotationP": 0,
  "ikLeftHandProneRotationY": 0,
  "ikLeftHandProneRotationR": 0,
  "ikLeftHandUiViewerOffsetF": 0,
  "ikLeftHandUiViewerOffsetR": 0,
  "ikLeftHandUiViewerOffsetU": 0,
  "ikLeftHandUiViewerRotationP": 0,
  "ikLeftHandUiViewerRotationY": 0,
  "ikLeftHandUiViewerRotationR": 0,
  "lockOnRadius": 0,
  "lockOnSpeed": 0,
  "requireLockonToFire": 0,
  "autoAimRange": 0,
  "aimAssistRange": 0,
  "aimAssistRangeAds": 0,
  "enemyCrosshairRange": 600,
  "crosshairColorChange": 1,
  "useAntiLagRewind": 0,
  "fightDist": 0,
  "maxDist": 0,
  "slide_in": "",
  "script": "",
  "barrelCooldownMinCount": 0,
  "viewFlashOffsetF": 0,
  "viewFlashOffsetR": 0,
  "viewFlashOffsetU": 0,
  "worldFlashOffsetF": 0,
  "worldFlashOffsetR": 0,
  "worldFlashOffsetU": 0,
  "shellCasing": "",
  "shellCasingPlayer": "",
  "standMountedWeapdef": "",
  "crouchMountedWeapdef": "",
  "proneMountedWeapdef": "",
  "viewShellEjectOffsetF": 0,
  "viewShellEjectOffsetR": 0,
  "viewShellEjectOffsetU": 0,
  "worldShellEjectOffsetF": 0,
  "worldShellEjectOffsetR": 0,
  "worldShellEjectOffsetU": 0,
  "viewShellEjectRotationP": 0,
  "viewShellEjectRotationY": 0,
  "viewShellEjectRotationR": 0,
  "worldShellEjectRotationP": 0,
  "worldShellEjectRotationY": 0,
  "worldShellEjectRotationR": 0,
  "ignoreAttachments": 0,
  "mountedModel": "",
  "coolWhileFiring": 0,
  "fuelTankWeapon": 0,
  "damage2": 0,
  "damage3": 0,
  "damage4": 0,
  "damage5": 0,
  "damageRange2": 0,
  "damageRange3": 0,
  "damageRange4": 0,
  "damageRange5": 0,
  "damageDuration": 0,
  "damageInterval": 0,
  "spinRate": 0,
  "applySpinPitch": 0,
  "introFireLength": 0,
  "nightVisionWearTimeFadeOutEnd": 0,
  "nightVisionWearTimePowerUp": 0,
  "nightVisionRemoveTimePowerDown": 0,
  "nightVisionRemoveTimeFadeInStart": 0,
  "noAdsWhenMagEmpty": 0,
  "avoidDropCleanup": 0,
  "stackFire": 0,
  "stackFireAccuracyDecay": 0,
  "mountableWeapon": 0,
  "aimPadding": 0,
  "rifleBullet": 0,
  "armorPiercing": 0,
  "boltAction": 0,
  "shotsBeforeRechamber": 0,
  "useAltTagFlash": 0,
  "isCarriedKillstreakWeapon": 0,
  "rechamberWhileAds": 0,
  "reloadWhileAds": 0,
  "canUseInVehicle": 0,
  "noDropsOrRaises": 0,
  "cancelAutoHolsterWhenEmpty": 0,
  "laserSight": 0,
  "laserSightDuringNightvision": 0,
  "bayonet": 0,
  "dualWield": 0,
  "hideThirdPerson": 0,
  "explodeOnGround": 0,
  "noThirdPersonDropsOrRaises": 0,
  "continuousFire": 0,
  "noQuickDropWhenEmpty": 0,
  "keepCrosshairWhenADS": 0,
  "useOnlyAltWeaoponHideTagsInAltMode": 0,
  "altWeaponAdsOnly": 0,
  "altWeaponDisableSwitching": 0,
  "noPartialReload": 0,
  "segmentedReload": 0,
  "noADSAutoReload": 0,
  "attachmentUnique": "",
  "DualWieldWeapon": "",
  "dropClipAmmoMin": 0,
  "dropClipAmmoMax": 0,
  "blocksProne": 0,
  "silenced": 0,
  "dualMag": 0,
  "infrared": 0,
  "tvguided": 0,
  "airburstWeapon": 0,
  "perks1": 0,
  "perks0": 0,
  "isRollingGrenade": 0,
  "useBallisticPrediction": 0,
  "isValuable": 0,
  "isTacticalInsertion": 0,
  "isReviveWeapon": 0,
  "bUseRigidBodyOnVehicle": 0,
  "timeToAccelerate": 0,
  "sentientImpactExplode": 0,
  "explodeWhenStationary": 0,
  "noCrumpleMissile": 0,
  "keepRolling": 0,
  "isCameraSensor": 0,
  "isAcousticSensor": 0,
  "isLaserSensor": 0,
  "hipReticleSidePos": 0,
  "leftArc": 0,
  "rightArc": 0,
  "topArc": 0,
  "bottomArc": 0,
  "accuracy": 0,
  "maxVertTurnSpeed": 0,
  "maxHorTurnSpeed": 0,
  "minVertTurnSpeed": 0,
  "minHorTurnSpeed": 0,
  "maxRange": 0,
  "playerPositionDist": 0,
  "useHintString": "",
  "dropHintString": "",
  "horizViewJitter": 0,
  "vertViewJitter": 0,
  "cameraShakeDuration": 0,
  "cameraShakeRadius": 0,
  "aiVsAiAccuracyGraph": "",
  "aiVsPlayerAccuracyGraph": "",
  "scanSpeed": 0,
  "scanAccel": 0,
  "flameTableFirstPerson": "",
  "flameTableThirdPerson": "",
  "usingLeftHandProneIK": 0,
  "doGibbing": 0,
  "customFloat0": 0,
  "customFloat1": 0,
  "customFloat2": 0,
  "customBool0": 0,
  "customBool1": 0,
  "customBool2": 0,
  "displayNameEnglish": "Semtex",
  "role": "grenade spawned by crossbow_mp bolts (crossbow_mp.grenadeWeapon); sticks and detonates"
 },
 "knife_ballistic_mp": {
  "displayName": "WEAPON_KNIFE_BALLISTIC",
  "AIOverlayDescription": "",
  "modeName": "",
  "playerAnimType": "ballisticknife",
  "weaponType": "projectile",
  "weaponClass": "pistol",
  "penetrateType": "none",
  "impactType": "bolt",
  "inventoryType": "primary",
  "fireType": "Single Shot",
  "clipType": "bottom",
  "barrelType": "Single",
  "offhandClass": "None",
  "offhandSlot": "None",
  "fireTypeIcon": "hud_mp_firerate_free",
  "hudIcon": "menu_mp_weapons_ballistic_knife",
  "hudIconRatio": "2:1",
  "indicatorIcon": "",
  "indicatorIconRatio": "1:1",
  "ammoCounterIcon": "menu_mp_weapons_ballistic_knife",
  "ammoCounterIconRatio": "1:1",
  "noPing": 1,
  "killIcon": "menu_mp_weapons_ballistic_knife",
  "killIconRatio": "1:1",
  "flipKillIcon": 1,
  "dpadIcon": "",
  "dpadIconRatio": "4:1",
  "noAmmoOnDpadIcon": 1,
  "altWeapon": "",
  "grenadeWeapon": "",
  "dropAmmoMin": 1,
  "dropAmmoMax": 1,
  "stance": "stand",
  "fireRumble": "pistol_fire",
  "meleeImpactRumble": "",
  "reloadRumble": "",
  "explosionRumble": "",
  "parentWeaponName": "",
  "camo": "camo_ballistic_knife",
  "attachments": "",
  "attachmentUniques": "",
  "gunModel": "t6_wpn_ballistic_knife_view",
  "gunModel2": "",
  "gunModel3": "",
  "gunModel4": "",
  "gunModel5": "",
  "gunModel6": "",
  "gunModel7": "",
  "gunModel8": "",
  "gunModel9": "",
  "gunModel10": "",
  "gunModel11": "",
  "gunModel12": "",
  "gunModel13": "",
  "gunModel14": "",
  "gunModel15": "",
  "gunModel16": "",
  "handModel": "",
  "hideTags": "",
  "worldModel": "t6_wpn_ballistic_knife_world",
  "worldModel2": "",
  "worldModel3": "",
  "worldModel4": "",
  "worldModel5": "",
  "worldModel6": "",
  "worldModel7": "",
  "worldModel8": "",
  "worldModel9": "",
  "worldModel10": "",
  "worldModel11": "",
  "worldModel12": "",
  "worldModel13": "",
  "worldModel14": "",
  "worldModel15": "",
  "worldModel16": "",
  "attachViewModel1": "",
  "attachViewModel2": "",
  "attachViewModel3": "",
  "attachViewModel4": "",
  "attachViewModel5": "",
  "attachViewModel6": "",
  "attachViewModel7": "",
  "attachViewModel8": "",
  "attachWorldModel1": "",
  "attachWorldModel2": "",
  "attachWorldModel3": "",
  "attachWorldModel4": "",
  "attachWorldModel5": "",
  "attachWorldModel6": "",
  "attachWorldModel7": "t6_wpn_ballistic_knife_blade_world",
  "attachWorldModel8": "",
  "attachViewModelTag1": "",
  "attachViewModelTag2": "",
  "attachViewModelTag3": "",
  "attachViewModelTag4": "",
  "attachViewModelTag5": "",
  "attachViewModelTag6": "",
  "attachViewModelTag7": "",
  "attachViewModelTag8": "",
  "attachWorldModelTag1": "",
  "attachWorldModelTag2": "",
  "attachWorldModelTag3": "",
  "attachWorldModelTag4": "",
  "attachWorldModelTag5": "",
  "attachWorldModelTag6": "",
  "attachWorldModelTag7": "",
  "attachWorldModelTag8": "",
  "attachViewModelOffsetX1": 0,
  "attachViewModelOffsetY1": 0,
  "attachViewModelOffsetZ1": 0,
  "attachViewModelOffsetX2": 0,
  "attachViewModelOffsetY2": 0,
  "attachViewModelOffsetZ2": 0,
  "attachViewModelOffsetX3": 0,
  "attachViewModelOffsetY3": 0,
  "attachViewModelOffsetZ3": 0,
  "attachViewModelOffsetX4": 0,
  "attachViewModelOffsetY4": 0,
  "attachViewModelOffsetZ4": 0,
  "attachViewModelOffsetX5": 0,
  "attachViewModelOffsetY5": 0,
  "attachViewModelOffsetZ5": 0,
  "attachViewModelOffsetX6": 0,
  "attachViewModelOffsetY6": 0,
  "attachViewModelOffsetZ6": 0,
  "attachViewModelOffsetX7": 3.999,
  "attachViewModelOffsetY7": 0,
  "attachViewModelOffsetZ7": 0,
  "attachViewModelOffsetX8": 0,
  "attachViewModelOffsetY8": 0,
  "attachViewModelOffsetZ8": 0,
  "attachWorldModelOffsetX1": 0,
  "attachWorldModelOffsetY1": 0,
  "attachWorldModelOffsetZ1": 0,
  "attachWorldModelOffsetX2": 0,
  "attachWorldModelOffsetY2": 0,
  "attachWorldModelOffsetZ2": 0,
  "attachWorldModelOffsetX3": 0,
  "attachWorldModelOffsetY3": 0,
  "attachWorldModelOffsetZ3": 0,
  "attachWorldModelOffsetX4": 0,
  "attachWorldModelOffsetY4": 0,
  "attachWorldModelOffsetZ4": 0,
  "attachWorldModelOffsetX5": 0,
  "attachWorldModelOffsetY5": 0,
  "attachWorldModelOffsetZ5": 0,
  "attachWorldModelOffsetX6": 0,
  "attachWorldModelOffsetY6": 0,
  "attachWorldModelOffsetZ6": 0,
  "attachWorldModelOffsetX7": -10.21,
  "attachWorldModelOffsetY7": -0.498,
  "attachWorldModelOffsetZ7": -3.951,
  "attachWorldModelOffsetX8": 0,
  "attachWorldModelOffsetY8": 0,
  "attachWorldModelOffsetZ8": 0,
  "attachViewModelOffsetPitch1": 0,
  "attachViewModelOffsetYaw1": 0,
  "attachViewModelOffsetRoll1": 0,
  "attachViewModelOffsetPitch2": 0,
  "attachViewModelOffsetYaw2": 0,
  "attachViewModelOffsetRoll2": 0,
  "attachViewModelOffsetPitch3": 0,
  "attachViewModelOffsetYaw3": 0,
  "attachViewModelOffsetRoll3": 0,
  "attachViewModelOffsetPitch4": 0,
  "attachViewModelOffsetYaw4": 0,
  "attachViewModelOffsetRoll4": 0,
  "attachViewModelOffsetPitch5": 0,
  "attachViewModelOffsetYaw5": 0,
  "attachViewModelOffsetRoll5": 0,
  "attachViewModelOffsetPitch6": 0,
  "attachViewModelOffsetYaw6": 0,
  "attachViewModelOffsetRoll6": 0,
  "attachViewModelOffsetPitch7": 0,
  "attachViewModelOffsetYaw7": 0,
  "attachViewModelOffsetRoll7": 0,
  "attachViewModelOffsetPitch8": 0,
  "attachViewModelOffsetYaw8": 0,
  "attachViewModelOffsetRoll8": 0,
  "attachWorldModelOffsetPitch1": 0,
  "attachWorldModelOffsetYaw1": 0,
  "attachWorldModelOffsetRoll1": 0,
  "attachWorldModelOffsetPitch2": 0,
  "attachWorldModelOffsetYaw2": 0,
  "attachWorldModelOffsetRoll2": 0,
  "attachWorldModelOffsetPitch3": 0,
  "attachWorldModelOffsetYaw3": 0,
  "attachWorldModelOffsetRoll3": 0,
  "attachWorldModelOffsetPitch4": 0,
  "attachWorldModelOffsetYaw4": 0,
  "attachWorldModelOffsetRoll4": 0,
  "attachWorldModelOffsetPitch5": 0,
  "attachWorldModelOffsetYaw5": 0,
  "attachWorldModelOffsetRoll5": 0,
  "attachWorldModelOffsetPitch6": 0,
  "attachWorldModelOffsetYaw6": 0,
  "attachWorldModelOffsetRoll6": 0,
  "attachWorldModelOffsetPitch7": 0,
  "attachWorldModelOffsetYaw7": 0,
  "attachWorldModelOffsetRoll7": 0,
  "attachWorldModelOffsetPitch8": 0,
  "attachWorldModelOffsetYaw8": 0,
  "attachWorldModelOffsetRoll8": 0,
  "stowedModelOffsetsF": 0,
  "stowedModelOffsetsR": 0,
  "stowedModelOffsetsU": 0,
  "stowedModelOffsetsPitch": 0,
  "stowedModelOffsetsYaw": 0,
  "stowedModelOffsetsRoll": 0,
  "worldClipModel": "",
  "rocketModel": "t6_wpn_ballistic_knife_blade_view",
  "AdditionalMeleeModel": "t6_wpn_knife_base_world",
  "useDroppedModelAsStowed": 0,
  "projectileModel": "t6_wpn_ballistic_knife_projectile",
  "notetrackSoundMap": "",
  "idleAnim": "viewmodel_ballistic_knife_t6_idle",
  "idleAnimLeft": "",
  "emptyIdleAnim": "viewmodel_ballistic_knife_t6_idle",
  "emptyIdleAnimLeft": "",
  "fireIntroAnim": "",
  "fireAnim": "viewmodel_ballistic_knife_t6_fire",
  "fireAnimLeft": "",
  "holdFireAnim": "",
  "lastShotAnim": "viewmodel_ballistic_knife_t6_fire",
  "lastShotAnimLeft": "",
  "flourishAnim": "",
  "flourishAnimLeft": "",
  "detonateAnim": "",
  "rechamberAnim": "",
  "meleeAnim": "viewmodel_ballistic_knife_t6_melee_charge",
  "meleeAnimEmpty": "",
  "meleeAnim1": "",
  "meleeAnim2": "",
  "meleeAnim3": "",
  "meleeChargeAnim": "viewmodel_ballistic_knife_t6_melee_charge",
  "meleeChargeAnimEmpty": "",
  "reloadAnim": "viewmodel_ballistic_knife_t6_reload_empty",
  "reloadAnimRight": "",
  "reloadAnimLeft": "",
  "reloadEmptyAnim": "",
  "reloadEmptyAnimLeft": "",
  "reloadStartAnim": "",
  "reloadEndAnim": "",
  "reloadQuickAnim": "",
  "reloadQuickEmptyAnim": "",
  "raiseAnim": "viewmodel_ballistic_knife_t6_pullout",
  "dropAnim": "viewmodel_ballistic_knife_t6_putaway",
  "firstRaiseAnim": "viewmodel_ballistic_knife_t6_first_raise",
  "altRaiseAnim": "viewmodel_ballistic_knife_t6_pullout",
  "altDropAnim": "viewmodel_ballistic_knife_t6_putaway",
  "quickRaiseAnim": "viewmodel_ballistic_knife_t6_pullout",
  "quickDropAnim": "viewmodel_ballistic_knife_t6_putaway",
  "emptyRaiseAnim": "viewmodel_ballistic_knife_t6_pullout",
  "emptyDropAnim": "viewmodel_ballistic_knife_t6_putaway",
  "sprintInAnim": "viewmodel_ballistic_knife_t6_sprint_in",
  "sprintLoopAnim": "viewmodel_ballistic_knife_t6_sprint_loop",
  "sprintOutAnim": "viewmodel_ballistic_knife_t6_sprint_out",
  "sprintInEmptyAnim": "",
  "sprintLoopEmptyAnim": "",
  "sprintOutEmptyAnim": "",
  "lowReadyInAnim": "",
  "lowReadyLoopAnim": "",
  "lowReadyOutAnim": "",
  "contFireInAnim": "",
  "contFireLoopAnim": "",
  "contFireOutAnim": "",
  "crawlInAnim": "viewmodel_ballistic_knife_t6_crawl_in",
  "crawlForwardAnim": "viewmodel_ballistic_knife_t6_crawl_forward",
  "crawlBackAnim": "viewmodel_ballistic_knife_t6_crawl_back",
  "crawlRightAnim": "viewmodel_ballistic_knife_t6_crawl_right",
  "crawlLeftAnim": "viewmodel_ballistic_knife_t6_crawl_left",
  "crawlOutAnim": "viewmodel_ballistic_knife_t6_crawl_out",
  "crawlEmptyInAnim": "",
  "crawlEmptyForwardAnim": "",
  "crawlEmptyBackAnim": "",
  "crawlEmptyRightAnim": "",
  "crawlEmptyLeftAnim": "",
  "crawlEmptyOutAnim": "",
  "deployAnim": "",
  "nightVisionWearAnim": "",
  "nightVisionRemoveAnim": "",
  "adsFireAnim": "viewmodel_ballistic_knife_t6_fire",
  "adsLastShotAnim": "viewmodel_ballistic_knife_t6_fire",
  "adsRechamberAnim": "",
  "adsUpAnim": "viewmodel_ballistic_knife_t6_ads_up",
  "adsDownAnim": "viewmodel_ballistic_knife_t6_ads_down",
  "adsUpOtherScopeAnim": "",
  "adsFireIntroAnim": "",
  "breakdownAnim": "",
  "dtp_in": "viewmodel_ballistic_knife_t6_d2p_in",
  "dtp_loop": "viewmodel_ballistic_knife_t6_d2p_loop",
  "dtp_out": "viewmodel_ballistic_knife_t6_d2p_out",
  "dtp_empty_in": "",
  "dtp_empty_loop": "",
  "dtp_empty_out": "",
  "mantleAnim": "",
  "sprintCameraAnim": "",
  "dtpInCameraAnim": "",
  "dtpLoopCameraAnim": "",
  "dtpOutCameraAnim": "",
  "mantleCameraAnim": "",
  "pickupSound": "fly_generic_pickup_npc",
  "pickupSoundPlayer": "fly_generic_pickup_plr",
  "ammoPickupSound": "wpn_ammo_pickup_npc",
  "ammoPickupSoundPlayer": "wpn_ammo_pickup_plr",
  "projectileSound": "",
  "pullbackSound": "",
  "pullbackSoundPlayer": "",
  "fireSound": "wpn_bal_knife_fire_npc",
  "crackSound": "",
  "whizbySound": "",
  "fireSoundPlayer": "wpn_bal_knife_fire_plr",
  "loopFireSound": "",
  "loopFireSoundPlayer": "",
  "loopFireEndSound": "",
  "loopFireEndSoundPlayer": "",
  "startFireSound": "",
  "stopFireSound": "",
  "killcamStartFireSound": "",
  "startFireSoundPlayer": "",
  "stopFireSoundPlayer": "",
  "killcamStartFireSoundPlayer": "",
  "lastShotSound": "",
  "lastShotSoundPlayer": "",
  "emptyFireSound": "wpn_crossbow_dryfire_npc",
  "emptyFireSoundPlayer": "wpn_crossbow_dryfire_plr",
  "meleeSwipeSound": "wpn_melee_whoosh_npc",
  "meleeSwipeSoundPlayer": "wpn_melee_whoosh_plr",
  "meleeHitSound": "wpn_melee_knife_hit_body",
  "meleeMissSound": "wpn_melee_hit_other",
  "rechamberSound": "",
  "rechamberSoundPlayer": "",
  "reloadSound": "",
  "reloadSoundPlayer": "",
  "reloadEmptySound": "",
  "reloadEmptySoundPlayer": "",
  "reloadStartSound": "",
  "reloadStartSoundPlayer": "",
  "reloadEndSound": "",
  "reloadEndSoundPlayer": "",
  "rotateLoopSound": "",
  "rotateLoopSoundPlayer": "",
  "rotateStopSound": "",
  "rotateStopSoundPlayer": "",
  "deploySound": "",
  "deploySoundPlayer": "",
  "finishDeploySound": "",
  "finishDeploySoundPlayer": "",
  "breakdownSound": "",
  "breakdownSoundPlayer": "",
  "finishBreakdownSound": "",
  "finishBreakdownSoundPlayer": "",
  "detonateSound": "",
  "detonateSoundPlayer": "",
  "nightVisionWearSound": "",
  "nightVisionWearSoundPlayer": "",
  "nightVisionRemoveSound": "",
  "nightVisionRemoveSoundPlayer": "",
  "raiseSound": "fly_generic_raise_npc",
  "raiseSoundPlayer": "fly_generic_raise_plr",
  "firstRaiseSound": "fly_generic_first_raise_npc",
  "firstRaiseSoundPlayer": "fly_generic_first_raise_plr",
  "altSwitchSound": "",
  "altSwitchSoundPlayer": "",
  "adsRaiseSoundPlayer": "fly_generic_ads_plr",
  "adsLowerSoundPlayer": "fly_generic_ads_lower_plr",
  "putawaySound": "fly_generic_down_npc",
  "putawaySoundPlayer": "fly_generic_down_plr",
  "overheatSound": "",
  "overheatSoundPlayer": "",
  "adsZoomSound": "",
  "bounceSound": "",
  "spinLoopSound": "",
  "spinLoopSoundPlayer": "",
  "startSpinSound": "",
  "startSpinSoundPlayer": "",
  "stopSpinSound": "",
  "stopSpinSoundPlayer": "",
  "stackSound": "",
  "projExplosionSound": "",
  "projDudSound": "",
  "mortarShellSound": "",
  "tankShellSound": "",
  "projIgnitionSound": "",
  "viewFlashEffect": "weapon/muzzleflashes/fx_crossbow_base",
  "worldFlashEffect": "weapon/muzzleflashes/fx_crossbow_base",
  "barrelCooldownEffect": "",
  "viewShellEjectEffect": "",
  "worldShellEjectEffect": "",
  "viewLastShotEjectEffect": "",
  "worldLastShotEjectEffect": "",
  "projExplosionEffect": "",
  "projExplosionEffectForceNormalUp": 0,
  "projExplosionEffect2": "",
  "projExplosionEffect2ForceNormalUp": 0,
  "projExplosionEffect3": "",
  "projExplosionEffect3ForceNormalUp": 0,
  "projExplosionEffect4": "",
  "projExplosionEffect4ForceNormalUp": 0,
  "projExplosionEffect5": "",
  "projExplosionEffect5ForceNormalUp": 0,
  "projDudEffect": "",
  "projTrailEffect": "weapon/knife_ballistic/fx_trail_knife_ballistic",
  "projIgnitionEffect": "",
  "tagFx_preparationEffect": "",
  "tagFlash_preparationEffect": "",
  "meleeSwipeEffect": "",
  "meleeImpactEffect": "",
  "meleeImpactNoBloodEffect": "",
  "ammoCounterClip": "Shotgun",
  "startAmmo": 4,
  "ammoDisplayName": "",
  "ammoName": "knife_ballistic",
  "clipName": "knife_ballistic",
  "maxAmmo": 3,
  "clipSize": 1,
  "shotCount": 0,
  "sharedAmmoCapName": "",
  "sharedAmmoCap": 0,
  "unlimitedAmmo": 0,
  "ammoCountClipRelative": 0,
  "sharedAmmo": 0,
  "overheatWeapon": 0,
  "overheatRate": 60,
  "cooldownRate": 30,
  "overheatEndVal": 0,
  "clipOnly": 0,
  "suppressAmmoReserveDisplay": 0,
  "reloadAmmoAdd": 0,
  "reloadStartAdd": 0,
  "lowAmmoWarningThreshold": 0.25,
  "damage": 250,
  "minDamage": 0,
  "maxDamageRange": 999999,
  "minDamageRange": 999999,
  "playerDamage": 135,
  "minPlayerDamage": 0,
  "destabilizationRateTime": 0,
  "destabilizationCurvatureMax": 10,
  "destabilizeDistance": 100,
  "explosionRadius": 0,
  "explosionRadiusMin": 0,
  "indicatorRadius": 0,
  "explosionInnerDamage": 0,
  "explosionOuterDamage": 0,
  "damageConeAngle": 180,
  "projExplosionType": "bolt",
  "projImpactExplode": 0,
  "bulletImpactExplode": 0,
  "explosionTag": "",
  "explosionCameraShakeScale": 0.5,
  "explosionCameraShakeDuration": 500,
  "explosionCameraShakeRadius": 512,
  "locNone": 1,
  "locHelmet": 1,
  "locHead": 1,
  "locNeck": 1,
  "locTorsoUpper": 1,
  "locTorsoMid": 1,
  "locTorsoLower": 1,
  "locRightArmUpper": 1,
  "locRightArmLower": 1,
  "locRightHand": 1,
  "locLeftArmUpper": 1,
  "locLeftArmLower": 1,
  "locLeftHand": 1,
  "locRightLegUpper": 1,
  "locRightLegLower": 1,
  "locRightFoot": 1,
  "locLeftLegUpper": 1,
  "locLeftLegLower": 1,
  "locLeftFoot": 1,
  "locGun": 0,
  "maxGibDistance": 0,
  "meleeDamage": 300,
  "meleeDelay": 0.05,
  "meleeChargeDelay": 0.1,
  "meleeTime": 0.9,
  "meleeChargeTime": 1,
  "meleeChargeRange": 116,
  "useAsMelee": 1,
  "detonateTime": 0,
  "detonateDelay": 0,
  "fuseTime": 0,
  "aifuseTime": 0,
  "cookOffHold": 0,
  "throwBack": 0,
  "retrievable": 1,
  "dieOnRespawn": 0,
  "forceBounce": 0,
  "showIndicator": 0,
  "projectileSpeed": 2180,
  "projectileSpeedRelativeUp": 0,
  "projectileSpeedUp": 90,
  "projectileSpeedForward": 0,
  "projectileTakeParentVel": 0,
  "projectileActivateDist": 0,
  "projectileLifetime": 30,
  "projectileCurvature": 0,
  "stickiness": "Stick to all",
  "rotateType": "Rotate both axis, grenade style",
  "hasDetonator": 0,
  "plantable": 0,
  "timedDetonation": 0,
  "rotate": 0,
  "holdButtonToThrow": 0,
  "offhandHoldIsCancelable": 0,
  "freezeMovementWhenFiring": 0,
  "bDisallowAtMatchStart": 0,
  "isHoldUseGrenade": 0,
  "parallelDefaultBounce": 0.5,
  "parallelAsphaltBounce": 0.5,
  "parallelBarkBounce": 0.5,
  "parallelBrickBounce": 0.5,
  "parallelCarpetBounce": 0.5,
  "parallelCeramicBounce": 0.5,
  "parallelClothBounce": 0.5,
  "parallelConcreteBounce": 0.5,
  "parallelCushionBounce": 0.5,
  "parallelDirtBounce": 0.5,
  "parallelFleshBounce": 0.5,
  "parallelFoliageBounce": 0.5,
  "parallelFruitBounce": 0.5,
  "parallelGlassBounce": 0.5,
  "parallelGrassBounce": 0.5,
  "parallelGravelBounce": 0.5,
  "parallelIceBounce": 0.5,
  "parallelMetalBounce": 0.5,
  "parallelMudBounce": 0.5,
  "parallelPaintedMetalBounce": 0.5,
  "parallelPaperBounce": 0.5,
  "parallelPlasterBounce": 0.5,
  "parallelPlasticBounce": 0.5,
  "parallelRockBounce": 0.5,
  "parallelRubberBounce": 0.5,
  "parallelSandBounce": 0.5,
  "parallelSnowBounce": 0.5,
  "parallelWaterBounce": 0.5,
  "parallelWoodBounce": 0.5,
  "parallelRiotShieldBounce": 0.5,
  "perpendicularDefaultBounce": 0.5,
  "perpendicularAsphaltBounce": 0.5,
  "perpendicularBarkBounce": 0.5,
  "perpendicularBrickBounce": 0.5,
  "perpendicularCarpetBounce": 0.5,
  "perpendicularCeramicBounce": 0.5,
  "perpendicularClothBounce": 0.5,
  "perpendicularConcreteBounce": 0.5,
  "perpendicularCushionBounce": 0.5,
  "perpendicularDirtBounce": 0.5,
  "perpendicularFleshBounce": 0.5,
  "perpendicularFoliageBounce": 0.5,
  "perpendicularFruitBounce": 0.5,
  "perpendicularGlassBounce": 0.5,
  "perpendicularGrassBounce": 0.5,
  "perpendicularGravelBounce": 0.5,
  "perpendicularIceBounce": 0.5,
  "perpendicularMetalBounce": 0.5,
  "perpendicularMudBounce": 0.5,
  "perpendicularPaintedMetalBounce": 0.5,
  "perpendicularPaperBounce": 0.5,
  "perpendicularPlasterBounce": 0.5,
  "perpendicularPlasticBounce": 0.5,
  "perpendicularRockBounce": 0.5,
  "perpendicularRubberBounce": 0.5,
  "perpendicularSandBounce": 0.5,
  "perpendicularSnowBounce": 0.5,
  "perpendicularWaterBounce": 0.5,
  "perpendicularWoodBounce": 0.5,
  "perpendicularRiotShieldBounce": 0.5,
  "projectileRed": 0.75,
  "projectileGreen": 0.3,
  "projectileBlue": 0,
  "guidedMissileType": "Ballistic",
  "maxSteeringAccel": 3000,
  "projIgnitionDelay": 0,
  "tracerType": "",
  "enemyTracerType": "",
  "throwBackType": "",
  "reticleCenter": "knife_ballistic_reticle",
  "reticleSide": "",
  "reticleCenterSize": 42,
  "reticleSideSize": 1,
  "reticleMinOfs": 0,
  "activeReticleType": "None",
  "adsMoveSpeedScale": 1,
  "adsSwayMaxAngle": 6,
  "adsSwayLerpSpeed": 7,
  "adsSwayPitchScale": 0.06,
  "adsSwayYawScale": 0.045,
  "adsSwayHorizScale": 0.13,
  "adsSwayVertScale": 0.12,
  "aimDownSight": 0,
  "adsViewErrorMin": 0,
  "adsViewErrorMax": 0,
  "adsFire": 0,
  "antiQuickScope": 0,
  "adsTransInTime": 0.25,
  "adsTransOutTime": 0.25,
  "adsIdleAmount": 28,
  "adsIdleSpeed": 1,
  "adsZoomFov1": 55,
  "adsZoomFov2": 55,
  "adsZoomFov3": 55,
  "adsZoomInFrac": 0.5,
  "adsZoomOutFrac": 0.5,
  "adsOverlayShader": "",
  "adsOverlayShaderLowRes": "",
  "adsOverlayReticle": "none",
  "adsOverlayInterface": "None",
  "adsOverlayWidth": 220,
  "adsOverlayHeight": 220,
  "adsOverlayAlphaScale": 1,
  "adsBobFactor": 0.5,
  "adsViewBobMult": 0.25,
  "holdBreathToSteady": 0,
  "adsAimPitch": 0,
  "adsCrosshairInFrac": 1,
  "adsCrosshairOutFrac": 0.2,
  "adsReloadTransTime": 0.6,
  "adsGunKickReducedKickBullets": 0,
  "adsGunKickReducedKickPercent": 0,
  "adsGunKickPitchMin": 0,
  "adsGunKickPitchMax": 0,
  "adsGunKickYawMin": 0,
  "adsGunKickYawMax": 0,
  "adsGunKickAccel": 0,
  "adsGunKickSpeedMax": 2000,
  "adsGunKickSpeedDecay": 25,
  "adsGunKickStaticDecay": 50,
  "adsViewKickPitchMin": 60,
  "adsViewKickPitchMax": 80,
  "adsViewKickMinMagnitude": 0,
  "adsViewKickYawMin": -40,
  "adsViewKickYawMax": -50,
  "adsRecoilReductionRate": 0,
  "adsRecoilReductionLimit": 0,
  "adsRecoilReturnRate": 0,
  "adsViewKickCenterSpeed": 1500,
  "adsViewKickCenterDuckedScale": 1,
  "adsViewKickCenterProneScale": 1,
  "adsSpread": 0,
  "antiQuickScopeTime": 0,
  "antiQuickScopeScale": 0,
  "antiQuickScopeSpreadMultiplier": 0,
  "antiQuickScopeSpreadMax": 0,
  "antiQuickScopeSwayFactor": 0,
  "adsDofStart": 0,
  "adsDofEnd": 3,
  "mmsWeapon": 0,
  "mmsInScope": 0,
  "mmsFOV": 0,
  "mmsAspect": 0,
  "mmsMaxDist": 0,
  "jamFireTime": 0,
  "tankLifeTime": 0,
  "fireDelay": 0,
  "spinUpTime": 0,
  "spinDownTime": 0,
  "introFireTime": 0,
  "fireTime": 0.5,
  "flourishTime": 0.5,
  "lastFireTime": 0,
  "rechamberTime": 0,
  "rechamberBoltTime": 0,
  "holdFireTime": 0,
  "burstFireDelay": 0,
  "reloadTime": 1.1,
  "reloadShowRocketTime": 0.1,
  "reloadEmptyTime": 1.1,
  "reloadAddTime": 0.3,
  "reloadEmptyAddTime": 0,
  "reloadQuickAddTime": 0,
  "reloadQuickEmptyAddTime": 0,
  "reloadStartTime": 0,
  "reloadStartAddTime": 0,
  "reloadEndTime": 0,
  "reloadQuickTime": 0,
  "reloadQuickEmptyTime": 0,
  "dropTime": 0.35,
  "raiseTime": 0.35,
  "altDropTime": 0,
  "altRaiseTime": 0,
  "quickDropTime": 0.25,
  "quickRaiseTime": 0.25,
  "firstRaiseTime": 1,
  "emptyRaiseTime": 0.25,
  "emptyDropTime": 0.25,
  "sprintInTime": 0.2,
  "sprintLoopTime": 0.6,
  "sprintOutTime": 0.2,
  "lowReadyInTime": 0.5,
  "lowReadyLoopTime": 0.5,
  "lowReadyOutTime": 0.5,
  "contFireInTime": 0,
  "contFireLoopTime": 0,
  "contFireOutTime": 0,
  "dtpInTime": 0.15,
  "dtpLoopTime": 0.6,
  "dtpOutTime": 0.25,
  "crawlInTime": 0.3,
  "crawlForwardTime": 1.1,
  "crawlBackTime": 1,
  "crawlRightTime": 1.2,
  "crawlLeftTime": 1.1,
  "crawlOutFireTime": 0.016,
  "crawlOutTime": 0.1,
  "slideInTime": 0.5,
  "deployTime": 0,
  "breakdownTime": 0,
  "nightVisionWearTime": 0,
  "nightVisionRemoveTime": 0,
  "pitchConvergenceTime": 0,
  "yawConvergenceTime": 0,
  "suppressionTime": 0,
  "scanPauseTime": 0,
  "altScopeADSTransInTime": 0,
  "altScopeADSTransOutTime": 0,
  "stackFireSpread": 15,
  "hipSpreadStandMin": 0,
  "hipSpreadDuckedMin": 0,
  "hipSpreadProneMin": 0,
  "hipSpreadMax": 0,
  "hipSpreadDuckedMax": 0,
  "hipSpreadProneMax": 0,
  "hipSpreadDecayRate": 0,
  "hipSpreadFireAdd": 0,
  "hipSpreadTurnAdd": 0,
  "hipSpreadMoveAdd": 0,
  "hipSpreadDuckedDecay": 0,
  "hipSpreadProneDecay": 0,
  "aiSpread": 0,
  "playerSpread": 0,
  "hipGunKickReducedKickBullets": 0,
  "hipGunKickReducedKickPercent": 0,
  "hipGunKickPitchMin": -30,
  "hipGunKickPitchMax": -35,
  "hipGunKickYawMin": -2,
  "hipGunKickYawMax": 18,
  "hipGunKickAccel": 1000,
  "hipGunKickSpeedMax": 1200,
  "hipGunKickSpeedDecay": 100,
  "hipGunKickStaticDecay": 2,
  "hipViewKickPitchMin": 60,
  "hipViewKickPitchMax": 80,
  "hipViewKickMinMagnitude": 0,
  "hipViewKickYawMin": -40,
  "hipViewKickYawMax": -50,
  "hipViewKickCenterSpeed": 1500,
  "duckedSprintBobH": 0,
  "duckedSprintBobV": 0,
  "sprintBobH": 0,
  "sprintBobV": 0,
  "dtpBobH": 0,
  "dtpBobV": 0,
  "idleCrouchFactor": 0.8,
  "idleProneFactor": 0.6,
  "gunMaxPitch": 2,
  "gunMaxYaw": 8,
  "swayMaxAngle": 5,
  "swayLerpSpeed": 5,
  "swayPitchScale": 2,
  "swayYawScale": 0.25,
  "swayHorizScale": 0.16,
  "swayVertScale": 0.35,
  "swayShellShockScale": 0.1,
  "hipIdleAmount": 25,
  "hipIdleSpeed": 9,
  "duckedSprintOfsF": 0,
  "duckedSprintOfsR": 0,
  "duckedSprintOfsU": 0,
  "duckedSprintRotP": 0,
  "duckedSprintRotY": 0,
  "duckedSprintRotR": 0,
  "duckedSprintScale": 0,
  "moveSpeedScale": 1.02,
  "sprintDurationScale": 1,
  "standMoveF": 0,
  "standMoveR": 0,
  "standMoveU": 0,
  "standRotP": 2,
  "standRotY": 0,
  "standRotR": -2,
  "duckedOfsF": -0.6,
  "duckedOfsR": 0,
  "duckedOfsU": -0.3,
  "duckedMoveF": 0,
  "duckedMoveR": 0,
  "duckedMoveU": 0,
  "sprintOfsF": 0,
  "sprintOfsR": 0,
  "sprintOfsU": 0,
  "sprintRotP": 0,
  "sprintRotY": 0,
  "sprintRotR": 0,
  "sprintScale": 0.8,
  "lowReadyOfsF": 0,
  "lowReadyOfsR": 0,
  "lowReadyOfsU": 0,
  "lowReadyRotP": 0,
  "lowReadyRotY": 0,
  "lowReadyRotR": 0,
  "rideOfsF": 0,
  "rideOfsR": 0,
  "rideOfsU": 0,
  "rideRotP": 0,
  "rideRotY": 0,
  "rideRotR": 0,
  "dtpOfsF": 0,
  "dtpOfsR": 0,
  "dtpOfsU": 0,
  "dtpRotP": 0,
  "dtpRotY": 0,
  "dtpRotR": 0,
  "dtpScale": 1,
  "mantleOfsF": 0,
  "mantleOfsR": 0,
  "mantleOfsU": 0,
  "mantleRotP": 0,
  "mantleRotY": 0,
  "mantleRotR": 0,
  "slideOfsF": 0,
  "slideOfsR": 0,
  "slideOfsU": 0,
  "slideRotP": 0,
  "slideRotY": 0,
  "slideRotR": 0,
  "duckedRotP": 2,
  "duckedRotY": 0,
  "duckedRotR": -2,
  "proneOfsF": 0,
  "proneOfsR": 0,
  "proneOfsU": 0,
  "proneMoveF": 0,
  "proneMoveR": 0,
  "proneMoveU": 0,
  "proneRotP": 0,
  "proneRotY": 3,
  "proneRotR": -3,
  "strafeMoveF": 0,
  "strafeMoveR": -0.25,
  "strafeMoveU": 0,
  "strafeRotP": 0,
  "strafeRotY": 0,
  "strafeRotR": 1.5,
  "posMoveRate": 6,
  "posProneMoveRate": 25,
  "standMoveMinSpeed": 0,
  "duckedMoveMinSpeed": 0,
  "proneMoveMinSpeed": 0,
  "posRotRate": 6,
  "posProneRotRate": 30,
  "standRotMinSpeed": 0,
  "duckedRotMinSpeed": 0,
  "proneRotMinSpeed": 0,
  "animHorRotateInc": 0,
  "cameraShakeScale": 0,
  "ikLeftHandIdlePosF": 0,
  "ikLeftHandIdlePosR": 0,
  "ikLeftHandIdlePosU": 0,
  "ikLeftHandOffsetF": 0,
  "ikLeftHandOffsetR": 0,
  "ikLeftHandOffsetU": 0,
  "ikLeftHandRotationP": 0,
  "ikLeftHandRotationY": 0,
  "ikLeftHandRotationR": 0,
  "ikLeftHandProneOffsetF": 0,
  "ikLeftHandProneOffsetR": 0,
  "ikLeftHandProneOffsetU": 0,
  "ikLeftHandProneRotationP": 0,
  "ikLeftHandProneRotationY": 0,
  "ikLeftHandProneRotationR": 0,
  "ikLeftHandUiViewerOffsetF": 0,
  "ikLeftHandUiViewerOffsetR": 0,
  "ikLeftHandUiViewerOffsetU": 0,
  "ikLeftHandUiViewerRotationP": 0,
  "ikLeftHandUiViewerRotationY": 0,
  "ikLeftHandUiViewerRotationR": 0,
  "lockOnRadius": 60,
  "lockOnSpeed": 2000,
  "requireLockonToFire": 0,
  "autoAimRange": 0,
  "aimAssistRange": 600,
  "aimAssistRangeAds": 600,
  "enemyCrosshairRange": 600,
  "crosshairColorChange": 1,
  "useAntiLagRewind": 1,
  "fightDist": 720,
  "maxDist": 250,
  "slide_in": "",
  "script": "",
  "barrelCooldownMinCount": 0,
  "viewFlashOffsetF": 0,
  "viewFlashOffsetR": 0,
  "viewFlashOffsetU": 0,
  "worldFlashOffsetF": 0,
  "worldFlashOffsetR": 0,
  "worldFlashOffsetU": 0,
  "shellCasing": "",
  "shellCasingPlayer": "",
  "standMountedWeapdef": "",
  "crouchMountedWeapdef": "",
  "proneMountedWeapdef": "",
  "viewShellEjectOffsetF": 0,
  "viewShellEjectOffsetR": 0,
  "viewShellEjectOffsetU": 0,
  "worldShellEjectOffsetF": 0,
  "worldShellEjectOffsetR": 0,
  "worldShellEjectOffsetU": 0,
  "viewShellEjectRotationP": 0,
  "viewShellEjectRotationY": 0,
  "viewShellEjectRotationR": 0,
  "worldShellEjectRotationP": 0,
  "worldShellEjectRotationY": 0,
  "worldShellEjectRotationR": 0,
  "ignoreAttachments": 0,
  "mountedModel": "",
  "coolWhileFiring": 0,
  "fuelTankWeapon": 0,
  "damage2": 0,
  "damage3": 0,
  "damage4": 0,
  "damage5": 0,
  "damageRange2": 0,
  "damageRange3": 0,
  "damageRange4": 0,
  "damageRange5": 0,
  "damageDuration": 0,
  "damageInterval": 0,
  "spinRate": 0,
  "applySpinPitch": 0,
  "introFireLength": 0,
  "nightVisionWearTimeFadeOutEnd": 0,
  "nightVisionWearTimePowerUp": 0,
  "nightVisionRemoveTimePowerDown": 0,
  "nightVisionRemoveTimeFadeInStart": 0,
  "noAdsWhenMagEmpty": 0,
  "avoidDropCleanup": 0,
  "stackFire": 0,
  "stackFireAccuracyDecay": 0,
  "mountableWeapon": 0,
  "aimPadding": 0,
  "rifleBullet": 0,
  "armorPiercing": 0,
  "boltAction": 0,
  "shotsBeforeRechamber": 0,
  "useAltTagFlash": 0,
  "isCarriedKillstreakWeapon": 0,
  "rechamberWhileAds": 0,
  "reloadWhileAds": 0,
  "canUseInVehicle": 0,
  "noDropsOrRaises": 0,
  "cancelAutoHolsterWhenEmpty": 0,
  "laserSight": 0,
  "laserSightDuringNightvision": 0,
  "bayonet": 0,
  "dualWield": 0,
  "hideThirdPerson": 0,
  "explodeOnGround": 0,
  "noThirdPersonDropsOrRaises": 0,
  "continuousFire": 0,
  "noQuickDropWhenEmpty": 0,
  "keepCrosshairWhenADS": 0,
  "useOnlyAltWeaoponHideTagsInAltMode": 0,
  "altWeaponAdsOnly": 0,
  "altWeaponDisableSwitching": 0,
  "noPartialReload": 0,
  "segmentedReload": 0,
  "noADSAutoReload": 0,
  "attachmentUnique": "",
  "DualWieldWeapon": "",
  "dropClipAmmoMin": 0,
  "dropClipAmmoMax": 0,
  "blocksProne": 0,
  "silenced": 0,
  "dualMag": 0,
  "infrared": 0,
  "tvguided": 0,
  "airburstWeapon": 0,
  "perks1": 0,
  "perks0": 0,
  "isRollingGrenade": 0,
  "useBallisticPrediction": 0,
  "isValuable": 0,
  "isTacticalInsertion": 0,
  "isReviveWeapon": 0,
  "bUseRigidBodyOnVehicle": 0,
  "timeToAccelerate": 0,
  "sentientImpactExplode": 0,
  "explodeWhenStationary": 0,
  "noCrumpleMissile": 0,
  "keepRolling": 0,
  "isCameraSensor": 0,
  "isAcousticSensor": 0,
  "isLaserSensor": 0,
  "hipReticleSidePos": 0,
  "leftArc": 0,
  "rightArc": 0,
  "topArc": 0,
  "bottomArc": 0,
  "accuracy": 0,
  "maxVertTurnSpeed": 0,
  "maxHorTurnSpeed": 0,
  "minVertTurnSpeed": 0,
  "minHorTurnSpeed": 0,
  "maxRange": 0,
  "playerPositionDist": 0,
  "useHintString": "",
  "dropHintString": "",
  "horizViewJitter": 0,
  "vertViewJitter": 0,
  "cameraShakeDuration": 0,
  "cameraShakeRadius": 0,
  "aiVsAiAccuracyGraph": "",
  "aiVsPlayerAccuracyGraph": "",
  "scanSpeed": 0,
  "scanAccel": 0,
  "flameTableFirstPerson": "",
  "flameTableThirdPerson": "",
  "usingLeftHandProneIK": 0,
  "doGibbing": 0,
  "customFloat0": 0,
  "customFloat1": 0,
  "customFloat2": 0,
  "customBool0": 0,
  "customBool1": 0,
  "customBool2": 0,
  "displayNameEnglish": "Ballistic Knife",
  "role": "SnS secondary (sas.gsc: giveweapon, setweaponammostock 2)"
 },
 "hatchet_mp": {
  "displayName": "WEAPON_HATCHET",
  "AIOverlayDescription": "",
  "modeName": "",
  "playerAnimType": "hatchet",
  "weaponType": "grenade",
  "weaponClass": "grenade",
  "penetrateType": "none",
  "impactType": "blade",
  "inventoryType": "offhand",
  "fireType": "Full Auto",
  "clipType": "bottom",
  "barrelType": "Single",
  "offhandClass": "Frag Grenade",
  "offhandSlot": "Lethal grenade",
  "fireTypeIcon": "",
  "hudIcon": "hud_hatchet",
  "hudIconRatio": "1:1",
  "indicatorIcon": "",
  "indicatorIconRatio": "4:1",
  "ammoCounterIcon": "",
  "ammoCounterIconRatio": "4:1",
  "noPing": 0,
  "killIcon": "hud_obit_hatchet",
  "killIconRatio": "1:1",
  "flipKillIcon": 1,
  "dpadIcon": "",
  "dpadIconRatio": "4:1",
  "noAmmoOnDpadIcon": 0,
  "altWeapon": "",
  "grenadeWeapon": "",
  "dropAmmoMin": 1,
  "dropAmmoMax": 1,
  "stance": "stand",
  "fireRumble": "",
  "meleeImpactRumble": "",
  "reloadRumble": "",
  "explosionRumble": "",
  "parentWeaponName": "",
  "camo": "",
  "attachments": "",
  "attachmentUniques": "",
  "gunModel": "t6_wpn_hatchet_view",
  "gunModel2": "",
  "gunModel3": "",
  "gunModel4": "",
  "gunModel5": "",
  "gunModel6": "",
  "gunModel7": "",
  "gunModel8": "",
  "gunModel9": "",
  "gunModel10": "",
  "gunModel11": "",
  "gunModel12": "",
  "gunModel13": "",
  "gunModel14": "",
  "gunModel15": "",
  "gunModel16": "",
  "handModel": "",
  "hideTags": "",
  "worldModel": "t6_wpn_hatchet_world",
  "worldModel2": "",
  "worldModel3": "t6_wpn_hatchet_world_retrieve",
  "worldModel4": "",
  "worldModel5": "",
  "worldModel6": "",
  "worldModel7": "",
  "worldModel8": "",
  "worldModel9": "",
  "worldModel10": "",
  "worldModel11": "",
  "worldModel12": "",
  "worldModel13": "",
  "worldModel14": "",
  "worldModel15": "",
  "worldModel16": "",
  "attachViewModel1": "",
  "attachViewModel2": "",
  "attachViewModel3": "",
  "attachViewModel4": "",
  "attachViewModel5": "",
  "attachViewModel6": "",
  "attachViewModel7": "",
  "attachViewModel8": "",
  "attachWorldModel1": "",
  "attachWorldModel2": "",
  "attachWorldModel3": "",
  "attachWorldModel4": "",
  "attachWorldModel5": "",
  "attachWorldModel6": "",
  "attachWorldModel7": "",
  "attachWorldModel8": "",
  "attachViewModelTag1": "",
  "attachViewModelTag2": "",
  "attachViewModelTag3": "",
  "attachViewModelTag4": "",
  "attachViewModelTag5": "",
  "attachViewModelTag6": "",
  "attachViewModelTag7": "",
  "attachViewModelTag8": "",
  "attachWorldModelTag1": "",
  "attachWorldModelTag2": "",
  "attachWorldModelTag3": "",
  "attachWorldModelTag4": "",
  "attachWorldModelTag5": "",
  "attachWorldModelTag6": "",
  "attachWorldModelTag7": "",
  "attachWorldModelTag8": "",
  "attachViewModelOffsetX1": 0,
  "attachViewModelOffsetY1": 0,
  "attachViewModelOffsetZ1": 0,
  "attachViewModelOffsetX2": 0,
  "attachViewModelOffsetY2": 0,
  "attachViewModelOffsetZ2": 0,
  "attachViewModelOffsetX3": 0,
  "attachViewModelOffsetY3": 0,
  "attachViewModelOffsetZ3": 0,
  "attachViewModelOffsetX4": 0,
  "attachViewModelOffsetY4": 0,
  "attachViewModelOffsetZ4": 0,
  "attachViewModelOffsetX5": 0,
  "attachViewModelOffsetY5": 0,
  "attachViewModelOffsetZ5": 0,
  "attachViewModelOffsetX6": 0,
  "attachViewModelOffsetY6": 0,
  "attachViewModelOffsetZ6": 0,
  "attachViewModelOffsetX7": 0,
  "attachViewModelOffsetY7": 0,
  "attachViewModelOffsetZ7": 0,
  "attachViewModelOffsetX8": 0,
  "attachViewModelOffsetY8": 0,
  "attachViewModelOffsetZ8": 0,
  "attachWorldModelOffsetX1": 0,
  "attachWorldModelOffsetY1": 0,
  "attachWorldModelOffsetZ1": 0,
  "attachWorldModelOffsetX2": 0,
  "attachWorldModelOffsetY2": 0,
  "attachWorldModelOffsetZ2": 0,
  "attachWorldModelOffsetX3": 0,
  "attachWorldModelOffsetY3": 0,
  "attachWorldModelOffsetZ3": 0,
  "attachWorldModelOffsetX4": 0,
  "attachWorldModelOffsetY4": 0,
  "attachWorldModelOffsetZ4": 0,
  "attachWorldModelOffsetX5": 0,
  "attachWorldModelOffsetY5": 0,
  "attachWorldModelOffsetZ5": 0,
  "attachWorldModelOffsetX6": 0,
  "attachWorldModelOffsetY6": 0,
  "attachWorldModelOffsetZ6": 0,
  "attachWorldModelOffsetX7": 0,
  "attachWorldModelOffsetY7": 0,
  "attachWorldModelOffsetZ7": 0,
  "attachWorldModelOffsetX8": 0,
  "attachWorldModelOffsetY8": 0,
  "attachWorldModelOffsetZ8": 0,
  "attachViewModelOffsetPitch1": 0,
  "attachViewModelOffsetYaw1": 0,
  "attachViewModelOffsetRoll1": 0,
  "attachViewModelOffsetPitch2": 0,
  "attachViewModelOffsetYaw2": 0,
  "attachViewModelOffsetRoll2": 0,
  "attachViewModelOffsetPitch3": 0,
  "attachViewModelOffsetYaw3": 0,
  "attachViewModelOffsetRoll3": 0,
  "attachViewModelOffsetPitch4": 0,
  "attachViewModelOffsetYaw4": 0,
  "attachViewModelOffsetRoll4": 0,
  "attachViewModelOffsetPitch5": 0,
  "attachViewModelOffsetYaw5": 0,
  "attachViewModelOffsetRoll5": 0,
  "attachViewModelOffsetPitch6": 0,
  "attachViewModelOffsetYaw6": 0,
  "attachViewModelOffsetRoll6": 0,
  "attachViewModelOffsetPitch7": 0,
  "attachViewModelOffsetYaw7": 0,
  "attachViewModelOffsetRoll7": 0,
  "attachViewModelOffsetPitch8": 0,
  "attachViewModelOffsetYaw8": 0,
  "attachViewModelOffsetRoll8": 0,
  "attachWorldModelOffsetPitch1": 0,
  "attachWorldModelOffsetYaw1": 0,
  "attachWorldModelOffsetRoll1": 0,
  "attachWorldModelOffsetPitch2": 0,
  "attachWorldModelOffsetYaw2": 0,
  "attachWorldModelOffsetRoll2": 0,
  "attachWorldModelOffsetPitch3": 0,
  "attachWorldModelOffsetYaw3": 0,
  "attachWorldModelOffsetRoll3": 0,
  "attachWorldModelOffsetPitch4": 0,
  "attachWorldModelOffsetYaw4": 0,
  "attachWorldModelOffsetRoll4": 0,
  "attachWorldModelOffsetPitch5": 0,
  "attachWorldModelOffsetYaw5": 0,
  "attachWorldModelOffsetRoll5": 0,
  "attachWorldModelOffsetPitch6": 0,
  "attachWorldModelOffsetYaw6": 0,
  "attachWorldModelOffsetRoll6": 0,
  "attachWorldModelOffsetPitch7": 0,
  "attachWorldModelOffsetYaw7": 0,
  "attachWorldModelOffsetRoll7": 0,
  "attachWorldModelOffsetPitch8": 0,
  "attachWorldModelOffsetYaw8": 0,
  "attachWorldModelOffsetRoll8": 0,
  "stowedModelOffsetsF": 0,
  "stowedModelOffsetsR": 0,
  "stowedModelOffsetsU": 0,
  "stowedModelOffsetsPitch": 0,
  "stowedModelOffsetsYaw": 0,
  "stowedModelOffsetsRoll": 0,
  "worldClipModel": "",
  "rocketModel": "",
  "AdditionalMeleeModel": "",
  "useDroppedModelAsStowed": 0,
  "projectileModel": "t6_wpn_hatchet_world",
  "notetrackSoundMap": "",
  "idleAnim": "viewmodel_hatchet_idle",
  "idleAnimLeft": "",
  "emptyIdleAnim": "viewmodel_hatchet_idle",
  "emptyIdleAnimLeft": "",
  "fireIntroAnim": "",
  "fireAnim": "viewmodel_hatchet_throw",
  "fireAnimLeft": "",
  "holdFireAnim": "viewmodel_hatchet_idle",
  "lastShotAnim": "viewmodel_hatchet_throw",
  "lastShotAnimLeft": "",
  "flourishAnim": "",
  "flourishAnimLeft": "",
  "detonateAnim": "",
  "rechamberAnim": "",
  "meleeAnim": "",
  "meleeAnimEmpty": "",
  "meleeAnim1": "",
  "meleeAnim2": "",
  "meleeAnim3": "",
  "meleeChargeAnim": "",
  "meleeChargeAnimEmpty": "",
  "reloadAnim": "",
  "reloadAnimRight": "",
  "reloadAnimLeft": "",
  "reloadEmptyAnim": "",
  "reloadEmptyAnimLeft": "",
  "reloadStartAnim": "",
  "reloadEndAnim": "",
  "reloadQuickAnim": "",
  "reloadQuickEmptyAnim": "",
  "raiseAnim": "viewmodel_hatchet_idle",
  "dropAnim": "viewmodel_hatchet_idle",
  "firstRaiseAnim": "",
  "altRaiseAnim": "viewmodel_m67_pickup_livenade",
  "altDropAnim": "viewmodel_hatchet_idle",
  "quickRaiseAnim": "",
  "quickDropAnim": "",
  "emptyRaiseAnim": "",
  "emptyDropAnim": "",
  "sprintInAnim": "",
  "sprintLoopAnim": "",
  "sprintOutAnim": "",
  "sprintInEmptyAnim": "",
  "sprintLoopEmptyAnim": "",
  "sprintOutEmptyAnim": "",
  "lowReadyInAnim": "",
  "lowReadyLoopAnim": "",
  "lowReadyOutAnim": "",
  "contFireInAnim": "",
  "contFireLoopAnim": "",
  "contFireOutAnim": "",
  "crawlInAnim": "",
  "crawlForwardAnim": "",
  "crawlBackAnim": "",
  "crawlRightAnim": "",
  "crawlLeftAnim": "",
  "crawlOutAnim": "",
  "crawlEmptyInAnim": "",
  "crawlEmptyForwardAnim": "",
  "crawlEmptyBackAnim": "",
  "crawlEmptyRightAnim": "",
  "crawlEmptyLeftAnim": "",
  "crawlEmptyOutAnim": "",
  "deployAnim": "",
  "nightVisionWearAnim": "",
  "nightVisionRemoveAnim": "",
  "adsFireAnim": "",
  "adsLastShotAnim": "",
  "adsRechamberAnim": "",
  "adsUpAnim": "",
  "adsDownAnim": "",
  "adsUpOtherScopeAnim": "",
  "adsFireIntroAnim": "",
  "breakdownAnim": "",
  "dtp_in": "",
  "dtp_loop": "",
  "dtp_out": "",
  "dtp_empty_in": "",
  "dtp_empty_loop": "",
  "dtp_empty_out": "",
  "mantleAnim": "",
  "sprintCameraAnim": "",
  "dtpInCameraAnim": "",
  "dtpLoopCameraAnim": "",
  "dtpOutCameraAnim": "",
  "mantleCameraAnim": "",
  "pickupSound": "fly_equipment_pickup_npc",
  "pickupSoundPlayer": "fly_equipment_pickup_plr",
  "ammoPickupSound": "",
  "ammoPickupSoundPlayer": "",
  "projectileSound": "",
  "pullbackSound": "",
  "pullbackSoundPlayer": "",
  "fireSound": "wpn_hatchet_throw_npc",
  "crackSound": "",
  "whizbySound": "",
  "fireSoundPlayer": "wpn_hatchet_throw_plr",
  "loopFireSound": "",
  "loopFireSoundPlayer": "",
  "loopFireEndSound": "",
  "loopFireEndSoundPlayer": "",
  "startFireSound": "",
  "stopFireSound": "",
  "killcamStartFireSound": "",
  "startFireSoundPlayer": "",
  "stopFireSoundPlayer": "",
  "killcamStartFireSoundPlayer": "",
  "lastShotSound": "",
  "lastShotSoundPlayer": "",
  "emptyFireSound": "",
  "emptyFireSoundPlayer": "",
  "meleeSwipeSound": "",
  "meleeSwipeSoundPlayer": "",
  "meleeHitSound": "",
  "meleeMissSound": "",
  "rechamberSound": "",
  "rechamberSoundPlayer": "",
  "reloadSound": "",
  "reloadSoundPlayer": "",
  "reloadEmptySound": "",
  "reloadEmptySoundPlayer": "",
  "reloadStartSound": "",
  "reloadStartSoundPlayer": "",
  "reloadEndSound": "",
  "reloadEndSoundPlayer": "",
  "rotateLoopSound": "",
  "rotateLoopSoundPlayer": "",
  "rotateStopSound": "",
  "rotateStopSoundPlayer": "",
  "deploySound": "",
  "deploySoundPlayer": "",
  "finishDeploySound": "",
  "finishDeploySoundPlayer": "",
  "breakdownSound": "",
  "breakdownSoundPlayer": "",
  "finishBreakdownSound": "",
  "finishBreakdownSoundPlayer": "",
  "detonateSound": "",
  "detonateSoundPlayer": "",
  "nightVisionWearSound": "",
  "nightVisionWearSoundPlayer": "",
  "nightVisionRemoveSound": "",
  "nightVisionRemoveSoundPlayer": "",
  "raiseSound": "",
  "raiseSoundPlayer": "",
  "firstRaiseSound": "",
  "firstRaiseSoundPlayer": "",
  "altSwitchSound": "",
  "altSwitchSoundPlayer": "",
  "adsRaiseSoundPlayer": "",
  "adsLowerSoundPlayer": "",
  "putawaySound": "",
  "putawaySoundPlayer": "",
  "overheatSound": "",
  "overheatSoundPlayer": "",
  "adsZoomSound": "",
  "bounceSound": "wpn_hatchet_bounce",
  "spinLoopSound": "",
  "spinLoopSoundPlayer": "",
  "startSpinSound": "",
  "startSpinSoundPlayer": "",
  "stopSpinSound": "",
  "stopSpinSoundPlayer": "",
  "stackSound": "",
  "projExplosionSound": "fly_hatchet_hit_npc",
  "projDudSound": "",
  "mortarShellSound": "",
  "tankShellSound": "",
  "projIgnitionSound": "",
  "viewFlashEffect": "",
  "worldFlashEffect": "",
  "barrelCooldownEffect": "",
  "viewShellEjectEffect": "",
  "worldShellEjectEffect": "",
  "viewLastShotEjectEffect": "",
  "worldLastShotEjectEffect": "",
  "projExplosionEffect": "",
  "projExplosionEffectForceNormalUp": 0,
  "projExplosionEffect2": "",
  "projExplosionEffect2ForceNormalUp": 0,
  "projExplosionEffect3": "",
  "projExplosionEffect3ForceNormalUp": 0,
  "projExplosionEffect4": "",
  "projExplosionEffect4ForceNormalUp": 0,
  "projExplosionEffect5": "",
  "projExplosionEffect5ForceNormalUp": 0,
  "projDudEffect": "",
  "projTrailEffect": "weapon/grenade/fx_trail_hatchet",
  "projIgnitionEffect": "",
  "tagFx_preparationEffect": "",
  "tagFlash_preparationEffect": "",
  "meleeSwipeEffect": "",
  "meleeImpactEffect": "",
  "meleeImpactNoBloodEffect": "",
  "ammoCounterClip": "None",
  "startAmmo": 1,
  "ammoDisplayName": "",
  "ammoName": "hatchet",
  "clipName": "hatchet",
  "maxAmmo": 4,
  "clipSize": 4,
  "shotCount": 0,
  "sharedAmmoCapName": "",
  "sharedAmmoCap": 0,
  "unlimitedAmmo": 0,
  "ammoCountClipRelative": 0,
  "sharedAmmo": 0,
  "overheatWeapon": 0,
  "overheatRate": 0,
  "cooldownRate": 0,
  "overheatEndVal": 0,
  "clipOnly": 1,
  "suppressAmmoReserveDisplay": 0,
  "reloadAmmoAdd": 0,
  "reloadStartAdd": 0,
  "lowAmmoWarningThreshold": 0.33,
  "damage": 125,
  "minDamage": 0,
  "maxDamageRange": 999999,
  "minDamageRange": 999999,
  "playerDamage": 0,
  "minPlayerDamage": 0,
  "destabilizationRateTime": 0,
  "destabilizationCurvatureMax": 0,
  "destabilizeDistance": 0,
  "explosionRadius": 0,
  "explosionRadiusMin": 0,
  "indicatorRadius": 0,
  "explosionInnerDamage": 0,
  "explosionOuterDamage": 0,
  "damageConeAngle": 0,
  "projExplosionType": "none",
  "projImpactExplode": 0,
  "bulletImpactExplode": 0,
  "explosionTag": "",
  "explosionCameraShakeScale": 0.5,
  "explosionCameraShakeDuration": 500,
  "explosionCameraShakeRadius": 512,
  "locNone": 1,
  "locHelmet": 1,
  "locHead": 1,
  "locNeck": 1,
  "locTorsoUpper": 1,
  "locTorsoMid": 1,
  "locTorsoLower": 1,
  "locRightArmUpper": 1,
  "locRightArmLower": 1,
  "locRightHand": 1,
  "locLeftArmUpper": 1,
  "locLeftArmLower": 1,
  "locLeftHand": 1,
  "locRightLegUpper": 1,
  "locRightLegLower": 1,
  "locRightFoot": 1,
  "locLeftLegUpper": 1,
  "locLeftLegLower": 1,
  "locLeftFoot": 1,
  "locGun": 0,
  "maxGibDistance": 0,
  "meleeDamage": 0,
  "meleeDelay": 0,
  "meleeChargeDelay": 0,
  "meleeTime": 0,
  "meleeChargeTime": 0,
  "meleeChargeRange": 0,
  "useAsMelee": 0,
  "detonateTime": 0,
  "detonateDelay": 0,
  "fuseTime": 0,
  "aifuseTime": 0,
  "cookOffHold": 0,
  "throwBack": 0,
  "retrievable": 1,
  "dieOnRespawn": 1,
  "forceBounce": 0,
  "showIndicator": 0,
  "projectileSpeed": 1600,
  "projectileSpeedRelativeUp": 0,
  "projectileSpeedUp": 40,
  "projectileSpeedForward": 150,
  "projectileTakeParentVel": 0,
  "projectileActivateDist": 0,
  "projectileLifetime": 0,
  "projectileCurvature": 0,
  "stickiness": "Stick to flesh",
  "rotateType": "Rotate one axis, blade style",
  "hasDetonator": 0,
  "plantable": 0,
  "timedDetonation": 0,
  "rotate": 1,
  "holdButtonToThrow": 0,
  "offhandHoldIsCancelable": 1,
  "freezeMovementWhenFiring": 0,
  "bDisallowAtMatchStart": 0,
  "isHoldUseGrenade": 0,
  "parallelDefaultBounce": 0.4,
  "parallelAsphaltBounce": 0.48,
  "parallelBarkBounce": 0.48,
  "parallelBrickBounce": 0.48,
  "parallelCarpetBounce": 0.48,
  "parallelCeramicBounce": 0.4,
  "parallelClothBounce": 0.16,
  "parallelConcreteBounce": 0.48,
  "parallelCushionBounce": 0.4,
  "parallelDirtBounce": 0.36,
  "parallelFleshBounce": 0.16,
  "parallelFoliageBounce": 0.05,
  "parallelFruitBounce": 0.4,
  "parallelGlassBounce": 0.32,
  "parallelGrassBounce": 0.28,
  "parallelGravelBounce": 0.4,
  "parallelIceBounce": 0.5,
  "parallelMetalBounce": 0.48,
  "parallelMudBounce": 0.2,
  "parallelPaintedMetalBounce": 0.4,
  "parallelPaperBounce": 0.2,
  "parallelPlasterBounce": 0.4,
  "parallelPlasticBounce": 0.4,
  "parallelRockBounce": 0.48,
  "parallelRubberBounce": 0.4,
  "parallelSandBounce": 0.3,
  "parallelSnowBounce": 0.2,
  "parallelWaterBounce": 0.2,
  "parallelWoodBounce": 0.48,
  "parallelRiotShieldBounce": 0.4,
  "perpendicularDefaultBounce": 0.2,
  "perpendicularAsphaltBounce": 0.2,
  "perpendicularBarkBounce": 0.2,
  "perpendicularBrickBounce": 0.2,
  "perpendicularCarpetBounce": 0.2,
  "perpendicularCeramicBounce": 0.4,
  "perpendicularClothBounce": 0.16,
  "perpendicularConcreteBounce": 0.2,
  "perpendicularCushionBounce": 0.4,
  "perpendicularDirtBounce": 0.18,
  "perpendicularFleshBounce": 0.16,
  "perpendicularFoliageBounce": 0.05,
  "perpendicularFruitBounce": 0.4,
  "perpendicularGlassBounce": 0.16,
  "perpendicularGrassBounce": 0.12,
  "perpendicularGravelBounce": 0.2,
  "perpendicularIceBounce": 0.25,
  "perpendicularMetalBounce": 0.2,
  "perpendicularMudBounce": 0.1,
  "perpendicularPaintedMetalBounce": 0.4,
  "perpendicularPaperBounce": 0.2,
  "perpendicularPlasterBounce": 0.2,
  "perpendicularPlasticBounce": 0.4,
  "perpendicularRockBounce": 0.2,
  "perpendicularRubberBounce": 0.4,
  "perpendicularSandBounce": 0.1,
  "perpendicularSnowBounce": 0.1,
  "perpendicularWaterBounce": 0.2,
  "perpendicularWoodBounce": 0.2,
  "perpendicularRiotShieldBounce": 0.4,
  "projectileRed": 0,
  "projectileGreen": 0,
  "projectileBlue": 0,
  "guidedMissileType": "None",
  "maxSteeringAccel": 0,
  "projIgnitionDelay": 0,
  "tracerType": "",
  "enemyTracerType": "",
  "throwBackType": "",
  "reticleCenter": "hatchet_reticle",
  "reticleSide": "",
  "reticleCenterSize": 42,
  "reticleSideSize": 16,
  "reticleMinOfs": 4,
  "activeReticleType": "None",
  "adsMoveSpeedScale": 0,
  "adsSwayMaxAngle": 0,
  "adsSwayLerpSpeed": 0,
  "adsSwayPitchScale": 0,
  "adsSwayYawScale": 0,
  "adsSwayHorizScale": 0,
  "adsSwayVertScale": 0,
  "aimDownSight": 0,
  "adsViewErrorMin": 0,
  "adsViewErrorMax": 0,
  "adsFire": 0,
  "antiQuickScope": 0,
  "adsTransInTime": 0,
  "adsTransOutTime": 0,
  "adsIdleAmount": 0,
  "adsIdleSpeed": 0,
  "adsZoomFov1": 0,
  "adsZoomFov2": 0,
  "adsZoomFov3": 0,
  "adsZoomInFrac": 0,
  "adsZoomOutFrac": 0,
  "adsOverlayShader": "",
  "adsOverlayShaderLowRes": "",
  "adsOverlayReticle": "none",
  "adsOverlayInterface": "None",
  "adsOverlayWidth": 0,
  "adsOverlayHeight": 0,
  "adsOverlayAlphaScale": 0,
  "adsBobFactor": 0,
  "adsViewBobMult": 0,
  "holdBreathToSteady": 0,
  "adsAimPitch": 0,
  "adsCrosshairInFrac": 0,
  "adsCrosshairOutFrac": 0,
  "adsReloadTransTime": 0,
  "adsGunKickReducedKickBullets": 0,
  "adsGunKickReducedKickPercent": 0,
  "adsGunKickPitchMin": 0,
  "adsGunKickPitchMax": 0,
  "adsGunKickYawMin": 0,
  "adsGunKickYawMax": 0,
  "adsGunKickAccel": 0,
  "adsGunKickSpeedMax": 0,
  "adsGunKickSpeedDecay": 0,
  "adsGunKickStaticDecay": 0,
  "adsViewKickPitchMin": 0,
  "adsViewKickPitchMax": 0,
  "adsViewKickMinMagnitude": 0,
  "adsViewKickYawMin": 0,
  "adsViewKickYawMax": 0,
  "adsRecoilReductionRate": 0,
  "adsRecoilReductionLimit": 0,
  "adsRecoilReturnRate": 0,
  "adsViewKickCenterSpeed": 0,
  "adsViewKickCenterDuckedScale": 0,
  "adsViewKickCenterProneScale": 0,
  "adsSpread": 0,
  "antiQuickScopeTime": 0,
  "antiQuickScopeScale": 0,
  "antiQuickScopeSpreadMultiplier": 0,
  "antiQuickScopeSpreadMax": 0,
  "antiQuickScopeSwayFactor": 0,
  "adsDofStart": 0,
  "adsDofEnd": 0,
  "mmsWeapon": 0,
  "mmsInScope": 0,
  "mmsFOV": 0,
  "mmsAspect": 0,
  "mmsMaxDist": 0,
  "jamFireTime": 0,
  "tankLifeTime": 0,
  "fireDelay": 0.048,
  "spinUpTime": 0,
  "spinDownTime": 0,
  "introFireTime": 0,
  "fireTime": 0.35,
  "flourishTime": 0.35,
  "lastFireTime": 0,
  "rechamberTime": 0,
  "rechamberBoltTime": 0,
  "holdFireTime": 0,
  "burstFireDelay": 0,
  "reloadTime": 0,
  "reloadShowRocketTime": 0,
  "reloadEmptyTime": 0,
  "reloadAddTime": 0,
  "reloadEmptyAddTime": 0,
  "reloadQuickAddTime": 0,
  "reloadQuickEmptyAddTime": 0,
  "reloadStartTime": 0,
  "reloadStartAddTime": 0,
  "reloadEndTime": 0,
  "reloadQuickTime": 0,
  "reloadQuickEmptyTime": 0,
  "dropTime": 0,
  "raiseTime": 0,
  "altDropTime": 0,
  "altRaiseTime": 0,
  "quickDropTime": 0.2,
  "quickRaiseTime": 0,
  "firstRaiseTime": 0,
  "emptyRaiseTime": 0,
  "emptyDropTime": 0,
  "sprintInTime": 0,
  "sprintLoopTime": 0,
  "sprintOutTime": 0,
  "lowReadyInTime": 0.5,
  "lowReadyLoopTime": 0.5,
  "lowReadyOutTime": 0.5,
  "contFireInTime": 0,
  "contFireLoopTime": 0,
  "contFireOutTime": 0,
  "dtpInTime": 0,
  "dtpLoopTime": 0,
  "dtpOutTime": 0,
  "crawlInTime": 0,
  "crawlForwardTime": 0,
  "crawlBackTime": 0,
  "crawlRightTime": 0,
  "crawlLeftTime": 0,
  "crawlOutFireTime": 0,
  "crawlOutTime": 0,
  "slideInTime": 0,
  "deployTime": 0,
  "breakdownTime": 0,
  "nightVisionWearTime": 0,
  "nightVisionRemoveTime": 0,
  "pitchConvergenceTime": 0,
  "yawConvergenceTime": 0,
  "suppressionTime": 0,
  "scanPauseTime": 0,
  "altScopeADSTransInTime": 0,
  "altScopeADSTransOutTime": 0,
  "stackFireSpread": 0,
  "hipSpreadStandMin": 0,
  "hipSpreadDuckedMin": 0,
  "hipSpreadProneMin": 0,
  "hipSpreadMax": 0,
  "hipSpreadDuckedMax": 0,
  "hipSpreadProneMax": 0,
  "hipSpreadDecayRate": 0,
  "hipSpreadFireAdd": 0,
  "hipSpreadTurnAdd": 0,
  "hipSpreadMoveAdd": 0,
  "hipSpreadDuckedDecay": 0,
  "hipSpreadProneDecay": 0,
  "aiSpread": 0,
  "playerSpread": 0,
  "hipGunKickReducedKickBullets": 0,
  "hipGunKickReducedKickPercent": 0,
  "hipGunKickPitchMin": 0,
  "hipGunKickPitchMax": 0,
  "hipGunKickYawMin": 0,
  "hipGunKickYawMax": 0,
  "hipGunKickAccel": 0,
  "hipGunKickSpeedMax": 0,
  "hipGunKickSpeedDecay": 0,
  "hipGunKickStaticDecay": 0,
  "hipViewKickPitchMin": 0,
  "hipViewKickPitchMax": 0,
  "hipViewKickMinMagnitude": 0,
  "hipViewKickYawMin": 0,
  "hipViewKickYawMax": 0,
  "hipViewKickCenterSpeed": 0,
  "duckedSprintBobH": 0,
  "duckedSprintBobV": 0,
  "sprintBobH": 1,
  "sprintBobV": 1,
  "dtpBobH": 1,
  "dtpBobV": 1,
  "idleCrouchFactor": 0,
  "idleProneFactor": 0,
  "gunMaxPitch": 0,
  "gunMaxYaw": 0,
  "swayMaxAngle": 0,
  "swayLerpSpeed": 1,
  "swayPitchScale": 0,
  "swayYawScale": 0,
  "swayHorizScale": 0,
  "swayVertScale": 0,
  "swayShellShockScale": 0,
  "hipIdleAmount": 0,
  "hipIdleSpeed": 0,
  "duckedSprintOfsF": 0,
  "duckedSprintOfsR": 0,
  "duckedSprintOfsU": 0,
  "duckedSprintRotP": 0,
  "duckedSprintRotY": 0,
  "duckedSprintRotR": 0,
  "duckedSprintScale": 0,
  "moveSpeedScale": 1,
  "sprintDurationScale": 1,
  "standMoveF": 0,
  "standMoveR": 1,
  "standMoveU": -1.5,
  "standRotP": 0,
  "standRotY": 0,
  "standRotR": 0,
  "duckedOfsF": -2,
  "duckedOfsR": 2,
  "duckedOfsU": -0.2,
  "duckedMoveF": 0,
  "duckedMoveR": 1,
  "duckedMoveU": -1.5,
  "sprintOfsF": 0,
  "sprintOfsR": 0,
  "sprintOfsU": 0,
  "sprintRotP": 0,
  "sprintRotY": 0,
  "sprintRotR": 0,
  "sprintScale": 1,
  "lowReadyOfsF": 0,
  "lowReadyOfsR": 0,
  "lowReadyOfsU": 0,
  "lowReadyRotP": 0,
  "lowReadyRotY": 0,
  "lowReadyRotR": 0,
  "rideOfsF": 0,
  "rideOfsR": 0,
  "rideOfsU": 0,
  "rideRotP": 0,
  "rideRotY": 0,
  "rideRotR": 0,
  "dtpOfsF": 0,
  "dtpOfsR": 0,
  "dtpOfsU": 0,
  "dtpRotP": 0,
  "dtpRotY": 0,
  "dtpRotR": 0,
  "dtpScale": 1,
  "mantleOfsF": 0,
  "mantleOfsR": 0,
  "mantleOfsU": 0,
  "mantleRotP": 0,
  "mantleRotY": 0,
  "mantleRotR": 0,
  "slideOfsF": 0,
  "slideOfsR": 0,
  "slideOfsU": 0,
  "slideRotP": 0,
  "slideRotY": 0,
  "slideRotR": 0,
  "duckedRotP": 0,
  "duckedRotY": 0,
  "duckedRotR": 0,
  "proneOfsF": -6,
  "proneOfsR": 3.5,
  "proneOfsU": 0.8,
  "proneMoveF": 0,
  "proneMoveR": 1,
  "proneMoveU": -1.5,
  "proneRotP": 0,
  "proneRotY": 0,
  "proneRotR": 0,
  "strafeMoveF": 0,
  "strafeMoveR": 0,
  "strafeMoveU": 0,
  "strafeRotP": 0,
  "strafeRotY": 0,
  "strafeRotR": 0,
  "posMoveRate": 4,
  "posProneMoveRate": 10,
  "standMoveMinSpeed": 0,
  "duckedMoveMinSpeed": 0,
  "proneMoveMinSpeed": 0,
  "posRotRate": 5,
  "posProneRotRate": 10,
  "standRotMinSpeed": 0,
  "duckedRotMinSpeed": 0,
  "proneRotMinSpeed": 0,
  "animHorRotateInc": 0,
  "cameraShakeScale": 0,
  "ikLeftHandIdlePosF": 0,
  "ikLeftHandIdlePosR": 0,
  "ikLeftHandIdlePosU": 0,
  "ikLeftHandOffsetF": 0,
  "ikLeftHandOffsetR": 0,
  "ikLeftHandOffsetU": 0,
  "ikLeftHandRotationP": 0,
  "ikLeftHandRotationY": 0,
  "ikLeftHandRotationR": 0,
  "ikLeftHandProneOffsetF": 0,
  "ikLeftHandProneOffsetR": 0,
  "ikLeftHandProneOffsetU": 0,
  "ikLeftHandProneRotationP": 0,
  "ikLeftHandProneRotationY": 0,
  "ikLeftHandProneRotationR": 0,
  "ikLeftHandUiViewerOffsetF": 0,
  "ikLeftHandUiViewerOffsetR": 0,
  "ikLeftHandUiViewerOffsetU": 0,
  "ikLeftHandUiViewerRotationP": 0,
  "ikLeftHandUiViewerRotationY": 0,
  "ikLeftHandUiViewerRotationR": 0,
  "lockOnRadius": 0,
  "lockOnSpeed": 0,
  "requireLockonToFire": 0,
  "autoAimRange": 0,
  "aimAssistRange": 1000,
  "aimAssistRangeAds": 1000,
  "enemyCrosshairRange": 1600,
  "crosshairColorChange": 1,
  "useAntiLagRewind": 1,
  "fightDist": 0,
  "maxDist": 0,
  "slide_in": "",
  "script": "",
  "barrelCooldownMinCount": 0,
  "viewFlashOffsetF": 0,
  "viewFlashOffsetR": 0,
  "viewFlashOffsetU": 0,
  "worldFlashOffsetF": 0,
  "worldFlashOffsetR": 0,
  "worldFlashOffsetU": 0,
  "shellCasing": "",
  "shellCasingPlayer": "",
  "standMountedWeapdef": "",
  "crouchMountedWeapdef": "",
  "proneMountedWeapdef": "",
  "viewShellEjectOffsetF": 0,
  "viewShellEjectOffsetR": 0,
  "viewShellEjectOffsetU": 0,
  "worldShellEjectOffsetF": 0,
  "worldShellEjectOffsetR": 0,
  "worldShellEjectOffsetU": 0,
  "viewShellEjectRotationP": 0,
  "viewShellEjectRotationY": 0,
  "viewShellEjectRotationR": 0,
  "worldShellEjectRotationP": 0,
  "worldShellEjectRotationY": 0,
  "worldShellEjectRotationR": 0,
  "ignoreAttachments": 0,
  "mountedModel": "",
  "coolWhileFiring": 0,
  "fuelTankWeapon": 0,
  "damage2": 0,
  "damage3": 0,
  "damage4": 0,
  "damage5": 0,
  "damageRange2": 0,
  "damageRange3": 0,
  "damageRange4": 0,
  "damageRange5": 0,
  "damageDuration": 0,
  "damageInterval": 0,
  "spinRate": 0,
  "applySpinPitch": 0,
  "introFireLength": 0,
  "nightVisionWearTimeFadeOutEnd": 0,
  "nightVisionWearTimePowerUp": 0,
  "nightVisionRemoveTimePowerDown": 0,
  "nightVisionRemoveTimeFadeInStart": 0,
  "noAdsWhenMagEmpty": 0,
  "avoidDropCleanup": 0,
  "stackFire": 0,
  "stackFireAccuracyDecay": 0,
  "mountableWeapon": 0,
  "aimPadding": 0,
  "rifleBullet": 0,
  "armorPiercing": 0,
  "boltAction": 0,
  "shotsBeforeRechamber": 0,
  "useAltTagFlash": 0,
  "isCarriedKillstreakWeapon": 0,
  "rechamberWhileAds": 0,
  "reloadWhileAds": 0,
  "canUseInVehicle": 0,
  "noDropsOrRaises": 0,
  "cancelAutoHolsterWhenEmpty": 0,
  "laserSight": 0,
  "laserSightDuringNightvision": 0,
  "bayonet": 0,
  "dualWield": 0,
  "hideThirdPerson": 0,
  "explodeOnGround": 0,
  "noThirdPersonDropsOrRaises": 0,
  "continuousFire": 0,
  "noQuickDropWhenEmpty": 0,
  "keepCrosshairWhenADS": 0,
  "useOnlyAltWeaoponHideTagsInAltMode": 0,
  "altWeaponAdsOnly": 0,
  "altWeaponDisableSwitching": 0,
  "noPartialReload": 0,
  "segmentedReload": 0,
  "noADSAutoReload": 0,
  "attachmentUnique": "",
  "DualWieldWeapon": "",
  "dropClipAmmoMin": 0,
  "dropClipAmmoMax": 0,
  "blocksProne": 0,
  "silenced": 0,
  "dualMag": 0,
  "infrared": 0,
  "tvguided": 0,
  "airburstWeapon": 0,
  "perks1": 0,
  "perks0": 0,
  "isRollingGrenade": 0,
  "useBallisticPrediction": 0,
  "isValuable": 0,
  "isTacticalInsertion": 0,
  "isReviveWeapon": 0,
  "bUseRigidBodyOnVehicle": 0,
  "timeToAccelerate": 0,
  "sentientImpactExplode": 0,
  "explodeWhenStationary": 0,
  "noCrumpleMissile": 0,
  "keepRolling": 0,
  "isCameraSensor": 0,
  "isAcousticSensor": 0,
  "isLaserSensor": 0,
  "hipReticleSidePos": 0,
  "leftArc": 0,
  "rightArc": 0,
  "topArc": 0,
  "bottomArc": 0,
  "accuracy": 0,
  "maxVertTurnSpeed": 0,
  "maxHorTurnSpeed": 0,
  "minVertTurnSpeed": 0,
  "minHorTurnSpeed": 0,
  "maxRange": 0,
  "playerPositionDist": 0,
  "useHintString": "",
  "dropHintString": "",
  "horizViewJitter": 0,
  "vertViewJitter": 0,
  "cameraShakeDuration": 0,
  "cameraShakeRadius": 0,
  "aiVsAiAccuracyGraph": "",
  "aiVsPlayerAccuracyGraph": "",
  "scanSpeed": 0,
  "scanAccel": 0,
  "flameTableFirstPerson": "",
  "flameTableThirdPerson": "",
  "usingLeftHandProneIK": 0,
  "doGibbing": 0,
  "customFloat0": 0,
  "customFloat1": 0,
  "customFloat2": 0,
  "customBool0": 0,
  "customBool1": 0,
  "customBool2": 0,
  "displayNameEnglish": "Combat Axe",
  "role": "SnS lethal = Combat Axe / \"tomahawk\" (sas.gsc: setoffhandprimaryclass, clip 1, stock 1)"
 },
 "knife_mp": {
  "displayName": "",
  "AIOverlayDescription": "",
  "modeName": "",
  "playerAnimType": "default",
  "weaponType": "melee",
  "weaponClass": "melee",
  "penetrateType": "none",
  "impactType": "none",
  "inventoryType": "melee",
  "fireType": "Full Auto",
  "clipType": "bottom",
  "barrelType": "Single",
  "offhandClass": "None",
  "offhandSlot": "None",
  "fireTypeIcon": "",
  "hudIcon": "",
  "hudIconRatio": "1:1",
  "indicatorIcon": "",
  "indicatorIconRatio": "1:1",
  "ammoCounterIcon": "",
  "ammoCounterIconRatio": "1:1",
  "noPing": 0,
  "killIcon": "",
  "killIconRatio": "1:1",
  "flipKillIcon": 0,
  "dpadIcon": "",
  "dpadIconRatio": "1:1",
  "noAmmoOnDpadIcon": 0,
  "altWeapon": "",
  "grenadeWeapon": "",
  "dropAmmoMin": 0,
  "dropAmmoMax": 0,
  "stance": "stand",
  "fireRumble": "",
  "meleeImpactRumble": "defaultweapon_melee",
  "reloadRumble": "",
  "explosionRumble": "",
  "parentWeaponName": "knife",
  "camo": "",
  "attachments": "",
  "attachmentUniques": "",
  "gunModel": "t6_wpn_knife_melee",
  "gunModel2": "",
  "gunModel3": "",
  "gunModel4": "",
  "gunModel5": "",
  "gunModel6": "",
  "gunModel7": "",
  "gunModel8": "",
  "gunModel9": "",
  "gunModel10": "",
  "gunModel11": "",
  "gunModel12": "",
  "gunModel13": "",
  "gunModel14": "",
  "gunModel15": "",
  "gunModel16": "",
  "handModel": "",
  "hideTags": "",
  "worldModel": "t6_wpn_knife_melee",
  "worldModel2": "",
  "worldModel3": "",
  "worldModel4": "",
  "worldModel5": "",
  "worldModel6": "",
  "worldModel7": "",
  "worldModel8": "",
  "worldModel9": "",
  "worldModel10": "",
  "worldModel11": "",
  "worldModel12": "",
  "worldModel13": "",
  "worldModel14": "",
  "worldModel15": "",
  "worldModel16": "",
  "attachViewModel1": "",
  "attachViewModel2": "",
  "attachViewModel3": "",
  "attachViewModel4": "",
  "attachViewModel5": "",
  "attachViewModel6": "",
  "attachViewModel7": "",
  "attachViewModel8": "",
  "attachWorldModel1": "",
  "attachWorldModel2": "",
  "attachWorldModel3": "",
  "attachWorldModel4": "",
  "attachWorldModel5": "",
  "attachWorldModel6": "",
  "attachWorldModel7": "",
  "attachWorldModel8": "",
  "attachViewModelTag1": "",
  "attachViewModelTag2": "",
  "attachViewModelTag3": "",
  "attachViewModelTag4": "",
  "attachViewModelTag5": "",
  "attachViewModelTag6": "",
  "attachViewModelTag7": "",
  "attachViewModelTag8": "",
  "attachWorldModelTag1": "",
  "attachWorldModelTag2": "",
  "attachWorldModelTag3": "",
  "attachWorldModelTag4": "",
  "attachWorldModelTag5": "",
  "attachWorldModelTag6": "",
  "attachWorldModelTag7": "",
  "attachWorldModelTag8": "",
  "attachViewModelOffsetX1": 0,
  "attachViewModelOffsetY1": 0,
  "attachViewModelOffsetZ1": 0,
  "attachViewModelOffsetX2": 0,
  "attachViewModelOffsetY2": 0,
  "attachViewModelOffsetZ2": 0,
  "attachViewModelOffsetX3": 0,
  "attachViewModelOffsetY3": 0,
  "attachViewModelOffsetZ3": 0,
  "attachViewModelOffsetX4": 0,
  "attachViewModelOffsetY4": 0,
  "attachViewModelOffsetZ4": 0,
  "attachViewModelOffsetX5": 0,
  "attachViewModelOffsetY5": 0,
  "attachViewModelOffsetZ5": 0,
  "attachViewModelOffsetX6": 0,
  "attachViewModelOffsetY6": 0,
  "attachViewModelOffsetZ6": 0,
  "attachViewModelOffsetX7": 0,
  "attachViewModelOffsetY7": 0,
  "attachViewModelOffsetZ7": 0,
  "attachViewModelOffsetX8": 0,
  "attachViewModelOffsetY8": 0,
  "attachViewModelOffsetZ8": 0,
  "attachWorldModelOffsetX1": 0,
  "attachWorldModelOffsetY1": 0,
  "attachWorldModelOffsetZ1": 0,
  "attachWorldModelOffsetX2": 0,
  "attachWorldModelOffsetY2": 0,
  "attachWorldModelOffsetZ2": 0,
  "attachWorldModelOffsetX3": 0,
  "attachWorldModelOffsetY3": 0,
  "attachWorldModelOffsetZ3": 0,
  "attachWorldModelOffsetX4": 0,
  "attachWorldModelOffsetY4": 0,
  "attachWorldModelOffsetZ4": 0,
  "attachWorldModelOffsetX5": 0,
  "attachWorldModelOffsetY5": 0,
  "attachWorldModelOffsetZ5": 0,
  "attachWorldModelOffsetX6": 0,
  "attachWorldModelOffsetY6": 0,
  "attachWorldModelOffsetZ6": 0,
  "attachWorldModelOffsetX7": 0,
  "attachWorldModelOffsetY7": 0,
  "attachWorldModelOffsetZ7": 0,
  "attachWorldModelOffsetX8": 0,
  "attachWorldModelOffsetY8": 0,
  "attachWorldModelOffsetZ8": 0,
  "attachViewModelOffsetPitch1": 0,
  "attachViewModelOffsetYaw1": 0,
  "attachViewModelOffsetRoll1": 0,
  "attachViewModelOffsetPitch2": 0,
  "attachViewModelOffsetYaw2": 0,
  "attachViewModelOffsetRoll2": 0,
  "attachViewModelOffsetPitch3": 0,
  "attachViewModelOffsetYaw3": 0,
  "attachViewModelOffsetRoll3": 0,
  "attachViewModelOffsetPitch4": 0,
  "attachViewModelOffsetYaw4": 0,
  "attachViewModelOffsetRoll4": 0,
  "attachViewModelOffsetPitch5": 0,
  "attachViewModelOffsetYaw5": 0,
  "attachViewModelOffsetRoll5": 0,
  "attachViewModelOffsetPitch6": 0,
  "attachViewModelOffsetYaw6": 0,
  "attachViewModelOffsetRoll6": 0,
  "attachViewModelOffsetPitch7": 0,
  "attachViewModelOffsetYaw7": 0,
  "attachViewModelOffsetRoll7": 0,
  "attachViewModelOffsetPitch8": 0,
  "attachViewModelOffsetYaw8": 0,
  "attachViewModelOffsetRoll8": 0,
  "attachWorldModelOffsetPitch1": 0,
  "attachWorldModelOffsetYaw1": 0,
  "attachWorldModelOffsetRoll1": 0,
  "attachWorldModelOffsetPitch2": 0,
  "attachWorldModelOffsetYaw2": 0,
  "attachWorldModelOffsetRoll2": 0,
  "attachWorldModelOffsetPitch3": 0,
  "attachWorldModelOffsetYaw3": 0,
  "attachWorldModelOffsetRoll3": 0,
  "attachWorldModelOffsetPitch4": 0,
  "attachWorldModelOffsetYaw4": 0,
  "attachWorldModelOffsetRoll4": 0,
  "attachWorldModelOffsetPitch5": 0,
  "attachWorldModelOffsetYaw5": 0,
  "attachWorldModelOffsetRoll5": 0,
  "attachWorldModelOffsetPitch6": 0,
  "attachWorldModelOffsetYaw6": 0,
  "attachWorldModelOffsetRoll6": 0,
  "attachWorldModelOffsetPitch7": 0,
  "attachWorldModelOffsetYaw7": 0,
  "attachWorldModelOffsetRoll7": 0,
  "attachWorldModelOffsetPitch8": 0,
  "attachWorldModelOffsetYaw8": 0,
  "attachWorldModelOffsetRoll8": 0,
  "stowedModelOffsetsF": 0,
  "stowedModelOffsetsR": 0,
  "stowedModelOffsetsU": 0,
  "stowedModelOffsetsPitch": 0,
  "stowedModelOffsetsYaw": 0,
  "stowedModelOffsetsRoll": 0,
  "worldClipModel": "",
  "rocketModel": "",
  "AdditionalMeleeModel": "",
  "useDroppedModelAsStowed": 0,
  "projectileModel": "",
  "notetrackSoundMap": "",
  "idleAnim": "viewmodel_sog_knife_idle_loop",
  "idleAnimLeft": "",
  "emptyIdleAnim": "",
  "emptyIdleAnimLeft": "",
  "fireIntroAnim": "",
  "fireAnim": "",
  "fireAnimLeft": "",
  "holdFireAnim": "",
  "lastShotAnim": "",
  "lastShotAnimLeft": "",
  "flourishAnim": "",
  "flourishAnimLeft": "",
  "detonateAnim": "",
  "rechamberAnim": "",
  "meleeAnim": "viewmodel_M4m203_knife_melee_1",
  "meleeAnimEmpty": "",
  "meleeAnim1": "",
  "meleeAnim2": "",
  "meleeAnim3": "",
  "meleeChargeAnim": "viewmodel_M4m203_knife_melee_2",
  "meleeChargeAnimEmpty": "",
  "reloadAnim": "",
  "reloadAnimRight": "",
  "reloadAnimLeft": "",
  "reloadEmptyAnim": "",
  "reloadEmptyAnimLeft": "",
  "reloadStartAnim": "",
  "reloadEndAnim": "",
  "reloadQuickAnim": "",
  "reloadQuickEmptyAnim": "",
  "raiseAnim": "",
  "dropAnim": "",
  "firstRaiseAnim": "",
  "altRaiseAnim": "",
  "altDropAnim": "",
  "quickRaiseAnim": "",
  "quickDropAnim": "",
  "emptyRaiseAnim": "",
  "emptyDropAnim": "",
  "sprintInAnim": "",
  "sprintLoopAnim": "",
  "sprintOutAnim": "",
  "sprintInEmptyAnim": "",
  "sprintLoopEmptyAnim": "",
  "sprintOutEmptyAnim": "",
  "lowReadyInAnim": "",
  "lowReadyLoopAnim": "",
  "lowReadyOutAnim": "",
  "contFireInAnim": "",
  "contFireLoopAnim": "",
  "contFireOutAnim": "",
  "crawlInAnim": "",
  "crawlForwardAnim": "",
  "crawlBackAnim": "",
  "crawlRightAnim": "",
  "crawlLeftAnim": "",
  "crawlOutAnim": "",
  "crawlEmptyInAnim": "",
  "crawlEmptyForwardAnim": "",
  "crawlEmptyBackAnim": "",
  "crawlEmptyRightAnim": "",
  "crawlEmptyLeftAnim": "",
  "crawlEmptyOutAnim": "",
  "deployAnim": "",
  "nightVisionWearAnim": "",
  "nightVisionRemoveAnim": "",
  "adsFireAnim": "",
  "adsLastShotAnim": "",
  "adsRechamberAnim": "",
  "adsUpAnim": "",
  "adsDownAnim": "",
  "adsUpOtherScopeAnim": "",
  "adsFireIntroAnim": "",
  "breakdownAnim": "",
  "dtp_in": "",
  "dtp_loop": "",
  "dtp_out": "",
  "dtp_empty_in": "",
  "dtp_empty_loop": "",
  "dtp_empty_out": "",
  "mantleAnim": "",
  "sprintCameraAnim": "",
  "dtpInCameraAnim": "",
  "dtpLoopCameraAnim": "",
  "dtpOutCameraAnim": "",
  "mantleCameraAnim": "",
  "pickupSound": "",
  "pickupSoundPlayer": "",
  "ammoPickupSound": "",
  "ammoPickupSoundPlayer": "",
  "projectileSound": "",
  "pullbackSound": "",
  "pullbackSoundPlayer": "",
  "fireSound": "",
  "crackSound": "",
  "whizbySound": "",
  "fireSoundPlayer": "",
  "loopFireSound": "",
  "loopFireSoundPlayer": "",
  "loopFireEndSound": "",
  "loopFireEndSoundPlayer": "",
  "startFireSound": "",
  "stopFireSound": "",
  "killcamStartFireSound": "",
  "startFireSoundPlayer": "",
  "stopFireSoundPlayer": "",
  "killcamStartFireSoundPlayer": "",
  "lastShotSound": "",
  "lastShotSoundPlayer": "",
  "emptyFireSound": "",
  "emptyFireSoundPlayer": "",
  "meleeSwipeSound": "wpn_melee_whoosh_npc",
  "meleeSwipeSoundPlayer": "wpn_melee_whoosh_plr",
  "meleeHitSound": "wpn_melee_knife_hit_body",
  "meleeMissSound": "wpn_melee_hit_other",
  "rechamberSound": "",
  "rechamberSoundPlayer": "",
  "reloadSound": "",
  "reloadSoundPlayer": "",
  "reloadEmptySound": "",
  "reloadEmptySoundPlayer": "",
  "reloadStartSound": "",
  "reloadStartSoundPlayer": "",
  "reloadEndSound": "",
  "reloadEndSoundPlayer": "",
  "rotateLoopSound": "",
  "rotateLoopSoundPlayer": "",
  "rotateStopSound": "",
  "rotateStopSoundPlayer": "",
  "deploySound": "",
  "deploySoundPlayer": "",
  "finishDeploySound": "",
  "finishDeploySoundPlayer": "",
  "breakdownSound": "",
  "breakdownSoundPlayer": "",
  "finishBreakdownSound": "",
  "finishBreakdownSoundPlayer": "",
  "detonateSound": "",
  "detonateSoundPlayer": "",
  "nightVisionWearSound": "",
  "nightVisionWearSoundPlayer": "",
  "nightVisionRemoveSound": "",
  "nightVisionRemoveSoundPlayer": "",
  "raiseSound": "",
  "raiseSoundPlayer": "",
  "firstRaiseSound": "",
  "firstRaiseSoundPlayer": "",
  "altSwitchSound": "",
  "altSwitchSoundPlayer": "",
  "adsRaiseSoundPlayer": "",
  "adsLowerSoundPlayer": "",
  "putawaySound": "",
  "putawaySoundPlayer": "",
  "overheatSound": "",
  "overheatSoundPlayer": "",
  "adsZoomSound": "",
  "bounceSound": "",
  "spinLoopSound": "",
  "spinLoopSoundPlayer": "",
  "startSpinSound": "",
  "startSpinSoundPlayer": "",
  "stopSpinSound": "",
  "stopSpinSoundPlayer": "",
  "stackSound": "",
  "projExplosionSound": "",
  "projDudSound": "",
  "mortarShellSound": "",
  "tankShellSound": "",
  "projIgnitionSound": "",
  "viewFlashEffect": "",
  "worldFlashEffect": "",
  "barrelCooldownEffect": "",
  "viewShellEjectEffect": "",
  "worldShellEjectEffect": "",
  "viewLastShotEjectEffect": "",
  "worldLastShotEjectEffect": "",
  "projExplosionEffect": "",
  "projExplosionEffectForceNormalUp": 0,
  "projExplosionEffect2": "",
  "projExplosionEffect2ForceNormalUp": 0,
  "projExplosionEffect3": "",
  "projExplosionEffect3ForceNormalUp": 0,
  "projExplosionEffect4": "",
  "projExplosionEffect4ForceNormalUp": 0,
  "projExplosionEffect5": "",
  "projExplosionEffect5ForceNormalUp": 0,
  "projDudEffect": "",
  "projTrailEffect": "",
  "projIgnitionEffect": "",
  "tagFx_preparationEffect": "",
  "tagFlash_preparationEffect": "",
  "meleeSwipeEffect": "",
  "meleeImpactEffect": "impacts/fx_flesh_hit_knife_mp",
  "meleeImpactNoBloodEffect": "impacts/fx_flesh_hit_knife_noblood",
  "ammoCounterClip": "None",
  "startAmmo": 0,
  "ammoDisplayName": "",
  "ammoName": "",
  "clipName": "",
  "maxAmmo": 0,
  "clipSize": 0,
  "shotCount": 0,
  "sharedAmmoCapName": "",
  "sharedAmmoCap": 0,
  "unlimitedAmmo": 0,
  "ammoCountClipRelative": 0,
  "sharedAmmo": 0,
  "overheatWeapon": 0,
  "overheatRate": 0,
  "cooldownRate": 0,
  "overheatEndVal": 0,
  "clipOnly": 0,
  "suppressAmmoReserveDisplay": 0,
  "reloadAmmoAdd": 0,
  "reloadStartAdd": 0,
  "lowAmmoWarningThreshold": 0,
  "damage": 0,
  "minDamage": 0,
  "maxDamageRange": 999999,
  "minDamageRange": 999999,
  "playerDamage": 150,
  "minPlayerDamage": 0,
  "destabilizationRateTime": 0,
  "destabilizationCurvatureMax": 0,
  "destabilizeDistance": 0,
  "explosionRadius": 0,
  "explosionRadiusMin": 0,
  "indicatorRadius": 0,
  "explosionInnerDamage": 0,
  "explosionOuterDamage": 0,
  "damageConeAngle": 0,
  "projExplosionType": "grenade",
  "projImpactExplode": 0,
  "bulletImpactExplode": 0,
  "explosionTag": "",
  "explosionCameraShakeScale": 0,
  "explosionCameraShakeDuration": 0,
  "explosionCameraShakeRadius": 0,
  "locNone": 0,
  "locHelmet": 0,
  "locHead": 0,
  "locNeck": 0,
  "locTorsoUpper": 0,
  "locTorsoMid": 0,
  "locTorsoLower": 0,
  "locRightArmUpper": 0,
  "locRightArmLower": 0,
  "locRightHand": 0,
  "locLeftArmUpper": 0,
  "locLeftArmLower": 0,
  "locLeftHand": 0,
  "locRightLegUpper": 0,
  "locRightLegLower": 0,
  "locRightFoot": 0,
  "locLeftLegUpper": 0,
  "locLeftLegLower": 0,
  "locLeftFoot": 0,
  "locGun": 0,
  "maxGibDistance": 0,
  "meleeDamage": 150,
  "meleeDelay": 0.125,
  "meleeChargeDelay": 0.1,
  "meleeTime": 0.8,
  "meleeChargeTime": 1.16,
  "meleeChargeRange": 0,
  "useAsMelee": 0,
  "detonateTime": 0,
  "detonateDelay": 0,
  "fuseTime": 0,
  "aifuseTime": 0,
  "cookOffHold": 0,
  "throwBack": 0,
  "retrievable": 0,
  "dieOnRespawn": 0,
  "forceBounce": 0,
  "showIndicator": 0,
  "projectileSpeed": 0,
  "projectileSpeedRelativeUp": 0,
  "projectileSpeedUp": 0,
  "projectileSpeedForward": 0,
  "projectileTakeParentVel": 0,
  "projectileActivateDist": 0,
  "projectileLifetime": 0,
  "projectileCurvature": 0,
  "stickiness": "Don't stick",
  "rotateType": "Rotate both axis, grenade style",
  "hasDetonator": 0,
  "plantable": 0,
  "timedDetonation": 0,
  "rotate": 0,
  "holdButtonToThrow": 0,
  "offhandHoldIsCancelable": 0,
  "freezeMovementWhenFiring": 0,
  "bDisallowAtMatchStart": 0,
  "isHoldUseGrenade": 0,
  "parallelDefaultBounce": 0,
  "parallelAsphaltBounce": 0,
  "parallelBarkBounce": 0,
  "parallelBrickBounce": 0,
  "parallelCarpetBounce": 0,
  "parallelCeramicBounce": 0,
  "parallelClothBounce": 0,
  "parallelConcreteBounce": 0,
  "parallelCushionBounce": 0,
  "parallelDirtBounce": 0,
  "parallelFleshBounce": 0,
  "parallelFoliageBounce": 0,
  "parallelFruitBounce": 0,
  "parallelGlassBounce": 0,
  "parallelGrassBounce": 0,
  "parallelGravelBounce": 0,
  "parallelIceBounce": 0,
  "parallelMetalBounce": 0,
  "parallelMudBounce": 0,
  "parallelPaintedMetalBounce": 0,
  "parallelPaperBounce": 0,
  "parallelPlasterBounce": 0,
  "parallelPlasticBounce": 0,
  "parallelRockBounce": 0,
  "parallelRubberBounce": 0,
  "parallelSandBounce": 0,
  "parallelSnowBounce": 0,
  "parallelWaterBounce": 0,
  "parallelWoodBounce": 0,
  "parallelRiotShieldBounce": 0,
  "perpendicularDefaultBounce": 0,
  "perpendicularAsphaltBounce": 0,
  "perpendicularBarkBounce": 0,
  "perpendicularBrickBounce": 0,
  "perpendicularCarpetBounce": 0,
  "perpendicularCeramicBounce": 0,
  "perpendicularClothBounce": 0,
  "perpendicularConcreteBounce": 0,
  "perpendicularCushionBounce": 0,
  "perpendicularDirtBounce": 0,
  "perpendicularFleshBounce": 0,
  "perpendicularFoliageBounce": 0,
  "perpendicularFruitBounce": 0,
  "perpendicularGlassBounce": 0,
  "perpendicularGrassBounce": 0,
  "perpendicularGravelBounce": 0,
  "perpendicularIceBounce": 0,
  "perpendicularMetalBounce": 0,
  "perpendicularMudBounce": 0,
  "perpendicularPaintedMetalBounce": 0,
  "perpendicularPaperBounce": 0,
  "perpendicularPlasterBounce": 0,
  "perpendicularPlasticBounce": 0,
  "perpendicularRockBounce": 0,
  "perpendicularRubberBounce": 0,
  "perpendicularSandBounce": 0,
  "perpendicularSnowBounce": 0,
  "perpendicularWaterBounce": 0,
  "perpendicularWoodBounce": 0,
  "perpendicularRiotShieldBounce": 0,
  "projectileRed": 0,
  "projectileGreen": 0,
  "projectileBlue": 0,
  "guidedMissileType": "None",
  "maxSteeringAccel": 0,
  "projIgnitionDelay": 0,
  "tracerType": "",
  "enemyTracerType": "",
  "throwBackType": "",
  "reticleCenter": "",
  "reticleSide": "",
  "reticleCenterSize": 0,
  "reticleSideSize": 0,
  "reticleMinOfs": 0,
  "activeReticleType": "None",
  "adsMoveSpeedScale": 1,
  "adsSwayMaxAngle": 0,
  "adsSwayLerpSpeed": 0,
  "adsSwayPitchScale": 0,
  "adsSwayYawScale": 0,
  "adsSwayHorizScale": 0,
  "adsSwayVertScale": 0,
  "aimDownSight": 0,
  "adsViewErrorMin": 0,
  "adsViewErrorMax": 0,
  "adsFire": 0,
  "antiQuickScope": 0,
  "adsTransInTime": 0,
  "adsTransOutTime": 0,
  "adsIdleAmount": 25,
  "adsIdleSpeed": 1,
  "adsZoomFov1": 0,
  "adsZoomFov2": 0,
  "adsZoomFov3": 0,
  "adsZoomInFrac": 0,
  "adsZoomOutFrac": 0,
  "adsOverlayShader": "",
  "adsOverlayShaderLowRes": "",
  "adsOverlayReticle": "none",
  "adsOverlayInterface": "None",
  "adsOverlayWidth": 0,
  "adsOverlayHeight": 0,
  "adsOverlayAlphaScale": 0,
  "adsBobFactor": 0,
  "adsViewBobMult": 0,
  "holdBreathToSteady": 0,
  "adsAimPitch": 0,
  "adsCrosshairInFrac": 0,
  "adsCrosshairOutFrac": 0,
  "adsReloadTransTime": 0,
  "adsGunKickReducedKickBullets": 0,
  "adsGunKickReducedKickPercent": 0,
  "adsGunKickPitchMin": 0,
  "adsGunKickPitchMax": 0,
  "adsGunKickYawMin": 0,
  "adsGunKickYawMax": 0,
  "adsGunKickAccel": 0,
  "adsGunKickSpeedMax": 0,
  "adsGunKickSpeedDecay": 0,
  "adsGunKickStaticDecay": 0,
  "adsViewKickPitchMin": 0,
  "adsViewKickPitchMax": 0,
  "adsViewKickMinMagnitude": 0,
  "adsViewKickYawMin": 0,
  "adsViewKickYawMax": 0,
  "adsRecoilReductionRate": 0,
  "adsRecoilReductionLimit": 0,
  "adsRecoilReturnRate": 0,
  "adsViewKickCenterSpeed": 0,
  "adsViewKickCenterDuckedScale": 0,
  "adsViewKickCenterProneScale": 0,
  "adsSpread": 0,
  "antiQuickScopeTime": 0,
  "antiQuickScopeScale": 0,
  "antiQuickScopeSpreadMultiplier": 0,
  "antiQuickScopeSpreadMax": 0,
  "antiQuickScopeSwayFactor": 0,
  "adsDofStart": 0,
  "adsDofEnd": 0,
  "mmsWeapon": 0,
  "mmsInScope": 0,
  "mmsFOV": 0,
  "mmsAspect": 0,
  "mmsMaxDist": 0,
  "jamFireTime": 0,
  "tankLifeTime": 0,
  "fireDelay": 0,
  "spinUpTime": 0,
  "spinDownTime": 0,
  "introFireTime": 0,
  "fireTime": 0,
  "flourishTime": 0,
  "lastFireTime": 0,
  "rechamberTime": 0,
  "rechamberBoltTime": 0,
  "holdFireTime": 0,
  "burstFireDelay": 0,
  "reloadTime": 0,
  "reloadShowRocketTime": 0,
  "reloadEmptyTime": 0,
  "reloadAddTime": 0,
  "reloadEmptyAddTime": 0,
  "reloadQuickAddTime": 0,
  "reloadQuickEmptyAddTime": 0,
  "reloadStartTime": 0,
  "reloadStartAddTime": 0,
  "reloadEndTime": 0,
  "reloadQuickTime": 0,
  "reloadQuickEmptyTime": 0,
  "dropTime": 0,
  "raiseTime": 0,
  "altDropTime": 0,
  "altRaiseTime": 0,
  "quickDropTime": 0,
  "quickRaiseTime": 0,
  "firstRaiseTime": 0,
  "emptyRaiseTime": 0,
  "emptyDropTime": 0,
  "sprintInTime": 0.5,
  "sprintLoopTime": 0.5,
  "sprintOutTime": 0.5,
  "lowReadyInTime": 0,
  "lowReadyLoopTime": 0,
  "lowReadyOutTime": 0,
  "contFireInTime": 0,
  "contFireLoopTime": 0,
  "contFireOutTime": 0,
  "dtpInTime": 0,
  "dtpLoopTime": 0,
  "dtpOutTime": 0,
  "crawlInTime": 0,
  "crawlForwardTime": 0,
  "crawlBackTime": 0,
  "crawlRightTime": 0,
  "crawlLeftTime": 0,
  "crawlOutFireTime": 0,
  "crawlOutTime": 0,
  "slideInTime": 0,
  "deployTime": 0,
  "breakdownTime": 0,
  "nightVisionWearTime": 0,
  "nightVisionRemoveTime": 0,
  "pitchConvergenceTime": 0,
  "yawConvergenceTime": 0,
  "suppressionTime": 0,
  "scanPauseTime": 0,
  "altScopeADSTransInTime": 0,
  "altScopeADSTransOutTime": 0,
  "stackFireSpread": 0,
  "hipSpreadStandMin": 0,
  "hipSpreadDuckedMin": 0,
  "hipSpreadProneMin": 0,
  "hipSpreadMax": 0,
  "hipSpreadDuckedMax": 0,
  "hipSpreadProneMax": 0,
  "hipSpreadDecayRate": 0,
  "hipSpreadFireAdd": 0,
  "hipSpreadTurnAdd": 0,
  "hipSpreadMoveAdd": 0,
  "hipSpreadDuckedDecay": 0,
  "hipSpreadProneDecay": 0,
  "aiSpread": 0,
  "playerSpread": 0,
  "hipGunKickReducedKickBullets": 0,
  "hipGunKickReducedKickPercent": 0,
  "hipGunKickPitchMin": 0,
  "hipGunKickPitchMax": 0,
  "hipGunKickYawMin": 0,
  "hipGunKickYawMax": 0,
  "hipGunKickAccel": 0,
  "hipGunKickSpeedMax": 0,
  "hipGunKickSpeedDecay": 0,
  "hipGunKickStaticDecay": 0,
  "hipViewKickPitchMin": 0,
  "hipViewKickPitchMax": 0,
  "hipViewKickMinMagnitude": 0,
  "hipViewKickYawMin": 0,
  "hipViewKickYawMax": 0,
  "hipViewKickCenterSpeed": 0,
  "duckedSprintBobH": 1,
  "duckedSprintBobV": 1,
  "sprintBobH": 1,
  "sprintBobV": 1,
  "dtpBobH": 1,
  "dtpBobV": 1,
  "idleCrouchFactor": 0.5,
  "idleProneFactor": 0.15,
  "gunMaxPitch": 0,
  "gunMaxYaw": 0,
  "swayMaxAngle": 0,
  "swayLerpSpeed": 0,
  "swayPitchScale": 0,
  "swayYawScale": 0,
  "swayHorizScale": 0,
  "swayVertScale": 0,
  "swayShellShockScale": 0,
  "hipIdleAmount": 80,
  "hipIdleSpeed": 1,
  "duckedSprintOfsF": -3,
  "duckedSprintOfsR": -5,
  "duckedSprintOfsU": -5,
  "duckedSprintRotP": 0,
  "duckedSprintRotY": 0,
  "duckedSprintRotR": 0,
  "duckedSprintScale": 1,
  "moveSpeedScale": 1,
  "sprintDurationScale": 1,
  "standMoveF": 0,
  "standMoveR": 1,
  "standMoveU": -1.5,
  "standRotP": 0,
  "standRotY": 0,
  "standRotR": 0,
  "duckedOfsF": -2,
  "duckedOfsR": 2,
  "duckedOfsU": -0.2,
  "duckedMoveF": 0,
  "duckedMoveR": 1,
  "duckedMoveU": -1.5,
  "sprintOfsF": 0,
  "sprintOfsR": 0,
  "sprintOfsU": 0,
  "sprintRotP": 0,
  "sprintRotY": 0,
  "sprintRotR": 0,
  "sprintScale": 1,
  "lowReadyOfsF": 0,
  "lowReadyOfsR": 0,
  "lowReadyOfsU": 0,
  "lowReadyRotP": 0,
  "lowReadyRotY": 0,
  "lowReadyRotR": 0,
  "rideOfsF": 0,
  "rideOfsR": 0,
  "rideOfsU": 0,
  "rideRotP": 0,
  "rideRotY": 0,
  "rideRotR": 0,
  "dtpOfsF": 0,
  "dtpOfsR": 0,
  "dtpOfsU": 0,
  "dtpRotP": 0,
  "dtpRotY": 0,
  "dtpRotR": 0,
  "dtpScale": 1,
  "mantleOfsF": 0,
  "mantleOfsR": 0,
  "mantleOfsU": 0,
  "mantleRotP": 0,
  "mantleRotY": 0,
  "mantleRotR": 0,
  "slideOfsF": 0,
  "slideOfsR": 0,
  "slideOfsU": 0,
  "slideRotP": 0,
  "slideRotY": 0,
  "slideRotR": 0,
  "duckedRotP": 0,
  "duckedRotY": 0,
  "duckedRotR": 0,
  "proneOfsF": -6,
  "proneOfsR": 3.5,
  "proneOfsU": 0.8,
  "proneMoveF": 0,
  "proneMoveR": 1,
  "proneMoveU": -1.5,
  "proneRotP": 0,
  "proneRotY": 0,
  "proneRotR": 0,
  "strafeMoveF": 0,
  "strafeMoveR": 0,
  "strafeMoveU": 0,
  "strafeRotP": 0,
  "strafeRotY": 0,
  "strafeRotR": 0,
  "posMoveRate": 4,
  "posProneMoveRate": 10,
  "standMoveMinSpeed": 110,
  "duckedMoveMinSpeed": 60,
  "proneMoveMinSpeed": 0,
  "posRotRate": 5,
  "posProneRotRate": 10,
  "standRotMinSpeed": 110,
  "duckedRotMinSpeed": 60,
  "proneRotMinSpeed": 0,
  "animHorRotateInc": 0,
  "cameraShakeScale": 0,
  "ikLeftHandIdlePosF": 0,
  "ikLeftHandIdlePosR": 0,
  "ikLeftHandIdlePosU": 0,
  "ikLeftHandOffsetF": 0,
  "ikLeftHandOffsetR": 0,
  "ikLeftHandOffsetU": 0,
  "ikLeftHandRotationP": 0,
  "ikLeftHandRotationY": 0,
  "ikLeftHandRotationR": 0,
  "ikLeftHandProneOffsetF": 0,
  "ikLeftHandProneOffsetR": 0,
  "ikLeftHandProneOffsetU": 0,
  "ikLeftHandProneRotationP": 0,
  "ikLeftHandProneRotationY": 0,
  "ikLeftHandProneRotationR": 0,
  "ikLeftHandUiViewerOffsetF": 0,
  "ikLeftHandUiViewerOffsetR": 0,
  "ikLeftHandUiViewerOffsetU": 0,
  "ikLeftHandUiViewerRotationP": 0,
  "ikLeftHandUiViewerRotationY": 0,
  "ikLeftHandUiViewerRotationR": 0,
  "lockOnRadius": 0,
  "lockOnSpeed": 0,
  "requireLockonToFire": 0,
  "autoAimRange": 0,
  "aimAssistRange": 0,
  "aimAssistRangeAds": 0,
  "enemyCrosshairRange": 0,
  "crosshairColorChange": 0,
  "useAntiLagRewind": 0,
  "fightDist": 0,
  "maxDist": 0,
  "slide_in": "",
  "script": "",
  "barrelCooldownMinCount": 0,
  "viewFlashOffsetF": 0,
  "viewFlashOffsetR": 0,
  "viewFlashOffsetU": 0,
  "worldFlashOffsetF": 0,
  "worldFlashOffsetR": 0,
  "worldFlashOffsetU": 0,
  "shellCasing": "",
  "shellCasingPlayer": "",
  "standMountedWeapdef": "",
  "crouchMountedWeapdef": "",
  "proneMountedWeapdef": "",
  "viewShellEjectOffsetF": 0,
  "viewShellEjectOffsetR": 0,
  "viewShellEjectOffsetU": 0,
  "worldShellEjectOffsetF": 0,
  "worldShellEjectOffsetR": 0,
  "worldShellEjectOffsetU": 0,
  "viewShellEjectRotationP": 0,
  "viewShellEjectRotationY": 0,
  "viewShellEjectRotationR": 0,
  "worldShellEjectRotationP": 0,
  "worldShellEjectRotationY": 0,
  "worldShellEjectRotationR": 0,
  "ignoreAttachments": 0,
  "mountedModel": "",
  "coolWhileFiring": 0,
  "fuelTankWeapon": 0,
  "damage2": 0,
  "damage3": 0,
  "damage4": 0,
  "damage5": 0,
  "damageRange2": 0,
  "damageRange3": 0,
  "damageRange4": 0,
  "damageRange5": 0,
  "damageDuration": 0,
  "damageInterval": 0,
  "spinRate": 0,
  "applySpinPitch": 0,
  "introFireLength": 0,
  "nightVisionWearTimeFadeOutEnd": 0,
  "nightVisionWearTimePowerUp": 0,
  "nightVisionRemoveTimePowerDown": 0,
  "nightVisionRemoveTimeFadeInStart": 0,
  "noAdsWhenMagEmpty": 0,
  "avoidDropCleanup": 0,
  "stackFire": 0,
  "stackFireAccuracyDecay": 0,
  "mountableWeapon": 0,
  "aimPadding": 0,
  "rifleBullet": 0,
  "armorPiercing": 0,
  "boltAction": 0,
  "shotsBeforeRechamber": 0,
  "useAltTagFlash": 0,
  "isCarriedKillstreakWeapon": 0,
  "rechamberWhileAds": 0,
  "reloadWhileAds": 0,
  "canUseInVehicle": 0,
  "noDropsOrRaises": 0,
  "cancelAutoHolsterWhenEmpty": 0,
  "laserSight": 0,
  "laserSightDuringNightvision": 0,
  "bayonet": 0,
  "dualWield": 0,
  "hideThirdPerson": 0,
  "explodeOnGround": 0,
  "noThirdPersonDropsOrRaises": 0,
  "continuousFire": 0,
  "noQuickDropWhenEmpty": 0,
  "keepCrosshairWhenADS": 0,
  "useOnlyAltWeaoponHideTagsInAltMode": 0,
  "altWeaponAdsOnly": 0,
  "altWeaponDisableSwitching": 0,
  "noPartialReload": 0,
  "segmentedReload": 0,
  "noADSAutoReload": 0,
  "attachmentUnique": "",
  "DualWieldWeapon": "",
  "dropClipAmmoMin": 0,
  "dropClipAmmoMax": 0,
  "blocksProne": 0,
  "silenced": 0,
  "dualMag": 0,
  "infrared": 0,
  "tvguided": 0,
  "airburstWeapon": 0,
  "perks1": 0,
  "perks0": 0,
  "isRollingGrenade": 0,
  "useBallisticPrediction": 0,
  "isValuable": 0,
  "isTacticalInsertion": 0,
  "isReviveWeapon": 0,
  "bUseRigidBodyOnVehicle": 0,
  "timeToAccelerate": 0,
  "sentientImpactExplode": 0,
  "explodeWhenStationary": 0,
  "noCrumpleMissile": 0,
  "keepRolling": 0,
  "isCameraSensor": 0,
  "isAcousticSensor": 0,
  "isLaserSensor": 0,
  "hipReticleSidePos": 0,
  "leftArc": 0,
  "rightArc": 0,
  "topArc": 0,
  "bottomArc": 0,
  "accuracy": 0,
  "maxVertTurnSpeed": 0,
  "maxHorTurnSpeed": 0,
  "minVertTurnSpeed": 0,
  "minHorTurnSpeed": 0,
  "maxRange": 0,
  "playerPositionDist": 0,
  "useHintString": "",
  "dropHintString": "",
  "horizViewJitter": 0,
  "vertViewJitter": 0,
  "cameraShakeDuration": 0,
  "cameraShakeRadius": 0,
  "aiVsAiAccuracyGraph": "",
  "aiVsPlayerAccuracyGraph": "",
  "scanSpeed": 0,
  "scanAccel": 0,
  "flameTableFirstPerson": "",
  "flameTableThirdPerson": "",
  "usingLeftHandProneIK": 0,
  "doGibbing": 0,
  "customFloat0": 0,
  "customFloat1": 0,
  "customFloat2": 0,
  "customBool0": 0,
  "customBool1": 0,
  "customBool2": 0,
  "displayNameEnglish": "",
  "role": "SnS melee weapon (sas.gsc: giveweapon(\"knife_mp\")) used for the melee button"
 },
 "knife_held_mp": {
  "displayName": "WEAPON_KNIFE_HELD",
  "AIOverlayDescription": "",
  "modeName": "",
  "playerAnimType": "singleknife",
  "weaponType": "melee",
  "weaponClass": "melee",
  "penetrateType": "none",
  "impactType": "none",
  "inventoryType": "primary",
  "fireType": "Single Shot",
  "clipType": "bottom",
  "barrelType": "Single",
  "offhandClass": "None",
  "offhandSlot": "None",
  "fireTypeIcon": "",
  "hudIcon": "menu_mp_weapons_ballistic_knife",
  "hudIconRatio": "1:1",
  "indicatorIcon": "",
  "indicatorIconRatio": "1:1",
  "ammoCounterIcon": "menu_mp_weapons_ballistic_knife",
  "ammoCounterIconRatio": "4:1",
  "noPing": 0,
  "killIcon": "menu_mp_weapons_ballistic_knife",
  "killIconRatio": "1:1",
  "flipKillIcon": 1,
  "dpadIcon": "",
  "dpadIconRatio": "4:1",
  "noAmmoOnDpadIcon": 1,
  "altWeapon": "",
  "grenadeWeapon": "",
  "dropAmmoMin": 0,
  "dropAmmoMax": 0,
  "stance": "stand",
  "fireRumble": "defaultweapon_melee",
  "meleeImpactRumble": "",
  "reloadRumble": "",
  "explosionRumble": "",
  "parentWeaponName": "knife_held",
  "camo": "camo_knife",
  "attachments": "",
  "attachmentUniques": "",
  "gunModel": "t6_wpn_knife_base_view",
  "gunModel2": "",
  "gunModel3": "",
  "gunModel4": "",
  "gunModel5": "",
  "gunModel6": "",
  "gunModel7": "",
  "gunModel8": "",
  "gunModel9": "",
  "gunModel10": "",
  "gunModel11": "",
  "gunModel12": "",
  "gunModel13": "",
  "gunModel14": "",
  "gunModel15": "",
  "gunModel16": "",
  "handModel": "",
  "hideTags": "",
  "worldModel": "t6_wpn_knife_base_world",
  "worldModel2": "",
  "worldModel3": "",
  "worldModel4": "",
  "worldModel5": "",
  "worldModel6": "",
  "worldModel7": "",
  "worldModel8": "",
  "worldModel9": "",
  "worldModel10": "",
  "worldModel11": "",
  "worldModel12": "",
  "worldModel13": "",
  "worldModel14": "",
  "worldModel15": "",
  "worldModel16": "",
  "attachViewModel1": "",
  "attachViewModel2": "",
  "attachViewModel3": "",
  "attachViewModel4": "",
  "attachViewModel5": "",
  "attachViewModel6": "",
  "attachViewModel7": "",
  "attachViewModel8": "",
  "attachWorldModel1": "",
  "attachWorldModel2": "",
  "attachWorldModel3": "",
  "attachWorldModel4": "",
  "attachWorldModel5": "",
  "attachWorldModel6": "",
  "attachWorldModel7": "",
  "attachWorldModel8": "",
  "attachViewModelTag1": "",
  "attachViewModelTag2": "",
  "attachViewModelTag3": "",
  "attachViewModelTag4": "",
  "attachViewModelTag5": "",
  "attachViewModelTag6": "",
  "attachViewModelTag7": "",
  "attachViewModelTag8": "",
  "attachWorldModelTag1": "",
  "attachWorldModelTag2": "",
  "attachWorldModelTag3": "",
  "attachWorldModelTag4": "",
  "attachWorldModelTag5": "",
  "attachWorldModelTag6": "",
  "attachWorldModelTag7": "",
  "attachWorldModelTag8": "",
  "attachViewModelOffsetX1": 0,
  "attachViewModelOffsetY1": 0,
  "attachViewModelOffsetZ1": 0,
  "attachViewModelOffsetX2": 0,
  "attachViewModelOffsetY2": 0,
  "attachViewModelOffsetZ2": 0,
  "attachViewModelOffsetX3": 0,
  "attachViewModelOffsetY3": 0,
  "attachViewModelOffsetZ3": 0,
  "attachViewModelOffsetX4": 0,
  "attachViewModelOffsetY4": 0,
  "attachViewModelOffsetZ4": 0,
  "attachViewModelOffsetX5": 0,
  "attachViewModelOffsetY5": 0,
  "attachViewModelOffsetZ5": 0,
  "attachViewModelOffsetX6": 0,
  "attachViewModelOffsetY6": 0,
  "attachViewModelOffsetZ6": 0,
  "attachViewModelOffsetX7": 0,
  "attachViewModelOffsetY7": 0,
  "attachViewModelOffsetZ7": 0,
  "attachViewModelOffsetX8": 0,
  "attachViewModelOffsetY8": 0,
  "attachViewModelOffsetZ8": 0,
  "attachWorldModelOffsetX1": 0,
  "attachWorldModelOffsetY1": 0,
  "attachWorldModelOffsetZ1": 0,
  "attachWorldModelOffsetX2": 0,
  "attachWorldModelOffsetY2": 0,
  "attachWorldModelOffsetZ2": 0,
  "attachWorldModelOffsetX3": 0,
  "attachWorldModelOffsetY3": 0,
  "attachWorldModelOffsetZ3": 0,
  "attachWorldModelOffsetX4": 0,
  "attachWorldModelOffsetY4": 0,
  "attachWorldModelOffsetZ4": 0,
  "attachWorldModelOffsetX5": 0,
  "attachWorldModelOffsetY5": 0,
  "attachWorldModelOffsetZ5": 0,
  "attachWorldModelOffsetX6": 0,
  "attachWorldModelOffsetY6": 0,
  "attachWorldModelOffsetZ6": 0,
  "attachWorldModelOffsetX7": 0,
  "attachWorldModelOffsetY7": 0,
  "attachWorldModelOffsetZ7": 0,
  "attachWorldModelOffsetX8": 0,
  "attachWorldModelOffsetY8": 0,
  "attachWorldModelOffsetZ8": 0,
  "attachViewModelOffsetPitch1": 0,
  "attachViewModelOffsetYaw1": 0,
  "attachViewModelOffsetRoll1": 0,
  "attachViewModelOffsetPitch2": 0,
  "attachViewModelOffsetYaw2": 0,
  "attachViewModelOffsetRoll2": 0,
  "attachViewModelOffsetPitch3": 0,
  "attachViewModelOffsetYaw3": 0,
  "attachViewModelOffsetRoll3": 0,
  "attachViewModelOffsetPitch4": 0,
  "attachViewModelOffsetYaw4": 0,
  "attachViewModelOffsetRoll4": 0,
  "attachViewModelOffsetPitch5": 0,
  "attachViewModelOffsetYaw5": 0,
  "attachViewModelOffsetRoll5": 0,
  "attachViewModelOffsetPitch6": 0,
  "attachViewModelOffsetYaw6": 0,
  "attachViewModelOffsetRoll6": 0,
  "attachViewModelOffsetPitch7": 0,
  "attachViewModelOffsetYaw7": 0,
  "attachViewModelOffsetRoll7": 0,
  "attachViewModelOffsetPitch8": 0,
  "attachViewModelOffsetYaw8": 0,
  "attachViewModelOffsetRoll8": 0,
  "attachWorldModelOffsetPitch1": 0,
  "attachWorldModelOffsetYaw1": 0,
  "attachWorldModelOffsetRoll1": 0,
  "attachWorldModelOffsetPitch2": 0,
  "attachWorldModelOffsetYaw2": 0,
  "attachWorldModelOffsetRoll2": 0,
  "attachWorldModelOffsetPitch3": 0,
  "attachWorldModelOffsetYaw3": 0,
  "attachWorldModelOffsetRoll3": 0,
  "attachWorldModelOffsetPitch4": 0,
  "attachWorldModelOffsetYaw4": 0,
  "attachWorldModelOffsetRoll4": 0,
  "attachWorldModelOffsetPitch5": 0,
  "attachWorldModelOffsetYaw5": 0,
  "attachWorldModelOffsetRoll5": 0,
  "attachWorldModelOffsetPitch6": 0,
  "attachWorldModelOffsetYaw6": 0,
  "attachWorldModelOffsetRoll6": 0,
  "attachWorldModelOffsetPitch7": 0,
  "attachWorldModelOffsetYaw7": 0,
  "attachWorldModelOffsetRoll7": 0,
  "attachWorldModelOffsetPitch8": 0,
  "attachWorldModelOffsetYaw8": 0,
  "attachWorldModelOffsetRoll8": 0,
  "stowedModelOffsetsF": 0,
  "stowedModelOffsetsR": 0,
  "stowedModelOffsetsU": 0,
  "stowedModelOffsetsPitch": 0,
  "stowedModelOffsetsYaw": 0,
  "stowedModelOffsetsRoll": 0,
  "worldClipModel": "",
  "rocketModel": "",
  "AdditionalMeleeModel": "",
  "useDroppedModelAsStowed": 0,
  "projectileModel": "",
  "notetrackSoundMap": "",
  "idleAnim": "viewmodel_strider_idle",
  "idleAnimLeft": "",
  "emptyIdleAnim": "viewmodel_strider_idle",
  "emptyIdleAnimLeft": "",
  "fireIntroAnim": "",
  "fireAnim": "viewmodel_strider_melee_swipe",
  "fireAnimLeft": "",
  "holdFireAnim": "",
  "lastShotAnim": "viewmodel_strider_melee_swipe",
  "lastShotAnimLeft": "",
  "flourishAnim": "",
  "flourishAnimLeft": "",
  "detonateAnim": "",
  "rechamberAnim": "",
  "meleeAnim": "viewmodel_strider_melee_swipe",
  "meleeAnimEmpty": "",
  "meleeAnim1": "",
  "meleeAnim2": "",
  "meleeAnim3": "",
  "meleeChargeAnim": "viewmodel_strider_melee_charge",
  "meleeChargeAnimEmpty": "",
  "reloadAnim": "",
  "reloadAnimRight": "",
  "reloadAnimLeft": "",
  "reloadEmptyAnim": "",
  "reloadEmptyAnimLeft": "",
  "reloadStartAnim": "",
  "reloadEndAnim": "",
  "reloadQuickAnim": "",
  "reloadQuickEmptyAnim": "",
  "raiseAnim": "viewmodel_strider_pullout",
  "dropAnim": "viewmodel_strider_putaway",
  "firstRaiseAnim": "viewmodel_strider_first_raise",
  "altRaiseAnim": "",
  "altDropAnim": "",
  "quickRaiseAnim": "viewmodel_strider_pullout",
  "quickDropAnim": "viewmodel_strider_putaway",
  "emptyRaiseAnim": "viewmodel_strider_pullout",
  "emptyDropAnim": "viewmodel_strider_putaway",
  "sprintInAnim": "viewmodel_strider_sprint_in",
  "sprintLoopAnim": "viewmodel_strider_sprint_loop",
  "sprintOutAnim": "viewmodel_strider_sprint_out",
  "sprintInEmptyAnim": "",
  "sprintLoopEmptyAnim": "",
  "sprintOutEmptyAnim": "",
  "lowReadyInAnim": "",
  "lowReadyLoopAnim": "",
  "lowReadyOutAnim": "",
  "contFireInAnim": "",
  "contFireLoopAnim": "",
  "contFireOutAnim": "",
  "crawlInAnim": "viewmodel_strider_crawl_in",
  "crawlForwardAnim": "viewmodel_strider_crawl_forward",
  "crawlBackAnim": "viewmodel_strider_crawl_back",
  "crawlRightAnim": "viewmodel_strider_crawl_right",
  "crawlLeftAnim": "viewmodel_strider_crawl_left",
  "crawlOutAnim": "viewmodel_strider_crawl_out",
  "crawlEmptyInAnim": "",
  "crawlEmptyForwardAnim": "",
  "crawlEmptyBackAnim": "",
  "crawlEmptyRightAnim": "",
  "crawlEmptyLeftAnim": "",
  "crawlEmptyOutAnim": "",
  "deployAnim": "",
  "nightVisionWearAnim": "",
  "nightVisionRemoveAnim": "",
  "adsFireAnim": "viewmodel_strider_melee_swipe",
  "adsLastShotAnim": "viewmodel_strider_melee_swipe",
  "adsRechamberAnim": "",
  "adsUpAnim": "viewmodel_strider_ads_up",
  "adsDownAnim": "viewmodel_strider_ads_down",
  "adsUpOtherScopeAnim": "",
  "adsFireIntroAnim": "",
  "breakdownAnim": "",
  "dtp_in": "viewmodel_strider_d2p_in",
  "dtp_loop": "viewmodel_strider_d2p_loop",
  "dtp_out": "viewmodel_strider_d2p_out",
  "dtp_empty_in": "",
  "dtp_empty_loop": "",
  "dtp_empty_out": "",
  "mantleAnim": "",
  "sprintCameraAnim": "",
  "dtpInCameraAnim": "",
  "dtpLoopCameraAnim": "",
  "dtpOutCameraAnim": "",
  "mantleCameraAnim": "t5_viewmodel_camera_mantle",
  "pickupSound": "wpn_weap_pickup_npc",
  "pickupSoundPlayer": "wpn_weap_pickup_plr",
  "ammoPickupSound": "wpn_ammo_pickup_npc",
  "ammoPickupSoundPlayer": "wpn_ammo_pickup_plr",
  "projectileSound": "",
  "pullbackSound": "",
  "pullbackSoundPlayer": "",
  "fireSound": "",
  "crackSound": "",
  "whizbySound": "",
  "fireSoundPlayer": "",
  "loopFireSound": "",
  "loopFireSoundPlayer": "",
  "loopFireEndSound": "",
  "loopFireEndSoundPlayer": "",
  "startFireSound": "",
  "stopFireSound": "",
  "killcamStartFireSound": "",
  "startFireSoundPlayer": "",
  "stopFireSoundPlayer": "",
  "killcamStartFireSoundPlayer": "",
  "lastShotSound": "",
  "lastShotSoundPlayer": "",
  "emptyFireSound": "",
  "emptyFireSoundPlayer": "",
  "meleeSwipeSound": "wpn_com_knife_whoosh_npc",
  "meleeSwipeSoundPlayer": "wpn_com_knife_whoosh_plr",
  "meleeHitSound": "wpn_melee_knife_hit_body",
  "meleeMissSound": "wpn_melee_hit_other",
  "rechamberSound": "",
  "rechamberSoundPlayer": "",
  "reloadSound": "",
  "reloadSoundPlayer": "",
  "reloadEmptySound": "",
  "reloadEmptySoundPlayer": "",
  "reloadStartSound": "",
  "reloadStartSoundPlayer": "",
  "reloadEndSound": "",
  "reloadEndSoundPlayer": "",
  "rotateLoopSound": "",
  "rotateLoopSoundPlayer": "",
  "rotateStopSound": "",
  "rotateStopSoundPlayer": "",
  "deploySound": "",
  "deploySoundPlayer": "",
  "finishDeploySound": "",
  "finishDeploySoundPlayer": "",
  "breakdownSound": "",
  "breakdownSoundPlayer": "",
  "finishBreakdownSound": "",
  "finishBreakdownSoundPlayer": "",
  "detonateSound": "",
  "detonateSoundPlayer": "",
  "nightVisionWearSound": "",
  "nightVisionWearSoundPlayer": "",
  "nightVisionRemoveSound": "",
  "nightVisionRemoveSoundPlayer": "",
  "raiseSound": "",
  "raiseSoundPlayer": "",
  "firstRaiseSound": "",
  "firstRaiseSoundPlayer": "",
  "altSwitchSound": "",
  "altSwitchSoundPlayer": "",
  "adsRaiseSoundPlayer": "",
  "adsLowerSoundPlayer": "",
  "putawaySound": "",
  "putawaySoundPlayer": "",
  "overheatSound": "",
  "overheatSoundPlayer": "",
  "adsZoomSound": "",
  "bounceSound": "",
  "spinLoopSound": "",
  "spinLoopSoundPlayer": "",
  "startSpinSound": "",
  "startSpinSoundPlayer": "",
  "stopSpinSound": "",
  "stopSpinSoundPlayer": "",
  "stackSound": "",
  "projExplosionSound": "",
  "projDudSound": "",
  "mortarShellSound": "",
  "tankShellSound": "",
  "projIgnitionSound": "",
  "viewFlashEffect": "weapon/muzzleflashes/fx_pistol_flash_base",
  "worldFlashEffect": "weapon/muzzleflashes/fx_pistol_flash_base",
  "barrelCooldownEffect": "",
  "viewShellEjectEffect": "weapon/shellejects/fx_pistol",
  "worldShellEjectEffect": "weapon/shellejects/fx_pistol",
  "viewLastShotEjectEffect": "weapon/shellejects/fx_pistol",
  "worldLastShotEjectEffect": "weapon/shellejects/fx_pistol",
  "projExplosionEffect": "",
  "projExplosionEffectForceNormalUp": 0,
  "projExplosionEffect2": "",
  "projExplosionEffect2ForceNormalUp": 0,
  "projExplosionEffect3": "",
  "projExplosionEffect3ForceNormalUp": 0,
  "projExplosionEffect4": "",
  "projExplosionEffect4ForceNormalUp": 0,
  "projExplosionEffect5": "",
  "projExplosionEffect5ForceNormalUp": 0,
  "projDudEffect": "",
  "projTrailEffect": "",
  "projIgnitionEffect": "",
  "tagFx_preparationEffect": "",
  "tagFlash_preparationEffect": "",
  "meleeSwipeEffect": "",
  "meleeImpactEffect": "",
  "meleeImpactNoBloodEffect": "",
  "ammoCounterClip": "Magazine",
  "startAmmo": 0,
  "ammoDisplayName": "",
  "ammoName": "knife",
  "clipName": "knife",
  "maxAmmo": 0,
  "clipSize": 0,
  "shotCount": 1,
  "sharedAmmoCapName": "",
  "sharedAmmoCap": 0,
  "unlimitedAmmo": 1,
  "ammoCountClipRelative": 0,
  "sharedAmmo": 0,
  "overheatWeapon": 0,
  "overheatRate": 1,
  "cooldownRate": 30,
  "overheatEndVal": 25,
  "clipOnly": 0,
  "suppressAmmoReserveDisplay": 1,
  "reloadAmmoAdd": 0,
  "reloadStartAdd": 0,
  "lowAmmoWarningThreshold": 0,
  "damage": 150,
  "minDamage": 125,
  "maxDamageRange": 500,
  "minDamageRange": 600,
  "playerDamage": 150,
  "minPlayerDamage": 0,
  "destabilizationRateTime": 0,
  "destabilizationCurvatureMax": 0,
  "destabilizeDistance": 0,
  "explosionRadius": 0,
  "explosionRadiusMin": 0,
  "indicatorRadius": 0,
  "explosionInnerDamage": 0,
  "explosionOuterDamage": 0,
  "damageConeAngle": 180,
  "projExplosionType": "grenade",
  "projImpactExplode": 0,
  "bulletImpactExplode": 0,
  "explosionTag": "",
  "explosionCameraShakeScale": 0,
  "explosionCameraShakeDuration": 0,
  "explosionCameraShakeRadius": 0,
  "locNone": 1,
  "locHelmet": 1.4,
  "locHead": 1.4,
  "locNeck": 1,
  "locTorsoUpper": 1,
  "locTorsoMid": 1,
  "locTorsoLower": 1,
  "locRightArmUpper": 1,
  "locRightArmLower": 1,
  "locRightHand": 1,
  "locLeftArmUpper": 1,
  "locLeftArmLower": 1,
  "locLeftHand": 1,
  "locRightLegUpper": 1,
  "locRightLegLower": 1,
  "locRightFoot": 1,
  "locLeftLegUpper": 1,
  "locLeftLegLower": 1,
  "locLeftFoot": 1,
  "locGun": 0,
  "maxGibDistance": 1000,
  "meleeDamage": 150,
  "meleeDelay": 0.05,
  "meleeChargeDelay": 0.1,
  "meleeTime": 0.45,
  "meleeChargeTime": 1.16,
  "meleeChargeRange": 116,
  "useAsMelee": 1,
  "detonateTime": 0,
  "detonateDelay": 0,
  "fuseTime": 0,
  "aifuseTime": 0,
  "cookOffHold": 0,
  "throwBack": 0,
  "retrievable": 0,
  "dieOnRespawn": 0,
  "forceBounce": 0,
  "showIndicator": 0,
  "projectileSpeed": 0,
  "projectileSpeedRelativeUp": 0,
  "projectileSpeedUp": 0,
  "projectileSpeedForward": 0,
  "projectileTakeParentVel": 0,
  "projectileActivateDist": 0,
  "projectileLifetime": 0,
  "projectileCurvature": 0,
  "stickiness": "Don't stick",
  "rotateType": "Rotate both axis, grenade style",
  "hasDetonator": 0,
  "plantable": 0,
  "timedDetonation": 0,
  "rotate": 0,
  "holdButtonToThrow": 0,
  "offhandHoldIsCancelable": 0,
  "freezeMovementWhenFiring": 0,
  "bDisallowAtMatchStart": 0,
  "isHoldUseGrenade": 0,
  "parallelDefaultBounce": 0,
  "parallelAsphaltBounce": 0,
  "parallelBarkBounce": 0,
  "parallelBrickBounce": 0,
  "parallelCarpetBounce": 0,
  "parallelCeramicBounce": 0,
  "parallelClothBounce": 0,
  "parallelConcreteBounce": 0,
  "parallelCushionBounce": 0,
  "parallelDirtBounce": 0,
  "parallelFleshBounce": 0,
  "parallelFoliageBounce": 0,
  "parallelFruitBounce": 0,
  "parallelGlassBounce": 0,
  "parallelGrassBounce": 0,
  "parallelGravelBounce": 0,
  "parallelIceBounce": 0,
  "parallelMetalBounce": 0,
  "parallelMudBounce": 0,
  "parallelPaintedMetalBounce": 0,
  "parallelPaperBounce": 0,
  "parallelPlasterBounce": 0,
  "parallelPlasticBounce": 0,
  "parallelRockBounce": 0,
  "parallelRubberBounce": 0,
  "parallelSandBounce": 0,
  "parallelSnowBounce": 0,
  "parallelWaterBounce": 0,
  "parallelWoodBounce": 0,
  "parallelRiotShieldBounce": 0,
  "perpendicularDefaultBounce": 0,
  "perpendicularAsphaltBounce": 0,
  "perpendicularBarkBounce": 0,
  "perpendicularBrickBounce": 0,
  "perpendicularCarpetBounce": 0,
  "perpendicularCeramicBounce": 0,
  "perpendicularClothBounce": 0,
  "perpendicularConcreteBounce": 0,
  "perpendicularCushionBounce": 0,
  "perpendicularDirtBounce": 0,
  "perpendicularFleshBounce": 0,
  "perpendicularFoliageBounce": 0,
  "perpendicularFruitBounce": 0,
  "perpendicularGlassBounce": 0,
  "perpendicularGrassBounce": 0,
  "perpendicularGravelBounce": 0,
  "perpendicularIceBounce": 0,
  "perpendicularMetalBounce": 0,
  "perpendicularMudBounce": 0,
  "perpendicularPaintedMetalBounce": 0,
  "perpendicularPaperBounce": 0,
  "perpendicularPlasterBounce": 0,
  "perpendicularPlasticBounce": 0,
  "perpendicularRockBounce": 0,
  "perpendicularRubberBounce": 0,
  "perpendicularSandBounce": 0,
  "perpendicularSnowBounce": 0,
  "perpendicularWaterBounce": 0,
  "perpendicularWoodBounce": 0,
  "perpendicularRiotShieldBounce": 0,
  "projectileRed": 0,
  "projectileGreen": 0,
  "projectileBlue": 0,
  "guidedMissileType": "None",
  "maxSteeringAccel": 0,
  "projIgnitionDelay": 0,
  "tracerType": "",
  "enemyTracerType": "",
  "throwBackType": "",
  "reticleCenter": "",
  "reticleSide": "",
  "reticleCenterSize": 4,
  "reticleSideSize": 8,
  "reticleMinOfs": 0,
  "activeReticleType": "None",
  "adsMoveSpeedScale": 2,
  "adsSwayMaxAngle": 2,
  "adsSwayLerpSpeed": 4,
  "adsSwayPitchScale": 0.1,
  "adsSwayYawScale": 0.1,
  "adsSwayHorizScale": 0.12,
  "adsSwayVertScale": 0.2,
  "aimDownSight": 0,
  "adsViewErrorMin": 0,
  "adsViewErrorMax": 0,
  "adsFire": 0,
  "antiQuickScope": 0,
  "adsTransInTime": 0.15,
  "adsTransOutTime": 0.15,
  "adsIdleAmount": 28,
  "adsIdleSpeed": 1,
  "adsZoomFov1": 65,
  "adsZoomFov2": 65,
  "adsZoomFov3": 65,
  "adsZoomInFrac": 0.42,
  "adsZoomOutFrac": 0.08,
  "adsOverlayShader": "",
  "adsOverlayShaderLowRes": "",
  "adsOverlayReticle": "none",
  "adsOverlayInterface": "None",
  "adsOverlayWidth": 220,
  "adsOverlayHeight": 220,
  "adsOverlayAlphaScale": 1,
  "adsBobFactor": 0.7,
  "adsViewBobMult": 0.2,
  "holdBreathToSteady": 0,
  "adsAimPitch": 0,
  "adsCrosshairInFrac": 1,
  "adsCrosshairOutFrac": 0.2,
  "adsReloadTransTime": 0.15,
  "adsGunKickReducedKickBullets": 0,
  "adsGunKickReducedKickPercent": 0,
  "adsGunKickPitchMin": -25,
  "adsGunKickPitchMax": 25,
  "adsGunKickYawMin": -25,
  "adsGunKickYawMax": 50,
  "adsGunKickAccel": 500,
  "adsGunKickSpeedMax": 1500,
  "adsGunKickSpeedDecay": 25,
  "adsGunKickStaticDecay": 50,
  "adsViewKickPitchMin": 25,
  "adsViewKickPitchMax": 45,
  "adsViewKickMinMagnitude": 30,
  "adsViewKickYawMin": 35,
  "adsViewKickYawMax": -35,
  "adsRecoilReductionRate": 0,
  "adsRecoilReductionLimit": 0,
  "adsRecoilReturnRate": 1,
  "adsViewKickCenterSpeed": 1100,
  "adsViewKickCenterDuckedScale": 1,
  "adsViewKickCenterProneScale": 1,
  "adsSpread": 0,
  "antiQuickScopeTime": 0.15,
  "antiQuickScopeScale": 8,
  "antiQuickScopeSpreadMultiplier": 1,
  "antiQuickScopeSpreadMax": 25,
  "antiQuickScopeSwayFactor": 20,
  "adsDofStart": 5,
  "adsDofEnd": 11.6,
  "mmsWeapon": 0,
  "mmsInScope": 0,
  "mmsFOV": 25,
  "mmsAspect": 1,
  "mmsMaxDist": 1200,
  "jamFireTime": 0.05,
  "tankLifeTime": 0,
  "fireDelay": 0,
  "spinUpTime": 1,
  "spinDownTime": 1,
  "introFireTime": 0.1,
  "fireTime": 0.048,
  "flourishTime": 0.048,
  "lastFireTime": 0,
  "rechamberTime": 0,
  "rechamberBoltTime": 0,
  "holdFireTime": 0.1,
  "burstFireDelay": 0,
  "reloadTime": 0.5,
  "reloadShowRocketTime": 0,
  "reloadEmptyTime": 0.5,
  "reloadAddTime": 0.5,
  "reloadEmptyAddTime": 0.5,
  "reloadQuickAddTime": 0,
  "reloadQuickEmptyAddTime": 0,
  "reloadStartTime": 0,
  "reloadStartAddTime": 0,
  "reloadEndTime": 0,
  "reloadQuickTime": 0,
  "reloadQuickEmptyTime": 0,
  "dropTime": 0.35,
  "raiseTime": 0.5,
  "altDropTime": 0,
  "altRaiseTime": 0,
  "quickDropTime": 0.25,
  "quickRaiseTime": 0.3,
  "firstRaiseTime": 1,
  "emptyRaiseTime": 0.25,
  "emptyDropTime": 0.45,
  "sprintInTime": 0.3,
  "sprintLoopTime": 0.6,
  "sprintOutTime": 0.3,
  "lowReadyInTime": 0.5,
  "lowReadyLoopTime": 0.5,
  "lowReadyOutTime": 0.5,
  "contFireInTime": 0.5,
  "contFireLoopTime": 0.5,
  "contFireOutTime": 0.5,
  "dtpInTime": 0.18,
  "dtpLoopTime": 0.6,
  "dtpOutTime": 0.25,
  "crawlInTime": 0.1,
  "crawlForwardTime": 1.1,
  "crawlBackTime": 1,
  "crawlRightTime": 1.2,
  "crawlLeftTime": 1.1,
  "crawlOutFireTime": 0.048,
  "crawlOutTime": 0.1,
  "slideInTime": 0.5,
  "deployTime": 0.5,
  "breakdownTime": 0.5,
  "nightVisionWearTime": 0,
  "nightVisionRemoveTime": 0,
  "pitchConvergenceTime": 0,
  "yawConvergenceTime": 0,
  "suppressionTime": 0,
  "scanPauseTime": 0,
  "altScopeADSTransInTime": 0,
  "altScopeADSTransOutTime": 0,
  "stackFireSpread": 0,
  "hipSpreadStandMin": 3,
  "hipSpreadDuckedMin": 2.5,
  "hipSpreadProneMin": 2,
  "hipSpreadMax": 6,
  "hipSpreadDuckedMax": 5,
  "hipSpreadProneMax": 4,
  "hipSpreadDecayRate": 4,
  "hipSpreadFireAdd": 1,
  "hipSpreadTurnAdd": 0,
  "hipSpreadMoveAdd": 4.5,
  "hipSpreadDuckedDecay": 1,
  "hipSpreadProneDecay": 1,
  "aiSpread": 0,
  "playerSpread": 0,
  "hipGunKickReducedKickBullets": 0,
  "hipGunKickReducedKickPercent": 0,
  "hipGunKickPitchMin": 0,
  "hipGunKickPitchMax": 0,
  "hipGunKickYawMin": 0,
  "hipGunKickYawMax": 0,
  "hipGunKickAccel": 1000,
  "hipGunKickSpeedMax": 1200,
  "hipGunKickSpeedDecay": 100,
  "hipGunKickStaticDecay": 2,
  "hipViewKickPitchMin": 25,
  "hipViewKickPitchMax": 45,
  "hipViewKickMinMagnitude": 30,
  "hipViewKickYawMin": 35,
  "hipViewKickYawMax": -35,
  "hipViewKickCenterSpeed": 1100,
  "duckedSprintBobH": 0,
  "duckedSprintBobV": 0,
  "sprintBobH": 1,
  "sprintBobV": 1,
  "dtpBobH": 1,
  "dtpBobV": 1,
  "idleCrouchFactor": 0.8,
  "idleProneFactor": 0.6,
  "gunMaxPitch": 2,
  "gunMaxYaw": 8,
  "swayMaxAngle": 4,
  "swayLerpSpeed": 4,
  "swayPitchScale": -1,
  "swayYawScale": -1,
  "swayHorizScale": 0.3,
  "swayVertScale": 0.3,
  "swayShellShockScale": 5,
  "hipIdleAmount": 25,
  "hipIdleSpeed": 8,
  "duckedSprintOfsF": 0,
  "duckedSprintOfsR": 0,
  "duckedSprintOfsU": 0,
  "duckedSprintRotP": 0,
  "duckedSprintRotY": 0,
  "duckedSprintRotR": 0,
  "duckedSprintScale": 0,
  "moveSpeedScale": 1.02,
  "sprintDurationScale": 1.5,
  "standMoveF": 0,
  "standMoveR": 0,
  "standMoveU": 0,
  "standRotP": 2,
  "standRotY": 0,
  "standRotR": -2,
  "duckedOfsF": -0.8,
  "duckedOfsR": 0.5,
  "duckedOfsU": -0.5,
  "duckedMoveF": 0,
  "duckedMoveR": 0,
  "duckedMoveU": 0,
  "sprintOfsF": 0,
  "sprintOfsR": 0,
  "sprintOfsU": 0,
  "sprintRotP": 0,
  "sprintRotY": 0,
  "sprintRotR": 0,
  "sprintScale": 1,
  "lowReadyOfsF": 0,
  "lowReadyOfsR": 0,
  "lowReadyOfsU": 0,
  "lowReadyRotP": 0,
  "lowReadyRotY": 0,
  "lowReadyRotR": 0,
  "rideOfsF": 0,
  "rideOfsR": 0,
  "rideOfsU": 0,
  "rideRotP": 0,
  "rideRotY": 0,
  "rideRotR": 0,
  "dtpOfsF": 0,
  "dtpOfsR": 0,
  "dtpOfsU": 0,
  "dtpRotP": 0,
  "dtpRotY": 0,
  "dtpRotR": 0,
  "dtpScale": 1,
  "mantleOfsF": -2,
  "mantleOfsR": -3,
  "mantleOfsU": 3,
  "mantleRotP": 0,
  "mantleRotY": 0,
  "mantleRotR": -5,
  "slideOfsF": 0,
  "slideOfsR": 0,
  "slideOfsU": 0,
  "slideRotP": 0,
  "slideRotY": 0,
  "slideRotR": 0,
  "duckedRotP": 2,
  "duckedRotY": 0,
  "duckedRotR": -2,
  "proneOfsF": 1,
  "proneOfsR": 0,
  "proneOfsU": -1,
  "proneMoveF": 0,
  "proneMoveR": 0,
  "proneMoveU": 0,
  "proneRotP": 0,
  "proneRotY": 2,
  "proneRotR": -3,
  "strafeMoveF": 0,
  "strafeMoveR": 0.5,
  "strafeMoveU": 0,
  "strafeRotP": 0,
  "strafeRotY": 0,
  "strafeRotR": 3,
  "posMoveRate": 5,
  "posProneMoveRate": 25,
  "standMoveMinSpeed": 0,
  "duckedMoveMinSpeed": 0,
  "proneMoveMinSpeed": 0,
  "posRotRate": 6,
  "posProneRotRate": 30,
  "standRotMinSpeed": 0,
  "duckedRotMinSpeed": 0,
  "proneRotMinSpeed": 0,
  "animHorRotateInc": 0,
  "cameraShakeScale": 0,
  "ikLeftHandIdlePosF": 0,
  "ikLeftHandIdlePosR": 0,
  "ikLeftHandIdlePosU": 0,
  "ikLeftHandOffsetF": 0,
  "ikLeftHandOffsetR": 0,
  "ikLeftHandOffsetU": 0,
  "ikLeftHandRotationP": 0,
  "ikLeftHandRotationY": 0,
  "ikLeftHandRotationR": 0,
  "ikLeftHandProneOffsetF": 0,
  "ikLeftHandProneOffsetR": 0,
  "ikLeftHandProneOffsetU": 0,
  "ikLeftHandProneRotationP": 0,
  "ikLeftHandProneRotationY": 0,
  "ikLeftHandProneRotationR": 0,
  "ikLeftHandUiViewerOffsetF": 0,
  "ikLeftHandUiViewerOffsetR": 0,
  "ikLeftHandUiViewerOffsetU": 0,
  "ikLeftHandUiViewerRotationP": 0,
  "ikLeftHandUiViewerRotationY": 0,
  "ikLeftHandUiViewerRotationR": 0,
  "lockOnRadius": 0,
  "lockOnSpeed": 0,
  "requireLockonToFire": 0,
  "autoAimRange": 0,
  "aimAssistRange": 600,
  "aimAssistRangeAds": 600,
  "enemyCrosshairRange": 600,
  "crosshairColorChange": 1,
  "useAntiLagRewind": 0,
  "fightDist": 720,
  "maxDist": 250,
  "slide_in": "",
  "script": "",
  "barrelCooldownMinCount": 0,
  "viewFlashOffsetF": 0,
  "viewFlashOffsetR": 0,
  "viewFlashOffsetU": 0,
  "worldFlashOffsetF": 0,
  "worldFlashOffsetR": 0,
  "worldFlashOffsetU": 0,
  "shellCasing": "",
  "shellCasingPlayer": "",
  "standMountedWeapdef": "",
  "crouchMountedWeapdef": "",
  "proneMountedWeapdef": "",
  "viewShellEjectOffsetF": 0,
  "viewShellEjectOffsetR": 0,
  "viewShellEjectOffsetU": 0,
  "worldShellEjectOffsetF": 0,
  "worldShellEjectOffsetR": 0,
  "worldShellEjectOffsetU": 0,
  "viewShellEjectRotationP": 0,
  "viewShellEjectRotationY": 0,
  "viewShellEjectRotationR": 0,
  "worldShellEjectRotationP": 0,
  "worldShellEjectRotationY": 0,
  "worldShellEjectRotationR": 0,
  "ignoreAttachments": 0,
  "mountedModel": "",
  "coolWhileFiring": 0,
  "fuelTankWeapon": 0,
  "damage2": 0,
  "damage3": 0,
  "damage4": 0,
  "damage5": 0,
  "damageRange2": 0,
  "damageRange3": 0,
  "damageRange4": 0,
  "damageRange5": 0,
  "damageDuration": 0,
  "damageInterval": 0,
  "spinRate": 1,
  "applySpinPitch": 1,
  "introFireLength": 0,
  "nightVisionWearTimeFadeOutEnd": 0,
  "nightVisionWearTimePowerUp": 0,
  "nightVisionRemoveTimePowerDown": 0,
  "nightVisionRemoveTimeFadeInStart": 0,
  "noAdsWhenMagEmpty": 0,
  "avoidDropCleanup": 0,
  "stackFire": 0,
  "stackFireAccuracyDecay": 0,
  "mountableWeapon": 0,
  "aimPadding": 0,
  "rifleBullet": 0,
  "armorPiercing": 0,
  "boltAction": 0,
  "shotsBeforeRechamber": 0,
  "useAltTagFlash": 0,
  "isCarriedKillstreakWeapon": 0,
  "rechamberWhileAds": 0,
  "reloadWhileAds": 0,
  "canUseInVehicle": 0,
  "noDropsOrRaises": 0,
  "cancelAutoHolsterWhenEmpty": 0,
  "laserSight": 0,
  "laserSightDuringNightvision": 0,
  "bayonet": 0,
  "dualWield": 0,
  "hideThirdPerson": 0,
  "explodeOnGround": 0,
  "noThirdPersonDropsOrRaises": 0,
  "continuousFire": 0,
  "noQuickDropWhenEmpty": 1,
  "keepCrosshairWhenADS": 0,
  "useOnlyAltWeaoponHideTagsInAltMode": 0,
  "altWeaponAdsOnly": 0,
  "altWeaponDisableSwitching": 0,
  "noPartialReload": 0,
  "segmentedReload": 0,
  "noADSAutoReload": 0,
  "attachmentUnique": "",
  "DualWieldWeapon": "",
  "dropClipAmmoMin": 0,
  "dropClipAmmoMax": 0,
  "blocksProne": 0,
  "silenced": 0,
  "dualMag": 0,
  "infrared": 0,
  "tvguided": 0,
  "airburstWeapon": 0,
  "perks1": 0,
  "perks0": 0,
  "isRollingGrenade": 0,
  "useBallisticPrediction": 0,
  "isValuable": 0,
  "isTacticalInsertion": 0,
  "isReviveWeapon": 0,
  "bUseRigidBodyOnVehicle": 0,
  "timeToAccelerate": 0,
  "sentientImpactExplode": 0,
  "explodeWhenStationary": 0,
  "noCrumpleMissile": 0,
  "keepRolling": 0,
  "isCameraSensor": 0,
  "isAcousticSensor": 0,
  "isLaserSensor": 0,
  "hipReticleSidePos": 0,
  "leftArc": 0,
  "rightArc": 0,
  "topArc": 0,
  "bottomArc": 0,
  "accuracy": 0,
  "maxVertTurnSpeed": 0,
  "maxHorTurnSpeed": 0,
  "minVertTurnSpeed": 0,
  "minHorTurnSpeed": 0,
  "maxRange": 0,
  "playerPositionDist": 0,
  "useHintString": "",
  "dropHintString": "",
  "horizViewJitter": 0,
  "vertViewJitter": 0,
  "cameraShakeDuration": 0,
  "cameraShakeRadius": 0,
  "aiVsAiAccuracyGraph": "",
  "aiVsPlayerAccuracyGraph": "",
  "scanSpeed": 0,
  "scanAccel": 0,
  "flameTableFirstPerson": "",
  "flameTableThirdPerson": "",
  "usingLeftHandProneIK": 0,
  "doGibbing": 0,
  "customFloat0": 0,
  "customFloat1": 0,
  "customFloat2": 0,
  "customBool0": 0,
  "customBool1": 0,
  "customBool2": 0,
  "displayNameEnglish": "Combat Knife",
  "role": "Combat Knife primary (NOT in the SnS loadout; reference only, it holds the strider viewmodel anims)"
 }
};

export const SAS_LOADOUT = {
 "source": "extracted/mp/patch_mp/maps/mp/gametypes/sas.gsc (compiled) == tools/src/t6-scripts/MP/Core/maps/mp/gametypes/sas.gsc givecustomloadout()",
 "primary": {
  "weapon": "crossbow_mp",
  "clip": 3,
  "stock": 3,
  "spawnWeapon": true
 },
 "secondary": {
  "weapon": "knife_ballistic_mp",
  "clip": "default (startAmmo fill, ESTIMATE: 1 = clipSize)",
  "stock": 2
 },
 "lethal": {
  "weapon": "hatchet_mp",
  "offhandPrimaryClass": true,
  "clip": 1,
  "stock": 1
 },
 "melee": {
  "weapon": "knife_mp"
 },
 "perks": "clearperks() in _wager.gsc setupblankrandomplayer -> no perks",
 "bodyModel": "set_player_model(team, \"crossbow_mp\") -> statstable group weapon_special -> bodytype \"default\" (assault body)"
} as const;
